export const CertificateData = 
[
  {
    "name": "Aftab Ahmed",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130202,
    "batch": 1
  },
  {
    "name": "Gul Muhammad",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130203,
    "batch": 1
  },
  {
    "name": "Khalid Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130204,
    "batch": 1
  },
  {
    "name": "Shoukat Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130205,
    "batch": 1
  },
  {
    "name": "Zafar Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130206,
    "batch": 1
  },
  {
    "name": "Zameer Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130207,
    "batch": 1
  },
  {
    "name": "Abdul Haleem",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120201,
    "batch": 1
  },
  {
    "name": "Abdul Haseeb",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120202,
    "batch": 1
  },
  {
    "name": "Abdul Qadeer",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120203,
    "batch": 1
  },
  {
    "name": "Abdul Rashed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120204,
    "batch": 1
  },
  {
    "name": "Afzal Ali",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120205,
    "batch": 1
  },
  {
    "name": "Akash Abro",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120206,
    "batch": 1
  },
  {
    "name": "Amaz Anwar",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120207,
    "batch": 1
  },
  {
    "name": "Arif Nawaz",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120208,
    "batch": 1
  },
  {
    "name": "Arslan Khan",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120209,
    "batch": 1
  },
  {
    "name": "Arslan Khan",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120210,
    "batch": 1
  },
  {
    "name": "Asif Bhutto",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120211,
    "batch": 1
  },
  {
    "name": "Athar Ali",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120212,
    "batch": 1
  },
  {
    "name": "Atta Muhammad",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120213,
    "batch": 1
  },
  {
    "name": "Awais Gul",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120214,
    "batch": 1
  },
  {
    "name": "Barkat Ali",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120215,
    "batch": 1
  },
  {
    "name": "Irshad Ali",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120216,
    "batch": 1
  },
  {
    "name": "Mehtab Ahmed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120217,
    "batch": 1
  },
  {
    "name": "Muhammad Bux",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120218,
    "batch": 1
  },
  {
    "name": "Muhammad Hanan",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120219,
    "batch": 1
  },
  {
    "name": "Muhammad Hanzala",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120220,
    "batch": 1
  },
  {
    "name": "Muhammad Saleem",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120221,
    "batch": 1
  },
  {
    "name": "Saeed Ahmed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120222,
    "batch": 1
  },
  {
    "name": "Saifullah",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120223,
    "batch": 1
  },
  {
    "name": "Shafique Ahmed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120224,
    "batch": 1
  },
  {
    "name": "Shahzaib",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120225,
    "batch": 1
  },
  {
    "name": "Sibghatullah",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120226,
    "batch": 1
  },
  {
    "name": "Sohail Ahmed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120227,
    "batch": 1
  },
  {
    "name": "Sumeet Kumar",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120228,
    "batch": 1
  },
  {
    "name": "Zafaruddin",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120229,
    "batch": 1
  },
  {
    "name": "Zeeshan Ahmed",
    "course": "Certified Digital Marketing",
    "center": "AROR University",
    "certificate_id": 120230,
    "batch": 1
  },
  {
    "name": "Aashish Kumar",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120301,
    "batch": 1
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120302,
    "batch": 1
  },
  {
    "name": "Abdul Majeed",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120303,
    "batch": 1
  },
  {
    "name": "Abdul Mudasir",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120304,
    "batch": 1
  },
  {
    "name": "Abdul Wahab",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120305,
    "batch": 1
  },
  {
    "name": "Agha Abdul Majeed",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120306,
    "batch": 1
  },
  {
    "name": "Aitzaz Chohan",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120307,
    "batch": 1
  },
  {
    "name": "Ali Gul",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120308,
    "batch": 1
  },
  {
    "name": "Ali Hamza Brohi",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120309,
    "batch": 1
  },
  {
    "name": "Ali Raza Keeryo",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120310,
    "batch": 1
  },
  {
    "name": "Allah Wasayo",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120311,
    "batch": 1
  },
  {
    "name": "Aqsa Channa",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120312,
    "batch": 1
  },
  {
    "name": "Asad Ali",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120313,
    "batch": 1
  },
  {
    "name": "Ashfaque Hussain",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120314,
    "batch": 1
  },
  {
    "name": "Atif Ali",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120315,
    "batch": 1
  },
  {
    "name": "Awais Gul",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120316,
    "batch": 1
  },
  {
    "name": "Bahawal Khan",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120317,
    "batch": 1
  },
  {
    "name": "Bilal Ahmed",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120318,
    "batch": 1
  },
  {
    "name": "Farooque",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120319,
    "batch": 1
  },
  {
    "name": "Hallar",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120320,
    "batch": 1
  },
  {
    "name": "Hamadullah Mazari",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120321,
    "batch": 1
  },
  {
    "name": "Hyder Ali",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120322,
    "batch": 1
  },
  {
    "name": "Iftikhar Ahmed",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120323,
    "batch": 1
  },
  {
    "name": "Iqra Bhutto",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120324,
    "batch": 1
  },
  {
    "name": "Kashmir",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120325,
    "batch": 1
  },
  {
    "name": "Makhan",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120326,
    "batch": 1
  },
  {
    "name": "Mehtab Ahmed",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120327,
    "batch": 1
  },
  {
    "name": "Mir Hasnain Raza",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120328,
    "batch": 1
  },
  {
    "name": "Mir Talib Hussain",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120329,
    "batch": 1
  },
  {
    "name": "Muhammad Abuzer",
    "course": "Certified Graphic Designer",
    "center": "AROR University",
    "certificate_id": 120330,
    "batch": 1
  },
  {
    "name": "Aakash Hyder",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130101,
    "batch": 1
  },
  {
    "name": "Abdul Sami",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130102,
    "batch": 1
  },
  {
    "name": "Ali Waris",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130103,
    "batch": 1
  },
  {
    "name": "Awais Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130104,
    "batch": 1
  },
  {
    "name": "Ayaz Muhammad",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130105,
    "batch": 1
  },
  {
    "name": "Faraz Ali Shah",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130106,
    "batch": 1
  },
  {
    "name": "Gada Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130107,
    "batch": 1
  },
  {
    "name": "Hassan Raza Shah",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130108,
    "batch": 1
  },
  {
    "name": "Jameel Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130109,
    "batch": 1
  },
  {
    "name": "Khizar Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130110,
    "batch": 1
  },
  {
    "name": "Mohammad Hatif",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130111,
    "batch": 1
  },
  {
    "name": "Muhammad Umar",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130112,
    "batch": 1
  },
  {
    "name": "Muqadas Mehdi",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130113,
    "batch": 1
  },
  {
    "name": "Saifal Khan",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130114,
    "batch": 1
  },
  {
    "name": "Sajjad Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130115,
    "batch": 1
  },
  {
    "name": "Shuaib Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130116,
    "batch": 1
  },
  {
    "name": "Syed Bakhsh Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130117,
    "batch": 1
  },
  {
    "name": "Syed Farman Ali Shah",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130118,
    "batch": 1
  },
  {
    "name": "Tanveer Ahmed",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130119,
    "batch": 1
  },
  {
    "name": "Tanveer Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130120,
    "batch": 1
  },
  {
    "name": "Waheed",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130121,
    "batch": 1
  },
  {
    "name": "Waseem Gul",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130122,
    "batch": 1
  },
  {
    "name": "Zulqurnain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130123,
    "batch": 1
  },
  {
    "name": "Aashan Aslam",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110241,
    "batch": 1
  },
  {
    "name": "Abdul Basit",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110201,
    "batch": 1
  },
  {
    "name": "Abdul Ghani",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110202,
    "batch": 1
  },
  {
    "name": "Abdul Musavir",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110203,
    "batch": 1
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110204,
    "batch": 1
  },
  {
    "name": "Abdul Wajid",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110205,
    "batch": 1
  },
  {
    "name": "Adeel Ahmed",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110206,
    "batch": 1
  },
  {
    "name": "Afia",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110207,
    "batch": 1
  },
  {
    "name": "Ali Raza Solangi",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110209,
    "batch": 1
  },
  {
    "name": "Alishba",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110210,
    "batch": 1
  },
  {
    "name": "Alishba Rajput",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110211,
    "batch": 1
  },
  {
    "name": "Aliza Ansari",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110242,
    "batch": 1
  },
  {
    "name": "Aliza Riaz",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110212,
    "batch": 1
  },
  {
    "name": "Aqsa Bibi",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110213,
    "batch": 1
  },
  {
    "name": "Areesha Irfan",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110243,
    "batch": 1
  },
  {
    "name": "Ayesha Noor",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110214,
    "batch": 1
  },
  {
    "name": "Dost Muhammad",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110215,
    "batch": 1
  },
  {
    "name": "Faizan Ali",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110216,
    "batch": 1
  },
  {
    "name": "Fariha Hassan",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110217,
    "batch": 1
  },
  {
    "name": "Insha Shaikh",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110247,
    "batch": 1
  },
  {
    "name": "Lareb Hassan",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110218,
    "batch": 1
  },
  {
    "name": "Mehak Ali",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110219,
    "batch": 1
  },
  {
    "name": "Mir Aryan Riaz",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110220,
    "batch": 1
  },
  {
    "name": "Mudasir Hussain",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110221,
    "batch": 1
  },
  {
    "name": "Muhammad Ahsan",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110222,
    "batch": 1
  },
  {
    "name": "Muhammad Hamza",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110244,
    "batch": 1
  },
  {
    "name": "Muhammad Haseeb Zafar",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110245,
    "batch": 1
  },
  {
    "name": "Muhammad Hassan",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110223,
    "batch": 1
  },
  {
    "name": "Muhammad Rehan Tasneem",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110224,
    "batch": 1
  },
  {
    "name": "Muhammad Yousif",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110248,
    "batch": 1
  },
  {
    "name": "Muhammads Saqib",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110225,
    "batch": 1
  },
  {
    "name": "Muhammed Uffaif",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110226,
    "batch": 1
  },
  {
    "name": "Muskan Mariyam",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110227,
    "batch": 1
  },
  {
    "name": "Naeem Ahmed",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110228,
    "batch": 1
  },
  {
    "name": "Sadam Hussain",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110229,
    "batch": 1
  },
  {
    "name": "Saqib Javed Shahzad",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110230,
    "batch": 1
  },
  {
    "name": "Shahnaz",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110231,
    "batch": 1
  },
  {
    "name": "Simirti",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110232,
    "batch": 1
  },
  {
    "name": "Summaiya Shaikh",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110233,
    "batch": 1
  },
  {
    "name": "Syed Aftab Hyder",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110234,
    "batch": 1
  },
  {
    "name": "Tahira Hakeem",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110235,
    "batch": 1
  },
  {
    "name": "Unsa",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110236,
    "batch": 1
  },
  {
    "name": "Wajiha",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110237,
    "batch": 1
  },
  {
    "name": "Wakeel Ahmed",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110238,
    "batch": 1
  },
  {
    "name": "Waqar",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110239,
    "batch": 1
  },
  {
    "name": "Zahra Fatima",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110246,
    "batch": 1
  },
  {
    "name": "Zohair Ahmed",
    "course": "Certified Digital Marketing",
    "center": "Sukkur IBA University",
    "certificate_id": 110240,
    "batch": 1
  },
  {
    "name": "Abbas Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110341,
    "batch": 1
  },
  {
    "name": "Abdul Kalam",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110343,
    "batch": 1
  },
  {
    "name": "Abdul Qadeer",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110344,
    "batch": 1
  },
  {
    "name": "Abdul Quddus",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110345,
    "batch": 1
  },
  {
    "name": "Abdul Raoof",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110346,
    "batch": 1
  },
  {
    "name": "Abdul Samad Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110394,
    "batch": 1
  },
  {
    "name": "Abeeha Batool",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110391,
    "batch": 1
  },
  {
    "name": "Afsana",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110301,
    "batch": 1
  },
  {
    "name": "Ali Raza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110381,
    "batch": 1
  },
  {
    "name": "Aliza Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110302,
    "batch": 1
  },
  {
    "name": "Amar Shiva",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110395,
    "batch": 1
  },
  {
    "name": "Amber Ali Bhatti",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110347,
    "batch": 1
  },
  {
    "name": "Amber Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110303,
    "batch": 1
  },
  {
    "name": "Anmol",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110382,
    "batch": 1
  },
  {
    "name": "Anosha",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110349,
    "batch": 1
  },
  {
    "name": "Aqsa Bhayo",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110304,
    "batch": 1
  },
  {
    "name": "Areeba Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110305,
    "batch": 1
  },
  {
    "name": "Aroon Kanjwani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110392,
    "batch": 1
  },
  {
    "name": "Aruba Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110307,
    "batch": 1
  },
  {
    "name": "Asif Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110350,
    "batch": 1
  },
  {
    "name": "Asra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110308,
    "batch": 1
  },
  {
    "name": "Azaf Hussain",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110351,
    "batch": 1
  },
  {
    "name": "Bibi Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110310,
    "batch": 1
  },
  {
    "name": "Bisma",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110383,
    "batch": 1
  },
  {
    "name": "Fardeen Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110312,
    "batch": 1
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110352,
    "batch": 1
  },
  {
    "name": "Fazila",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110384,
    "batch": 1
  },
  {
    "name": "Fida Hussain",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110353,
    "batch": 1
  },
  {
    "name": "Ghulam Hyder",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110398,
    "batch": 1
  },
  {
    "name": "Hassan Raza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110354,
    "batch": 1
  },
  {
    "name": "Hifza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110313,
    "batch": 1
  },
  {
    "name": "Ibrahim",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110355,
    "batch": 1
  },
  {
    "name": "Imran Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110356,
    "batch": 1
  },
  {
    "name": "Inamullah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110314,
    "batch": 1
  },
  {
    "name": "Iqra Abdul Sattar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110315,
    "batch": 1
  },
  {
    "name": "Iqra Bhatti",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110357,
    "batch": 1
  },
  {
    "name": "Iqra Ubaidullah Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110316,
    "batch": 1
  },
  {
    "name": "Kashish",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110317,
    "batch": 1
  },
  {
    "name": "Kinza Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110318,
    "batch": 1
  },
  {
    "name": "Lareb",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110319,
    "batch": 1
  },
  {
    "name": "Maheen",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110320,
    "batch": 1
  },
  {
    "name": "Marvi Memon",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110385,
    "batch": 1
  },
  {
    "name": "Mehak Abdul Ghafoor",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110359,
    "batch": 1
  },
  {
    "name": "Mehak Rajib Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110360,
    "batch": 1
  },
  {
    "name": "Misbah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110362,
    "batch": 1
  },
  {
    "name": "Muhammad Hamza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110321,
    "batch": 1
  },
  {
    "name": "Muhammad Hunaiz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110322,
    "batch": 1
  },
  {
    "name": "Muhammad Hussain Usmani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110323,
    "batch": 1
  },
  {
    "name": "Muhammad Roohallah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110393,
    "batch": 1
  },
  {
    "name": "Muhammad Saqib",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110324,
    "batch": 1
  },
  {
    "name": "Muhammad Shees Raza Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110325,
    "batch": 1
  },
  {
    "name": "Muhmmad Bilal",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110327,
    "batch": 1
  },
  {
    "name": "Muskan Batool",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110363,
    "batch": 1
  },
  {
    "name": "Nadia Iqbal",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110396,
    "batch": 1
  },
  {
    "name": "Rida Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110364,
    "batch": 1
  },
  {
    "name": "Roshni Kumari",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110365,
    "batch": 1
  },
  {
    "name": "Ruhab Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110366,
    "batch": 1
  },
  {
    "name": "Sadia",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110367,
    "batch": 1
  },
  {
    "name": "Samia",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110368,
    "batch": 1
  },
  {
    "name": "Samreen",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110369,
    "batch": 1
  },
  {
    "name": "Sanam Bhatti",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110370,
    "batch": 1
  },
  {
    "name": "Sania",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110397,
    "batch": 1
  },
  {
    "name": "Saqib Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110330,
    "batch": 1
  },
  {
    "name": "Sara Channa",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110371,
    "batch": 1
  },
  {
    "name": "Sehrish",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110372,
    "batch": 1
  },
  {
    "name": "Shaharyar Qadir",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110331,
    "batch": 1
  },
  {
    "name": "Shaiza Abbasi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110373,
    "batch": 1
  },
  {
    "name": "Sheeza Zafar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110332,
    "batch": 1
  },
  {
    "name": "Shoaib Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110333,
    "batch": 1
  },
  {
    "name": "Shua Parveen",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110374,
    "batch": 1
  },
  {
    "name": "Siraj Ahmed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110334,
    "batch": 1
  },
  {
    "name": "Ssd Laksh Matlani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110335,
    "batch": 1
  },
  {
    "name": "Sumair Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110336,
    "batch": 1
  },
  {
    "name": "Sumair Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110386,
    "batch": 1
  },
  {
    "name": "Sumaiya Qureshi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110337,
    "batch": 1
  },
  {
    "name": "Sumaiya Sanober",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110375,
    "batch": 1
  },
  {
    "name": "Urooj Fatima Ghulam Sarwar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110376,
    "batch": 1
  },
  {
    "name": "Urooj Fatima Rajib Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110377,
    "batch": 1
  },
  {
    "name": "Uzma",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110338,
    "batch": 1
  },
  {
    "name": "Wadia Sami",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110378,
    "batch": 1
  },
  {
    "name": "Wajid Dino",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110339,
    "batch": 1
  },
  {
    "name": "Yasir Nawaz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110340,
    "batch": 1
  },
  {
    "name": "Zainab Toufeeq",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110379,
    "batch": 1
  },
  {
    "name": "Zenab",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 110380,
    "batch": 1
  },
  {
    "name": "Abdul Basit",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110401,
    "batch": 1
  },
  {
    "name": "Abdul Rahim",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110403,
    "batch": 1
  },
  {
    "name": "Abrar Ahmed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110404,
    "batch": 1
  },
  {
    "name": "Afia Mughal",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110405,
    "batch": 1
  },
  {
    "name": "Aisha Anees",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110406,
    "batch": 1
  },
  {
    "name": "Ali Abbas",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110407,
    "batch": 1
  },
  {
    "name": "Aliya Ali",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110409,
    "batch": 1
  },
  {
    "name": "Arjun Kumar",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110410,
    "batch": 1
  },
  {
    "name": "Asma",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110411,
    "batch": 1
  },
  {
    "name": "Atif Ahmed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110412,
    "batch": 1
  },
  {
    "name": "Ayaan Hassan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110413,
    "batch": 1
  },
  {
    "name": "Ayesha Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110415,
    "batch": 1
  },
  {
    "name": "Bushra",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110445,
    "batch": 1
  },
  {
    "name": "Daniyal Pitafi",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110416,
    "batch": 1
  },
  {
    "name": "Farman Hyder",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110417,
    "batch": 1
  },
  {
    "name": "Fatima Faisal",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110446,
    "batch": 1
  },
  {
    "name": "Hadiqa Gul Alias Fiza",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110418,
    "batch": 1
  },
  {
    "name": "Hassan Imdad",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110419,
    "batch": 1
  },
  {
    "name": "Kaneez Bibi Khadijatul Kubra",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110447,
    "batch": 1
  },
  {
    "name": "Khizra Eman",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110420,
    "batch": 1
  },
  {
    "name": "Maleeha Naz",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110448,
    "batch": 1
  },
  {
    "name": "Mohammed Kashif Qureshi",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110422,
    "batch": 1
  },
  {
    "name": "Muhammad Asad",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110423,
    "batch": 1
  },
  {
    "name": "Muhammad Ibrahim Memon",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110424,
    "batch": 1
  },
  {
    "name": "Nadir Ali Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110426,
    "batch": 1
  },
  {
    "name": "Najaf Ali",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110427,
    "batch": 1
  },
  {
    "name": "Nimra Malik",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110428,
    "batch": 1
  },
  {
    "name": "Pireha Imtiaz",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110429,
    "batch": 1
  },
  {
    "name": "Rabia Jawed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110430,
    "batch": 1
  },
  {
    "name": "Razaullah",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110431,
    "batch": 1
  },
  {
    "name": "Sagheer Ahmed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110433,
    "batch": 1
  },
  {
    "name": "Samiullah",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110434,
    "batch": 1
  },
  {
    "name": "Samreen",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110449,
    "batch": 1
  },
  {
    "name": "Sania Sahar",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110435,
    "batch": 1
  },
  {
    "name": "Sara Jawed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110436,
    "batch": 1
  },
  {
    "name": "Sumaiya Samreen",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110437,
    "batch": 1
  },
  {
    "name": "Syed Ghulam Haider Shah",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110450,
    "batch": 1
  },
  {
    "name": "Syeda Fizza Fatima Hashmi",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110438,
    "batch": 1
  },
  {
    "name": "Zain Ul Abdin",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110439,
    "batch": 1
  },
  {
    "name": "Zainab Raees",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110440,
    "batch": 1
  },
  {
    "name": "Abdul Moiz",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110138,
    "batch": 1
  },
  {
    "name": "Abdul Rafio",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110101,
    "batch": 1
  },
  {
    "name": "Abdul Wajid",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110102,
    "batch": 1
  },
  {
    "name": "Ali Murtaza",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110146,
    "batch": 1
  },
  {
    "name": "Aneeq-Ur-Rehman",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110104,
    "batch": 1
  },
  {
    "name": "Areeba Mahar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110139,
    "batch": 1
  },
  {
    "name": "Arslan Raheem",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110106,
    "batch": 1
  },
  {
    "name": "Ashiq Ali Bharchoond",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110107,
    "batch": 1
  },
  {
    "name": "Dua Noor",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110108,
    "batch": 1
  },
  {
    "name": "Fakir Raza",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110109,
    "batch": 1
  },
  {
    "name": "Fasiha Parveen",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110110,
    "batch": 1
  },
  {
    "name": "Hafsa Noor",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110147,
    "batch": 1
  },
  {
    "name": "Jaweria Rashid",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110113,
    "batch": 1
  },
  {
    "name": "Maryam Fatima",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110114,
    "batch": 1
  },
  {
    "name": "Masood Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110115,
    "batch": 1
  },
  {
    "name": "Mehtab",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110111,
    "batch": 1
  },
  {
    "name": "Mohammed Umair Ansari",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110116,
    "batch": 1
  },
  {
    "name": "Muhammad Aizaz Mangi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110137,
    "batch": 1
  },
  {
    "name": "Muhammad Aliyan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110148,
    "batch": 1
  },
  {
    "name": "Muhammad Ans",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110117,
    "batch": 1
  },
  {
    "name": "Muhammad Atif Bashir",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110149,
    "batch": 1
  },
  {
    "name": "Muhammad Faizan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110118,
    "batch": 1
  },
  {
    "name": "Muhammad Owais",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110119,
    "batch": 1
  },
  {
    "name": "Muhammad Shayan Mirani",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110120,
    "batch": 1
  },
  {
    "name": "Muhammad Zubair",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110121,
    "batch": 1
  },
  {
    "name": "Noor Ul Ain",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110122,
    "batch": 1
  },
  {
    "name": "Nosheen",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110140,
    "batch": 1
  },
  {
    "name": "Prena Kumari",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110123,
    "batch": 1
  },
  {
    "name": "Sadia Kehar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110124,
    "batch": 1
  },
  {
    "name": "Sameer Rehmat",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110125,
    "batch": 1
  },
  {
    "name": "Sehar Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110126,
    "batch": 1
  },
  {
    "name": "Shahroz Arain",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110127,
    "batch": 1
  },
  {
    "name": "Sidra Parveen",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110128,
    "batch": 1
  },
  {
    "name": "Soohan Mariyam",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110129,
    "batch": 1
  },
  {
    "name": "Syed Ahmed Ali Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110136,
    "batch": 1
  },
  {
    "name": "Umm E Aiman",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110130,
    "batch": 1
  },
  {
    "name": "Urooj Zubair",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110131,
    "batch": 1
  },
  {
    "name": "Usama",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110132,
    "batch": 1
  },
  {
    "name": "Wajeeha Zainab",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110150,
    "batch": 1
  },
  {
    "name": "Zain Ul Abdin",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 110133,
    "batch": 1
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220201,
    "batch": 2
  },
  {
    "name": "ABDUL HAYEE MEMON",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220202,
    "batch": 2
  },
  {
    "name": "Abdul Wahab",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220203,
    "batch": 2
  },
  {
    "name": "Aisha",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220204,
    "batch": 2
  },
  {
    "name": "Anam Imtiaz",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220205,
    "batch": 2
  },
  {
    "name": "Arslan Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220206,
    "batch": 2
  },
  {
    "name": "Azeem Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220207,
    "batch": 2
  },
  {
    "name": "Benazir Shah",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220208,
    "batch": 2
  },
  {
    "name": "Bilal Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220209,
    "batch": 2
  },
  {
    "name": "Bisma Imtiaz",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220210,
    "batch": 2
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220236,
    "batch": 2
  },
  {
    "name": "Farman Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220211,
    "batch": 2
  },
  {
    "name": "Ghulam Mustafa",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220212,
    "batch": 2
  },
  {
    "name": "HAMID ALI",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220213,
    "batch": 2
  },
  {
    "name": "Hyder Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220238,
    "batch": 2
  },
  {
    "name": "Lareb",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220239,
    "batch": 2
  },
  {
    "name": "Luksh Areeja",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220240,
    "batch": 2
  },
  {
    "name": "Mahnoor Qureshi",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220214,
    "batch": 2
  },
  {
    "name": "Mateen Mustafa",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220241,
    "batch": 2
  },
  {
    "name": "MEHR UL NISA",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220215,
    "batch": 2
  },
  {
    "name": "Mubashar Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220216,
    "batch": 2
  },
  {
    "name": "Muhammad Azeem",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220242,
    "batch": 2
  },
  {
    "name": "Muhammad Jameel",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220244,
    "batch": 2
  },
  {
    "name": "MUHAMMAD SHAHRYAR",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220217,
    "batch": 2
  },
  {
    "name": "Muhammad Suhail Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220245,
    "batch": 2
  },
  {
    "name": "Muhammad Talha Rasheed",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220218,
    "batch": 2
  },
  {
    "name": "Muhammad Umair",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220219,
    "batch": 2
  },
  {
    "name": "Muhammad Usama",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220220,
    "batch": 2
  },
  {
    "name": "Muhammad Yaseen",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220221,
    "batch": 2
  },
  {
    "name": "Mussawir Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220246,
    "batch": 2
  },
  {
    "name": "Naeemullah",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220222,
    "batch": 2
  },
  {
    "name": "Najaf Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220223,
    "batch": 2
  },
  {
    "name": "Najaf-ul-ddin",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220247,
    "batch": 2
  },
  {
    "name": "Natasha Mangi",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220224,
    "batch": 2
  },
  {
    "name": "Qadir Bakhsh",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220225,
    "batch": 2
  },
  {
    "name": "Reema Shahzadi",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220226,
    "batch": 2
  },
  {
    "name": "Rehan Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220227,
    "batch": 2
  },
  {
    "name": "Sagar kumar",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220228,
    "batch": 2
  },
  {
    "name": "SAMIULLAH SHAIKH",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220229,
    "batch": 2
  },
  {
    "name": "Shahzad Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220249,
    "batch": 2
  },
  {
    "name": "Shoaib Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220250,
    "batch": 2
  },
  {
    "name": "Shoaib Ahmed Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220231,
    "batch": 2
  },
  {
    "name": "Shoaib Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220232,
    "batch": 2
  },
  {
    "name": "Tabassum Memon",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220251,
    "batch": 2
  },
  {
    "name": "Tufail Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220233,
    "batch": 2
  },
  {
    "name": "Usama Anwar",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220234,
    "batch": 2
  },
  {
    "name": "Yasin Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220235,
    "batch": 2
  },
  {
    "name": "Zeeshan",
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220253,
    "batch": 2
  },
  {
    "name": "Abdul Mateen shah",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220301,
    "batch": 2
  },
  {
    "name": "Abdul Samad",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220340,
    "batch": 2
  },
  {
    "name": "Ahsan Hussain",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220303,
    "batch": 2
  },
  {
    "name": "Ali Hassan",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220304,
    "batch": 2
  },
  {
    "name": "Ali Moiz",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220305,
    "batch": 2
  },
  {
    "name": "Ali Murtaza",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220342,
    "batch": 2
  },
  {
    "name": "Anesh Kumar",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220306,
    "batch": 2
  },
  {
    "name": "Anjilee",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220307,
    "batch": 2
  },
  {
    "name": "Areeba Gulzar",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220308,
    "batch": 2
  },
  {
    "name": "Arslan Fareed",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220309,
    "batch": 2
  },
  {
    "name": "Bilawal Sahito",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220310,
    "batch": 2
  },
  {
    "name": "Farukh Hussain",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220311,
    "batch": 2
  },
  {
    "name": "Fatima",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220312,
    "batch": 2
  },
  {
    "name": "Ghazala",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220313,
    "batch": 2
  },
  {
    "name": "Ibrar Solangi",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220314,
    "batch": 2
  },
  {
    "name": "Jawahir hussain",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220315,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220318,
    "batch": 2
  },
  {
    "name": "Khadija shaikh",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220319,
    "batch": 2
  },
  {
    "name": "LIHZA BATOOL",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220320,
    "batch": 2
  },
  {
    "name": "MARYAM",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220321,
    "batch": 2
  },
  {
    "name": "Mehrunisa Jumani",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220344,
    "batch": 2
  },
  {
    "name": "Misbah Khatonn",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220345,
    "batch": 2
  },
  {
    "name": "Mudasir Rehman",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220323,
    "batch": 2
  },
  {
    "name": "Muhammad Mudasir memon",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220324,
    "batch": 2
  },
  {
    "name": "Muqadas Ayoub",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220327,
    "batch": 2
  },
  {
    "name": "Nabeel Gul",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220328,
    "batch": 2
  },
  {
    "name": "Peeral Khan",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220329,
    "batch": 2
  },
  {
    "name": "Rabia",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220331,
    "batch": 2
  },
  {
    "name": "Seengar Ali",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220333,
    "batch": 2
  },
  {
    "name": "Sineha",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220335,
    "batch": 2
  },
  {
    "name": "Yasir Hussain",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220337,
    "batch": 2
  },
  {
    "name": "Yusra",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220338,
    "batch": 2
  },
  {
    "name": "Zeeshan Ahmed",
    "course": "Certified Graphic Designer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220339,
    "batch": 2
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220424,
    "batch": 2
  },
  {
    "name": "Abuzar Ali",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220406,
    "batch": 2
  },
  {
    "name": "Afsana",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220438,
    "batch": 2
  },
  {
    "name": "Ainee shaikh",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220409,
    "batch": 2
  },
  {
    "name": "Ali Abbas",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220434,
    "batch": 2
  },
  {
    "name": "Ali Faiz",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220411,
    "batch": 2
  },
  {
    "name": "Aqsa Batool",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220426,
    "batch": 2
  },
  {
    "name": "Asif Ali",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220428,
    "batch": 2
  },
  {
    "name": "Ghania Batool",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220425,
    "batch": 2
  },
  {
    "name": "Ghulam Mustafa",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220413,
    "batch": 2
  },
  {
    "name": "Hamadullah",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220442,
    "batch": 2
  },
  {
    "name": "Haseeba",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220440,
    "batch": 2
  },
  {
    "name": "Irfan Ahmed",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220410,
    "batch": 2
  },
  {
    "name": "Kamlesh Kumar",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220404,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220432,
    "batch": 2
  },
  {
    "name": "Muhammad Ahsan",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220436,
    "batch": 2
  },
  {
    "name": "Muhammad Amin",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220437,
    "batch": 2
  },
  {
    "name": "Muhammad Faizan",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220419,
    "batch": 2
  },
  {
    "name": "Muhammad Taha",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220416,
    "batch": 2
  },
  {
    "name": "Muhammad Yaseen",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220444,
    "batch": 2
  },
  {
    "name": "Muskan Naz",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220403,
    "batch": 2
  },
  {
    "name": "Neelam Naz",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220412,
    "batch": 2
  },
  {
    "name": "RAJAB ALI",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220420,
    "batch": 2
  },
  {
    "name": "Sabia Kanwal",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220431,
    "batch": 2
  },
  {
    "name": "Saifullah",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220421,
    "batch": 2
  },
  {
    "name": "Sarfaraz Ahmed",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220401,
    "batch": 2
  },
  {
    "name": "Sawan Khan",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220405,
    "batch": 2
  },
  {
    "name": "Shah Zaman",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220422,
    "batch": 2
  },
  {
    "name": "Shahzad Ashraf",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220418,
    "batch": 2
  },
  {
    "name": "Sibtain Hyder",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220435,
    "batch": 2
  },
  {
    "name": "Syed Hussain Hyder",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220445,
    "batch": 2
  },
  {
    "name": "Taha Ali",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220417,
    "batch": 2
  },
  {
    "name": "Tufail Ahmed",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220427,
    "batch": 2
  },
  {
    "name": "Vaniza Batool",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220439,
    "batch": 2
  },
  {
    "name": "Zainab khan",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220407,
    "batch": 2
  },
  {
    "name": "Zuha Rania Khan",
    "course": "Certified Python Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220408,
    "batch": 2
  },
  {
    "name": "Abdul Rehman",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220136,
    "batch": 2
  },
  {
    "name": "Abid Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220102,
    "batch": 2
  },
  {
    "name": "Afifa",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220103,
    "batch": 2
  },
  {
    "name": "Ali Raza",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220104,
    "batch": 2
  },
  {
    "name": "Arifa Solangi",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220105,
    "batch": 2
  },
  {
    "name": "Arshad Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220106,
    "batch": 2
  },
  {
    "name": "Arshia Mansoor",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220107,
    "batch": 2
  },
  {
    "name": "Attaullah",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220108,
    "batch": 2
  },
  {
    "name": "Bisma shaikh",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220109,
    "batch": 2
  },
  {
    "name": "Bushra Ambreen",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220110,
    "batch": 2
  },
  {
    "name": "Farman Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220111,
    "batch": 2
  },
  {
    "name": "Farwa batool",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220112,
    "batch": 2
  },
  {
    "name": "Ghulam Fatima",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220138,
    "batch": 2
  },
  {
    "name": "Haseebullah",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220139,
    "batch": 2
  },
  {
    "name": "Huzaifa Zulfiqar",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220140,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220114,
    "batch": 2
  },
  {
    "name": "Kashif Khan",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220142,
    "batch": 2
  },
  {
    "name": "Mudasir",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220144,
    "batch": 2
  },
  {
    "name": "Muhammad Ahmed",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220145,
    "batch": 2
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220116,
    "batch": 2
  },
  {
    "name": "Muhammad Kashif",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220117,
    "batch": 2
  },
  {
    "name": "Muhammad Masharib",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220118,
    "batch": 2
  },
  {
    "name": "Muhammad Umer",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220119,
    "batch": 2
  },
  {
    "name": "Muhammad Zain",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220120,
    "batch": 2
  },
  {
    "name": "Mujahid Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220121,
    "batch": 2
  },
  {
    "name": "Muzamil Hussain",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220146,
    "batch": 2
  },
  {
    "name": "Nazeer Ahmed",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220122,
    "batch": 2
  },
  {
    "name": "Nimra Noor",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220123,
    "batch": 2
  },
  {
    "name": "Rabel",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220124,
    "batch": 2
  },
  {
    "name": "Rizwan Ahmed",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220125,
    "batch": 2
  },
  {
    "name": "Rizwan Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220126,
    "batch": 2
  },
  {
    "name": "Saiqa",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220128,
    "batch": 2
  },
  {
    "name": "Sana Ahmed",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220129,
    "batch": 2
  },
  {
    "name": "Sania Tabasum",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220147,
    "batch": 2
  },
  {
    "name": "Shakeel Ahmed",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220131,
    "batch": 2
  },
  {
    "name": "Syed Fateh Ali Shah",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220132,
    "batch": 2
  },
  {
    "name": "Ume Salma hassan",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220133,
    "batch": 2
  },
  {
    "name": "Usswa-e-Noor",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220149,
    "batch": 2
  },
  {
    "name": "Uzma",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220150,
    "batch": 2
  },
  {
    "name": "Zahid Ali",
    "course": "Certified Web Developer",
    "center": "IBA IET Campus Khairpur",
    "certificate_id": 220134,
    "batch": 2
  },
  {
    "name": "Aamir Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 130201,
    "batch": 2
  },
  {
    "name": "Abdul Samad",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230101,
    "batch": 2
  },
  {
    "name": "Adeel ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230102,
    "batch": 2
  },
  {
    "name": "Ahmed Nawaz",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230103,
    "batch": 2
  },
  {
    "name": "Ali Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230104,
    "batch": 2
  },
  {
    "name": "Fida Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230105,
    "batch": 2
  },
  {
    "name": "Gul Hassan",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230106,
    "batch": 2
  },
  {
    "name": "Hassan Raza Shah",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230107,
    "batch": 2
  },
  {
    "name": "Ishrat Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230108,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230109,
    "batch": 2
  },
  {
    "name": "Manthar Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230110,
    "batch": 2
  },
  {
    "name": "Mehdi Hassan",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230111,
    "batch": 2
  },
  {
    "name": "Messum Raza",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230112,
    "batch": 2
  },
  {
    "name": "Mir Daud Hassan",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230113,
    "batch": 2
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230114,
    "batch": 2
  },
  {
    "name": "Muhammad Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230115,
    "batch": 2
  },
  {
    "name": "Muqadas Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230117,
    "batch": 2
  },
  {
    "name": "Naeem Ahmed Mangnejo",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230118,
    "batch": 2
  },
  {
    "name": "Rahmatullah",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230119,
    "batch": 2
  },
  {
    "name": "Raza Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230120,
    "batch": 2
  },
  {
    "name": "Sammar Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230122,
    "batch": 2
  },
  {
    "name": "Sheeraz Hussain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230123,
    "batch": 2
  },
  {
    "name": "Waheed Ali",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230124,
    "batch": 2
  },
  {
    "name": "Yasir Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230125,
    "batch": 2
  },
  {
    "name": "Zaheer Abbas",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230126,
    "batch": 2
  },
  {
    "name": "Zulqarnain",
    "course": "Certified Web Developer",
    "center": "PBM-WEC- Kotdiji",
    "certificate_id": 230127,
    "batch": 2
  },
  {
    "name": "Abdul Khaliq",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260801,
    "batch": 2
  },
  {
    "name": "Abdul Majid",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260802,
    "batch": 2
  },
  {
    "name": "Abdul Manaf",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260803,
    "batch": 2
  },
  {
    "name": "Abdul Qayoom",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260804,
    "batch": 2
  },
  {
    "name": "Abdul Qudoos",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260805,
    "batch": 2
  },
  {
    "name": "Ahmed Hussain",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260806,
    "batch": 2
  },
  {
    "name": "Alishan",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260807,
    "batch": 2
  },
  {
    "name": "Arifa",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260808,
    "batch": 2
  },
  {
    "name": "Ashique Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260809,
    "batch": 2
  },
  {
    "name": "Deepak Kumar",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260810,
    "batch": 2
  },
  {
    "name": "Faiza",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260811,
    "batch": 2
  },
  {
    "name": "Farzand Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260812,
    "batch": 2
  },
  {
    "name": "Hussain Abbas",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260813,
    "batch": 2
  },
  {
    "name": "Irshad Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260814,
    "batch": 2
  },
  {
    "name": "Jawad Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260815,
    "batch": 2
  },
  {
    "name": "M. Muzammil",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260816,
    "batch": 2
  },
  {
    "name": "Masood Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260817,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260818,
    "batch": 2
  },
  {
    "name": "Mehdi Raza",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260819,
    "batch": 2
  },
  {
    "name": "Muhammad Muzamil",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260820,
    "batch": 2
  },
  {
    "name": "Muhammad Nawaz",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260821,
    "batch": 2
  },
  {
    "name": "Muneer Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260822,
    "batch": 2
  },
  {
    "name": "Rabail Sindhu",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260823,
    "batch": 2
  },
  {
    "name": "Raja Mubeen Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260824,
    "batch": 2
  },
  {
    "name": "Rohit Kumar",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260825,
    "batch": 2
  },
  {
    "name": "Saba",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260826,
    "batch": 2
  },
  {
    "name": "Sagar Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260827,
    "batch": 2
  },
  {
    "name": "Salik",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260828,
    "batch": 2
  },
  {
    "name": "Sammad-ul-Hassan",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260829,
    "batch": 2
  },
  {
    "name": "Shafaat Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260830,
    "batch": 2
  },
  {
    "name": "Shahid Hussain",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260831,
    "batch": 2
  },
  {
    "name": "Sittara",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260832,
    "batch": 2
  },
  {
    "name": "Ubaid-ur-Rehman",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260833,
    "batch": 2
  },
  {
    "name": "Umair",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260834,
    "batch": 2
  },
  {
    "name": "Vishal Kumar",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260835,
    "batch": 2
  },
  {
    "name": "Zafar Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260836,
    "batch": 2
  },
  {
    "name": "Zara",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260837,
    "batch": 2
  },
  {
    "name": "Zeenat Khatoon",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260838,
    "batch": 2
  },
  {
    "name": "Zuhaib Hassan",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260839,
    "batch": 2
  },
  {
    "name": "Zulfiqar Ali",
    "course": "Certified Data Base Administrator",
    "center": "QUEST Nawabshah",
    "certificate_id": 260840,
    "batch": 2
  },
  {
    "name": "Aakash",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260101,
    "batch": 2
  },
  {
    "name": "Aashir Razaque",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260102,
    "batch": 2
  },
  {
    "name": "Aasiya Kiran",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260103,
    "batch": 2
  },
  {
    "name": "Abdul Rehman",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260104,
    "batch": 2
  },
  {
    "name": "Abu Talha",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260105,
    "batch": 2
  },
  {
    "name": "Aftab Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260106,
    "batch": 2
  },
  {
    "name": "Aftab Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260107,
    "batch": 2
  },
  {
    "name": "Ahsan",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260108,
    "batch": 2
  },
  {
    "name": "Anmol",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260109,
    "batch": 2
  },
  {
    "name": "Arishba",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260110,
    "batch": 2
  },
  {
    "name": "Dua Iqra",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260111,
    "batch": 2
  },
  {
    "name": "Ghulam Mehdi",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260112,
    "batch": 2
  },
  {
    "name": "Gul Rehman",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260113,
    "batch": 2
  },
  {
    "name": "Hasnain Babar",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260114,
    "batch": 2
  },
  {
    "name": "Junaid Hyder",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260115,
    "batch": 2
  },
  {
    "name": "Kashif Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260116,
    "batch": 2
  },
  {
    "name": "Mariyam",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260118,
    "batch": 2
  },
  {
    "name": "Meer Uzair Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260119,
    "batch": 2
  },
  {
    "name": "Moiz Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260120,
    "batch": 2
  },
  {
    "name": "Muhammad Arslan",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260121,
    "batch": 2
  },
  {
    "name": "Muhammad Dawood",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260122,
    "batch": 2
  },
  {
    "name": "Muhammad Hamza",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260123,
    "batch": 2
  },
  {
    "name": "Muhammad Mubeen",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260117,
    "batch": 2
  },
  {
    "name": "Muhammad Mubeen",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260125,
    "batch": 2
  },
  {
    "name": "Muhammad Raza",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260126,
    "batch": 2
  },
  {
    "name": "Muhammad Shakeel",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260127,
    "batch": 2
  },
  {
    "name": "Muqadas Mumtaz Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260128,
    "batch": 2
  },
  {
    "name": "Musawir Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260129,
    "batch": 2
  },
  {
    "name": "Nabi Bux",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260130,
    "batch": 2
  },
  {
    "name": "Nasreen",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260131,
    "batch": 2
  },
  {
    "name": "Noman",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260132,
    "batch": 2
  },
  {
    "name": "Rab Nawaz",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260133,
    "batch": 2
  },
  {
    "name": "Rimsha",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260134,
    "batch": 2
  },
  {
    "name": "Saifullah",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260135,
    "batch": 2
  },
  {
    "name": "Sanober",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260136,
    "batch": 2
  },
  {
    "name": "Sehrish",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260137,
    "batch": 2
  },
  {
    "name": "Shamim Siyal",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260138,
    "batch": 2
  },
  {
    "name": "Sidra",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260139,
    "batch": 2
  },
  {
    "name": "Sikandar Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260140,
    "batch": 2
  },
  {
    "name": "Syed Noman Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260141,
    "batch": 2
  },
  {
    "name": "Tayyaba",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260142,
    "batch": 2
  },
  {
    "name": "Zafar Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260143,
    "batch": 2
  },
  {
    "name": "Zeeshan",
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260144,
    "batch": 2
  },
  {
    "name": "Aagha Essa Raza",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260644,
    "batch": 2
  },
  {
    "name": "Aaisha Hameed",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260701,
    "batch": 2
  },
  {
    "name": "Aarij Shafique",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260702,
    "batch": 2
  },
  {
    "name": "Abdul Rehman",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260703,
    "batch": 2
  },
  {
    "name": "Aftab Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260704,
    "batch": 2
  },
  {
    "name": "Ahmed  Nawaz",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260705,
    "batch": 2
  },
  {
    "name": "Aisha Kanwal",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260706,
    "batch": 2
  },
  {
    "name": "Aisha Kanwal",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260606,
    "batch": 2
  },
  {
    "name": "Ali Murtaza",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260608,
    "batch": 2
  },
  {
    "name": "Aliza Naz",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260707,
    "batch": 2
  },
  {
    "name": "Ambreen",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260610,
    "batch": 2
  },
  {
    "name": "AsaD Jameel",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260708,
    "batch": 2
  },
  {
    "name": "Asia",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260611,
    "batch": 2
  },
  {
    "name": "Azhar Hussain",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260612,
    "batch": 2
  },
  {
    "name": "Basit Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260709,
    "batch": 2
  },
  {
    "name": "Bibi Haleema",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260613,
    "batch": 2
  },
  {
    "name": "Dua Memon",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260614,
    "batch": 2
  },
  {
    "name": "Faisal Rehman",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260710,
    "batch": 2
  },
  {
    "name": "Faisal Sharif",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260615,
    "batch": 2
  },
  {
    "name": "Farhan Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260711,
    "batch": 2
  },
  {
    "name": "Farhan ALi",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260712,
    "batch": 2
  },
  {
    "name": "Fatima Soomro",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260604,
    "batch": 2
  },
  {
    "name": "Ghulam Shabir",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260616,
    "batch": 2
  },
  {
    "name": "Gulshan",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260713,
    "batch": 2
  },
  {
    "name": "Hamid Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260617,
    "batch": 2
  },
  {
    "name": "Haroon Asif",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260714,
    "batch": 2
  },
  {
    "name": "Heer",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260618,
    "batch": 2
  },
  {
    "name": "Humazaib",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260715,
    "batch": 2
  },
  {
    "name": "Irfan Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260716,
    "batch": 2
  },
  {
    "name": "Kanwal",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260717,
    "batch": 2
  },
  {
    "name": "Khizar Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260718,
    "batch": 2
  },
  {
    "name": "Khizar Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260619,
    "batch": 2
  },
  {
    "name": "Kirtika Lohana",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260719,
    "batch": 2
  },
  {
    "name": "Majid Sheikh",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260720,
    "batch": 2
  },
  {
    "name": "Maria",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260721,
    "batch": 2
  },
  {
    "name": "Mehrban Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260722,
    "batch": 2
  },
  {
    "name": "Merab",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260723,
    "batch": 2
  },
  {
    "name": "Mohammad Usman",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260724,
    "batch": 2
  },
  {
    "name": "Mohsin Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260725,
    "batch": 2
  },
  {
    "name": "Momin Awan",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260726,
    "batch": 2
  },
  {
    "name": "Mudasir",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260621,
    "batch": 2
  },
  {
    "name": "Muhammad",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260727,
    "batch": 2
  },
  {
    "name": "Muhammad Abu Talah",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260728,
    "batch": 2
  },
  {
    "name": "Muhammad Asim",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260622,
    "batch": 2
  },
  {
    "name": "Muhammad Asim",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260729,
    "batch": 2
  },
  {
    "name": "Muhammad Bux",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260730,
    "batch": 2
  },
  {
    "name": "Muhammad Hamza",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260731,
    "batch": 2
  },
  {
    "name": "Muhammad Hassan",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260623,
    "batch": 2
  },
  {
    "name": "Muhammad Ibrahim",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260732,
    "batch": 2
  },
  {
    "name": "Muhammad Musab",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260624,
    "batch": 2
  },
  {
    "name": "Muhammad Raza",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260625,
    "batch": 2
  },
  {
    "name": "Muhammad Umer",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260626,
    "batch": 2
  },
  {
    "name": "Muhammad Usama",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260601,
    "batch": 2
  },
  {
    "name": "Muhmmad Ahtisham",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260627,
    "batch": 2
  },
  {
    "name": "Mujahid",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260733,
    "batch": 2
  },
  {
    "name": "Mustafa Hussain",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260734,
    "batch": 2
  },
  {
    "name": "Neelman",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260735,
    "batch": 2
  },
  {
    "name": "Noor",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260628,
    "batch": 2
  },
  {
    "name": "Nosheen",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260736,
    "batch": 2
  },
  {
    "name": "Orangzaib",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260629,
    "batch": 2
  },
  {
    "name": "Piyaro Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260630,
    "batch": 2
  },
  {
    "name": "Rameez Qadir",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260737,
    "batch": 2
  },
  {
    "name": "Rana Faizan Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260738,
    "batch": 2
  },
  {
    "name": "Saba",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260739,
    "batch": 2
  },
  {
    "name": "Saba",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260631,
    "batch": 2
  },
  {
    "name": "Saba Gul",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260632,
    "batch": 2
  },
  {
    "name": "Sadia Bhutto",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260740,
    "batch": 2
  },
  {
    "name": "Sajjad",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260602,
    "batch": 2
  },
  {
    "name": "Sajjad Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260741,
    "batch": 2
  },
  {
    "name": "Samad Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260742,
    "batch": 2
  },
  {
    "name": "Saneha",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260743,
    "batch": 2
  },
  {
    "name": "Sapna",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260633,
    "batch": 2
  },
  {
    "name": "Sarwar Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260634,
    "batch": 2
  },
  {
    "name": "Sawera",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260745,
    "batch": 2
  },
  {
    "name": "Sawera",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260744,
    "batch": 2
  },
  {
    "name": "Shaharyar Qadir",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260746,
    "batch": 2
  },
  {
    "name": "Shahid Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260635,
    "batch": 2
  },
  {
    "name": "Shahida",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260636,
    "batch": 2
  },
  {
    "name": "Shahnawaz",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260637,
    "batch": 2
  },
  {
    "name": "Shahneela",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260638,
    "batch": 2
  },
  {
    "name": "Shahryar",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260747,
    "batch": 2
  },
  {
    "name": "Shams-ul-Din",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260639,
    "batch": 2
  },
  {
    "name": "Sohail Saleem",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260640,
    "batch": 2
  },
  {
    "name": "Tooba",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260748,
    "batch": 2
  },
  {
    "name": "Ubaidullah",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260749,
    "batch": 2
  },
  {
    "name": "Zahir Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260750,
    "batch": 2
  },
  {
    "name": "Zain Mustafa",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260751,
    "batch": 2
  },
  {
    "name": "Zain-ul-abdin",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260752,
    "batch": 2
  },
  {
    "name": "Zobia",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260641,
    "batch": 2
  },
  {
    "name": "Zubair Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260642,
    "batch": 2
  },
  {
    "name": "Zubair Ahmed Channa",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260605,
    "batch": 2
  },
  {
    "name": "Zulfiqar Ali",
    "course": "Certified E-Commerce Professional",
    "center": "QUEST Nawabshah",
    "certificate_id": 260643,
    "batch": 2
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260201,
    "batch": 2
  },
  {
    "name": "Abdul Rehman",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260301,
    "batch": 2
  },
  {
    "name": "Abdul Rehman",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260302,
    "batch": 2
  },
  {
    "name": "Abdul Samad",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260202,
    "batch": 2
  },
  {
    "name": "Abeer Khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260203,
    "batch": 2
  },
  {
    "name": "Ahmed Mujtaba",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260204,
    "batch": 2
  },
  {
    "name": "Aisha",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260205,
    "batch": 2
  },
  {
    "name": "Ali Raza Soomro",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260303,
    "batch": 2
  },
  {
    "name": "Alina",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260206,
    "batch": 2
  },
  {
    "name": "Aliya",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260207,
    "batch": 2
  },
  {
    "name": "Ameen Mari",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260208,
    "batch": 2
  },
  {
    "name": "Aneela",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260304,
    "batch": 2
  },
  {
    "name": "Areeba Kanwal",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260305,
    "batch": 2
  },
  {
    "name": "Areeba Kanwal",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260209,
    "batch": 2
  },
  {
    "name": "Arsal Abbas",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260210,
    "batch": 2
  },
  {
    "name": "Asad Ali Zardari",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260211,
    "batch": 2
  },
  {
    "name": "Ashna",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260212,
    "batch": 2
  },
  {
    "name": "Ayesha Parveen",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260306,
    "batch": 2
  },
  {
    "name": "Ayesha Saleem",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260213,
    "batch": 2
  },
  {
    "name": "Azhar Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260307,
    "batch": 2
  },
  {
    "name": "Barkat Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260214,
    "batch": 2
  },
  {
    "name": "Danish Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260215,
    "batch": 2
  },
  {
    "name": "Dost Ali Chandio",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260216,
    "batch": 2
  },
  {
    "name": "Fahad Hassan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260308,
    "batch": 2
  },
  {
    "name": "Fatima Nawaz",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260217,
    "batch": 2
  },
  {
    "name": "Fatima Zuhra",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260309,
    "batch": 2
  },
  {
    "name": "Fiza",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260218,
    "batch": 2
  },
  {
    "name": "Fiza",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260219,
    "batch": 2
  },
  {
    "name": "Iqra",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260310,
    "batch": 2
  },
  {
    "name": "Jawad Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260220,
    "batch": 2
  },
  {
    "name": "Junaid Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260221,
    "batch": 2
  },
  {
    "name": "Kaveeta",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260311,
    "batch": 2
  },
  {
    "name": "Khadim Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260222,
    "batch": 2
  },
  {
    "name": "Kiran",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260223,
    "batch": 2
  },
  {
    "name": "M. Hasnain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260224,
    "batch": 2
  },
  {
    "name": "M. Ibrahim",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260312,
    "batch": 2
  },
  {
    "name": "M. Uzair",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260225,
    "batch": 2
  },
  {
    "name": "M. Zaid Raza",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260313,
    "batch": 2
  },
  {
    "name": "M.Ehsanllah",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260226,
    "batch": 2
  },
  {
    "name": "M.Umair Raza",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260227,
    "batch": 2
  },
  {
    "name": "Mahak Mughal",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260228,
    "batch": 2
  },
  {
    "name": "Maham Khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260314,
    "batch": 2
  },
  {
    "name": "Mahnoor Malik",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260315,
    "batch": 2
  },
  {
    "name": "Mahtab Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260316,
    "batch": 2
  },
  {
    "name": "Marui Rukhsar",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260229,
    "batch": 2
  },
  {
    "name": "Maryam Rasheed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260317,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260318,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260319,
    "batch": 2
  },
  {
    "name": "Mehak Noor",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260320,
    "batch": 2
  },
  {
    "name": "Mir Hassan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260230,
    "batch": 2
  },
  {
    "name": "Mohsin Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260321,
    "batch": 2
  },
  {
    "name": "Moomal",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260322,
    "batch": 2
  },
  {
    "name": "Muhammad Aslam",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260231,
    "batch": 2
  },
  {
    "name": "Mujahid Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260232,
    "batch": 2
  },
  {
    "name": "Mujtaba",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260323,
    "batch": 2
  },
  {
    "name": "Najma",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260233,
    "batch": 2
  },
  {
    "name": "Nasir Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260234,
    "batch": 2
  },
  {
    "name": "Nimra",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260324,
    "batch": 2
  },
  {
    "name": "Noor Imran",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260325,
    "batch": 2
  },
  {
    "name": "Qadam Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260326,
    "batch": 2
  },
  {
    "name": "Rabia bibi",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260327,
    "batch": 2
  },
  {
    "name": "raja naimatullah",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260328,
    "batch": 2
  },
  {
    "name": "Saba Iman",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260235,
    "batch": 2
  },
  {
    "name": "Sadaf",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260329,
    "batch": 2
  },
  {
    "name": "Sadia Qureshi",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260330,
    "batch": 2
  },
  {
    "name": "Sahil Murad",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260236,
    "batch": 2
  },
  {
    "name": "Saima Awan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260331,
    "batch": 2
  },
  {
    "name": "Saqib Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260237,
    "batch": 2
  },
  {
    "name": "Saqib Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260332,
    "batch": 2
  },
  {
    "name": "Saveeta Bai",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260333,
    "batch": 2
  },
  {
    "name": "Sawera",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260238,
    "batch": 2
  },
  {
    "name": "Sayed Ali Akbar",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260239,
    "batch": 2
  },
  {
    "name": "Sayed Hassan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260240,
    "batch": 2
  },
  {
    "name": "Shahzaib",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260334,
    "batch": 2
  },
  {
    "name": "Shan Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260335,
    "batch": 2
  },
  {
    "name": "Sharjeel Alam",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260336,
    "batch": 2
  },
  {
    "name": "Shukurullah",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260241,
    "batch": 2
  },
  {
    "name": "Sidra",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260337,
    "batch": 2
  },
  {
    "name": "Silwester",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260242,
    "batch": 2
  },
  {
    "name": "Sumaiya",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260243,
    "batch": 2
  },
  {
    "name": "Sumera",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260244,
    "batch": 2
  },
  {
    "name": "Sumia Zakir",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260338,
    "batch": 2
  },
  {
    "name": "Taha Asad",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260245,
    "batch": 2
  },
  {
    "name": "Tahira Asad",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260246,
    "batch": 2
  },
  {
    "name": "Umar Hayat",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260339,
    "batch": 2
  },
  {
    "name": "Usama",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260247,
    "batch": 2
  },
  {
    "name": "Zakir Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260340,
    "batch": 2
  },
  {
    "name": "Zakir Karim",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260341,
    "batch": 2
  },
  {
    "name": "Zam Zam Preet",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260248,
    "batch": 2
  },
  {
    "name": "Zamin Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260342,
    "batch": 2
  },
  {
    "name": "Zeeshan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260249,
    "batch": 2
  },
  {
    "name": "Zoya Abbasi",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260343,
    "batch": 2
  },
  {
    "name": "Zulqarnain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260250,
    "batch": 2
  },
  {
    "name": "Abdul Majid",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260501,
    "batch": 2
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260502,
    "batch": 2
  },
  {
    "name": "Abeeha Zehra",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260503,
    "batch": 2
  },
  {
    "name": "Ali Raza",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260504,
    "batch": 2
  },
  {
    "name": "Alisha",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260505,
    "batch": 2
  },
  {
    "name": "Alishba",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260506,
    "batch": 2
  },
  {
    "name": "Amna Urooj",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260507,
    "batch": 2
  },
  {
    "name": "Aqsa",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260508,
    "batch": 2
  },
  {
    "name": "Aqsa Samo",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260509,
    "batch": 2
  },
  {
    "name": "Ayesha",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260510,
    "batch": 2
  },
  {
    "name": "Azeem Asghar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260511,
    "batch": 2
  },
  {
    "name": "Bibi Khatija",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260512,
    "batch": 2
  },
  {
    "name": "Bisma",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260513,
    "batch": 2
  },
  {
    "name": "Faraz Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260514,
    "batch": 2
  },
  {
    "name": "Hassnain Anwar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260516,
    "batch": 2
  },
  {
    "name": "Ilma",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260517,
    "batch": 2
  },
  {
    "name": "Imdad Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260518,
    "batch": 2
  },
  {
    "name": "Iqra",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260519,
    "batch": 2
  },
  {
    "name": "Irfan Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260520,
    "batch": 2
  },
  {
    "name": "Isha",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260521,
    "batch": 2
  },
  {
    "name": "Isra",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260522,
    "batch": 2
  },
  {
    "name": "Junaid",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260523,
    "batch": 2
  },
  {
    "name": "Junaid Ahmed",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260524,
    "batch": 2
  },
  {
    "name": "Kashaf-ud-Duja",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260525,
    "batch": 2
  },
  {
    "name": "Misbah Gul",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260526,
    "batch": 2
  },
  {
    "name": "Misbah-uddin",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260527,
    "batch": 2
  },
  {
    "name": "Muhammad  Usman",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260528,
    "batch": 2
  },
  {
    "name": "Muhammad Abrar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260529,
    "batch": 2
  },
  {
    "name": "Muhammad Ahmed Raza",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260530,
    "batch": 2
  },
  {
    "name": "Muhammad Saad",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260531,
    "batch": 2
  },
  {
    "name": "Musawir Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260533,
    "batch": 2
  },
  {
    "name": "Nazakat Hussain",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260534,
    "batch": 2
  },
  {
    "name": "Parvea Ahmed",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260535,
    "batch": 2
  },
  {
    "name": "Rimsha Qamar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260536,
    "batch": 2
  },
  {
    "name": "Rizwan Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260537,
    "batch": 2
  },
  {
    "name": "Sanaullah",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260538,
    "batch": 2
  },
  {
    "name": "Shahzaib Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260539,
    "batch": 2
  },
  {
    "name": "Syed Zainab-ur-Rehman",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260540,
    "batch": 2
  },
  {
    "name": "Waqas Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260541,
    "batch": 2
  },
  {
    "name": "Zubair Ahmed",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260542,
    "batch": 2
  },
  {
    "name": "Abdul Hameed",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260401,
    "batch": 2
  },
  {
    "name": "Ahmed Farooq",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260402,
    "batch": 2
  },
  {
    "name": "Ali Murtaza",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260403,
    "batch": 2
  },
  {
    "name": "Aqsa",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260404,
    "batch": 2
  },
  {
    "name": "Arzoo Channar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260405,
    "batch": 2
  },
  {
    "name": "Ayesha",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260406,
    "batch": 2
  },
  {
    "name": "Ayesha",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260407,
    "batch": 2
  },
  {
    "name": "Aysha Iqbal",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260408,
    "batch": 2
  },
  {
    "name": "Bashir Ahmed",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260409,
    "batch": 2
  },
  {
    "name": "Durreh Shehwar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260410,
    "batch": 2
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260411,
    "batch": 2
  },
  {
    "name": "Fayaz Hussain",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260412,
    "batch": 2
  },
  {
    "name": "Ganva",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260413,
    "batch": 2
  },
  {
    "name": "Ghullam Fatima",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260414,
    "batch": 2
  },
  {
    "name": "Ghullam Mohiddin",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260415,
    "batch": 2
  },
  {
    "name": "Haseeba Khan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260416,
    "batch": 2
  },
  {
    "name": "Hassnain",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260417,
    "batch": 2
  },
  {
    "name": "Hayan Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260418,
    "batch": 2
  },
  {
    "name": "Humaira Bano",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260419,
    "batch": 2
  },
  {
    "name": "JANHZAIB",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260420,
    "batch": 2
  },
  {
    "name": "Kanchan Kumari",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260421,
    "batch": 2
  },
  {
    "name": "Khushboo",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260422,
    "batch": 2
  },
  {
    "name": "M. Anss",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260423,
    "batch": 2
  },
  {
    "name": "M.Saleem",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260424,
    "batch": 2
  },
  {
    "name": "Mahak Bano",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260425,
    "batch": 2
  },
  {
    "name": "Marryam Noor",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260426,
    "batch": 2
  },
  {
    "name": "Marvi",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260427,
    "batch": 2
  },
  {
    "name": "Mehnaz",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260428,
    "batch": 2
  },
  {
    "name": "Muhammad Rizwan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260429,
    "batch": 2
  },
  {
    "name": "Muneeba",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260430,
    "batch": 2
  },
  {
    "name": "Muskan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260431,
    "batch": 2
  },
  {
    "name": "Paras Nasir",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260432,
    "batch": 2
  },
  {
    "name": "Rabnawaz",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260433,
    "batch": 2
  },
  {
    "name": "Shahbaz Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260434,
    "batch": 2
  },
  {
    "name": "Shahbaz Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260435,
    "batch": 2
  },
  {
    "name": "Shahzaib Khan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260436,
    "batch": 2
  },
  {
    "name": "Sufiyan Khan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260437,
    "batch": 2
  },
  {
    "name": "Syed Hassan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260438,
    "batch": 2
  },
  {
    "name": "urooj mehar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260439,
    "batch": 2
  },
  {
    "name": "Wali Muhammad",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 260440,
    "batch": 2
  },
  {
    "name": "Aadil Waheed",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210901,
    "batch": 2
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210902,
    "batch": 2
  },
  {
    "name": "Abdul Hafeez",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210904,
    "batch": 2
  },
  {
    "name": "Abdul Qadeer",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210905,
    "batch": 2
  },
  {
    "name": "Abdul Qadir",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210906,
    "batch": 2
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210907,
    "batch": 2
  },
  {
    "name": "Afshan Iqbal",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210908,
    "batch": 2
  },
  {
    "name": "Aiman Imran",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210909,
    "batch": 2
  },
  {
    "name": "Ali Asghar",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210910,
    "batch": 2
  },
  {
    "name": "Ali Jan Ansari",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210911,
    "batch": 2
  },
  {
    "name": "Ameer Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210912,
    "batch": 2
  },
  {
    "name": "Bisma Jokhio",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210915,
    "batch": 2
  },
  {
    "name": "Farhanullah",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210919,
    "batch": 2
  },
  {
    "name": "Farwa Fatima",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210920,
    "batch": 2
  },
  {
    "name": "Hansa Balouch",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210921,
    "batch": 2
  },
  {
    "name": "Hira Imran mirani",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210922,
    "batch": 2
  },
  {
    "name": "Iqra",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210923,
    "batch": 2
  },
  {
    "name": "Iram Iqbal",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210924,
    "batch": 2
  },
  {
    "name": "Jaweria Laghari",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210925,
    "batch": 2
  },
  {
    "name": "Jawwad Hussain",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210926,
    "batch": 2
  },
  {
    "name": "Joti Kumari",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210927,
    "batch": 2
  },
  {
    "name": "Kaleemullah Soomro",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210928,
    "batch": 2
  },
  {
    "name": "Madiha Sarfaraz",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210930,
    "batch": 2
  },
  {
    "name": "Meera",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210931,
    "batch": 2
  },
  {
    "name": "Mohsin Ali",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210932,
    "batch": 2
  },
  {
    "name": "Muhammad Bilal",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210934,
    "batch": 2
  },
  {
    "name": "Muhammad Mehdi Shah",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210935,
    "batch": 2
  },
  {
    "name": "Muhammad Rehan",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210936,
    "batch": 2
  },
  {
    "name": "Muhammad Sahil",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210937,
    "batch": 2
  },
  {
    "name": "Muhammad Usman",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210938,
    "batch": 2
  },
  {
    "name": "Sadaf",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210941,
    "batch": 2
  },
  {
    "name": "Sasuie Qureshi",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210942,
    "batch": 2
  },
  {
    "name": "Shah Nawaz",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210943,
    "batch": 2
  },
  {
    "name": "Shahmir",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210945,
    "batch": 2
  },
  {
    "name": "Sibghatullah Memon",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210946,
    "batch": 2
  },
  {
    "name": "Sohail",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210947,
    "batch": 2
  },
  {
    "name": "Sumaiya Fatima",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210948,
    "batch": 2
  },
  {
    "name": "Taimoor Khan",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210950,
    "batch": 2
  },
  {
    "name": "Toheed Ahmed",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210951,
    "batch": 2
  },
  {
    "name": "Zainab Shaikh",
    "course": "Certified Data Base Administrator",
    "center": "Sukkur IBA University",
    "certificate_id": 210954,
    "batch": 2
  },
  {
    "name": "Abdul Basit",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211001,
    "batch": 2
  },
  {
    "name": "Abdul Basit",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211002,
    "batch": 2
  },
  {
    "name": "Abdul raheem",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211005,
    "batch": 2
  },
  {
    "name": "Abrar Ahmed chachar",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211007,
    "batch": 2
  },
  {
    "name": "Afia",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211008,
    "batch": 2
  },
  {
    "name": "Ali Abbas Khoso",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211010,
    "batch": 2
  },
  {
    "name": "Anas Ali",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211011,
    "batch": 2
  },
  {
    "name": "Anchal",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211012,
    "batch": 2
  },
  {
    "name": "Asma",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211013,
    "batch": 2
  },
  {
    "name": "Babar Ali",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211015,
    "batch": 2
  },
  {
    "name": "Daniyal Pitafi",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211016,
    "batch": 2
  },
  {
    "name": "Fatima Faisal",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211017,
    "batch": 2
  },
  {
    "name": "Hoorain Qureshi",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211018,
    "batch": 2
  },
  {
    "name": "Kaleem Ullah",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211020,
    "batch": 2
  },
  {
    "name": "Kamran Ali",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211021,
    "batch": 2
  },
  {
    "name": "Lareb",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211022,
    "batch": 2
  },
  {
    "name": "M.Ilyas Arain",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211023,
    "batch": 2
  },
  {
    "name": "Mahnoor Bhutto",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211024,
    "batch": 2
  },
  {
    "name": "Maleeha Naz",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211025,
    "batch": 2
  },
  {
    "name": "Masooma  Batool",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211026,
    "batch": 2
  },
  {
    "name": "Muhammad Mujtaba",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211028,
    "batch": 2
  },
  {
    "name": "Muhammad Raqeeb",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211029,
    "batch": 2
  },
  {
    "name": "Muhammad Saqlain Qureshi",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211030,
    "batch": 2
  },
  {
    "name": "Muhammad Wajahat Khan Ghouri",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211031,
    "batch": 2
  },
  {
    "name": "Nadir Ali Khan",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211032,
    "batch": 2
  },
  {
    "name": "Najaf Ali Soomro",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211033,
    "batch": 2
  },
  {
    "name": "Naveed Ahmed",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211034,
    "batch": 2
  },
  {
    "name": "Nimra Malik",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211035,
    "batch": 2
  },
  {
    "name": "Noor Un Nisa",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211036,
    "batch": 2
  },
  {
    "name": "Samreen",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211038,
    "batch": 2
  },
  {
    "name": "Shahryar Ali",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211039,
    "batch": 2
  },
  {
    "name": "Sharika Syed",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211040,
    "batch": 2
  },
  {
    "name": "Shazmeena",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211041,
    "batch": 2
  },
  {
    "name": "Shoaib Ahmed Junejo",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211042,
    "batch": 2
  },
  {
    "name": "Sobia Asad",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211043,
    "batch": 2
  },
  {
    "name": "Sohail Ahmed Soomro",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211044,
    "batch": 2
  },
  {
    "name": "Sumair Ali Shaikh",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211045,
    "batch": 2
  },
  {
    "name": "Sumaiya Samreen",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211046,
    "batch": 2
  },
  {
    "name": "Syed Irshad Hussain Shah",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211047,
    "batch": 2
  },
  {
    "name": "Ubaid Ur Rehman",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211048,
    "batch": 2
  },
  {
    "name": "Ume Farwa Maqsood",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211049,
    "batch": 2
  },
  {
    "name": "Waqar Ahmed",
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "certificate_id": 211050,
    "batch": 2
  },
  {
    "name": "Aarif Ali Solangi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210201,
    "batch": 2
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210101,
    "batch": 2
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210202,
    "batch": 2
  },
  {
    "name": "Abdul Moiz Qureshi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210204,
    "batch": 2
  },
  {
    "name": "Abdul Quddus",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210301,
    "batch": 2
  },
  {
    "name": "Abdul Qudoos",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210103,
    "batch": 2
  },
  {
    "name": "Abdul Saboor",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210302,
    "batch": 2
  },
  {
    "name": "Abdul Wajid",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271503,
    "batch": 2
  },
  {
    "name": "Abdullah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271504,
    "batch": 2
  },
  {
    "name": "Adil Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210303,
    "batch": 2
  },
  {
    "name": "Adil Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271505,
    "batch": 2
  },
  {
    "name": "Aima Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210304,
    "batch": 2
  },
  {
    "name": "Aiman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210206,
    "batch": 2
  },
  {
    "name": "Ali Asghar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210207,
    "batch": 2
  },
  {
    "name": "Ali Jan Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271507,
    "batch": 2
  },
  {
    "name": "Ali Mehdi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210105,
    "batch": 2
  },
  {
    "name": "Aliza Attaullah Bhatti",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271509,
    "batch": 2
  },
  {
    "name": "Aliza Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210107,
    "batch": 2
  },
  {
    "name": "Aliza Mahar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210305,
    "batch": 2
  },
  {
    "name": "Aliza Parveen",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210208,
    "batch": 2
  },
  {
    "name": "Altaf Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210108,
    "batch": 2
  },
  {
    "name": "Amber Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210209,
    "batch": 2
  },
  {
    "name": "Ammara Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210109,
    "batch": 2
  },
  {
    "name": "Amna Rehman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210110,
    "batch": 2
  },
  {
    "name": "Anisha Batra",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271511,
    "batch": 2
  },
  {
    "name": "Anosha Imdad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210306,
    "batch": 2
  },
  {
    "name": "Aqib Javed Shahbaz",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210111,
    "batch": 2
  },
  {
    "name": "Areeba Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210210,
    "batch": 2
  },
  {
    "name": "Areeba Khoso",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210211,
    "batch": 2
  },
  {
    "name": "Arij Awan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210112,
    "batch": 2
  },
  {
    "name": "Asif Ali Mirani",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210113,
    "batch": 2
  },
  {
    "name": "Atif Ubed Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210114,
    "batch": 2
  },
  {
    "name": "Awais Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210115,
    "batch": 2
  },
  {
    "name": "Ayesha Abbasi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271512,
    "batch": 2
  },
  {
    "name": "Ayesha Farooq",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210116,
    "batch": 2
  },
  {
    "name": "Bisma Khalil",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210214,
    "batch": 2
  },
  {
    "name": "Faiza Gull Bhutto",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271514,
    "batch": 2
  },
  {
    "name": "Fardeen Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210215,
    "batch": 2
  },
  {
    "name": "Faryal Gul Bhutto",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271517,
    "batch": 2
  },
  {
    "name": "Fazila Jagirani",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271518,
    "batch": 2
  },
  {
    "name": "Fiza Naz",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210119,
    "batch": 2
  },
  {
    "name": "Ghazanfar Qazi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271519,
    "batch": 2
  },
  {
    "name": "Ghulam Hyder",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210307,
    "batch": 2
  },
  {
    "name": "Hadiqa Noor Ansari",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210216,
    "batch": 2
  },
  {
    "name": "Hafsa Noor",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271521,
    "batch": 2
  },
  {
    "name": "Hajira",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210308,
    "batch": 2
  },
  {
    "name": "Hammad Makhdoom",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271522,
    "batch": 2
  },
  {
    "name": "Hansa Kalwar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271523,
    "batch": 2
  },
  {
    "name": "Haseeb Ullah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210218,
    "batch": 2
  },
  {
    "name": "Hassan Imdad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271524,
    "batch": 2
  },
  {
    "name": "Hassan Raza",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210309,
    "batch": 2
  },
  {
    "name": "Huma Rizwan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210219,
    "batch": 2
  },
  {
    "name": "Hussain Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271526,
    "batch": 2
  },
  {
    "name": "Hussain Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210120,
    "batch": 2
  },
  {
    "name": "Hussain Mehdi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271527,
    "batch": 2
  },
  {
    "name": "Inamullah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210121,
    "batch": 2
  },
  {
    "name": "Iqra Bhatti",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210310,
    "batch": 2
  },
  {
    "name": "Iqra Rajput",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271528,
    "batch": 2
  },
  {
    "name": "Kalsoom Mangi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271530,
    "batch": 2
  },
  {
    "name": "Kamran Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210311,
    "batch": 2
  },
  {
    "name": "Kashaf Zehra",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210223,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271532,
    "batch": 2
  },
  {
    "name": "Kashish Nooruddin",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210224,
    "batch": 2
  },
  {
    "name": "Khushboo Hubdar Mirani",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271533,
    "batch": 2
  },
  {
    "name": "Kiran Iqbal",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210312,
    "batch": 2
  },
  {
    "name": "Lareb Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210313,
    "batch": 2
  },
  {
    "name": "Lareeb Mangi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210123,
    "batch": 2
  },
  {
    "name": "Mansoor Ul Haque Pitafi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271535,
    "batch": 2
  },
  {
    "name": "Maria Lodhi Pathan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271536,
    "batch": 2
  },
  {
    "name": "Marvi Memon",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210227,
    "batch": 2
  },
  {
    "name": "Maryam Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210314,
    "batch": 2
  },
  {
    "name": "Maryam Mukhtiar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210315,
    "batch": 2
  },
  {
    "name": "Maryam Zulfiqar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210124,
    "batch": 2
  },
  {
    "name": "Mehak Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210316,
    "batch": 2
  },
  {
    "name": "Mehak Lalwani",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210228,
    "batch": 2
  },
  {
    "name": "Mehreen Fatima Mughal",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210126,
    "batch": 2
  },
  {
    "name": "Mehtab",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271538,
    "batch": 2
  },
  {
    "name": "Mehza Jawaid",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210127,
    "batch": 2
  },
  {
    "name": "Memoona Jawad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210128,
    "batch": 2
  },
  {
    "name": "Misbah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210230,
    "batch": 2
  },
  {
    "name": "Mohammad Yamman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210129,
    "batch": 2
  },
  {
    "name": "Moiz Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210130,
    "batch": 2
  },
  {
    "name": "Mudasir Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271539,
    "batch": 2
  },
  {
    "name": "Muhammad  Rasheed Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210317,
    "batch": 2
  },
  {
    "name": "Muhammad Aliyan Web",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210231,
    "batch": 2
  },
  {
    "name": "Muhammad Bilal Anwar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210131,
    "batch": 2
  },
  {
    "name": "Muhammad Danyal Yaseen",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210132,
    "batch": 2
  },
  {
    "name": "Muhammad Hamza Qureshi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210133,
    "batch": 2
  },
  {
    "name": "Muhammad Hunaiz",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210232,
    "batch": 2
  },
  {
    "name": "Muhammad Hussain Shahzad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210134,
    "batch": 2
  },
  {
    "name": "Muhammad Ibrahim",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210318,
    "batch": 2
  },
  {
    "name": "Muhammad Ishaque",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210135,
    "batch": 2
  },
  {
    "name": "Muhammad Kashif Qureshi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210319,
    "batch": 2
  },
  {
    "name": "Muhammad Muzammil",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210136,
    "batch": 2
  },
  {
    "name": "Muhammad Shaheer",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210320,
    "batch": 2
  },
  {
    "name": "Muhammad Shees Raza Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210233,
    "batch": 2
  },
  {
    "name": "Muhammad Shehryar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210137,
    "batch": 2
  },
  {
    "name": "Muhammad Siddique",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210138,
    "batch": 2
  },
  {
    "name": "Muhammad Suhan Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210139,
    "batch": 2
  },
  {
    "name": "Muhammad Umair Ansari",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210321,
    "batch": 2
  },
  {
    "name": "Muhammad Usman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210140,
    "batch": 2
  },
  {
    "name": "Muhammad Usman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210322,
    "batch": 2
  },
  {
    "name": "Muhammad Zohaib Raza",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210234,
    "batch": 2
  },
  {
    "name": "Muskan Batool Abro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210323,
    "batch": 2
  },
  {
    "name": "Muzammil",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271541,
    "batch": 2
  },
  {
    "name": "Naresh Kumar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271542,
    "batch": 2
  },
  {
    "name": "Naseebullah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210141,
    "batch": 2
  },
  {
    "name": "Natasha",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210142,
    "batch": 2
  },
  {
    "name": "Noor Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210324,
    "batch": 2
  },
  {
    "name": "Noor Ul Ain Abro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210143,
    "batch": 2
  },
  {
    "name": "Parwana Kumar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271543,
    "batch": 2
  },
  {
    "name": "Qalb E Abbas",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210325,
    "batch": 2
  },
  {
    "name": "Rabeea Kashaf Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210144,
    "batch": 2
  },
  {
    "name": "Raheela",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210326,
    "batch": 2
  },
  {
    "name": "Rahemeen Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210327,
    "batch": 2
  },
  {
    "name": "Ramsha Balouch",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210328,
    "batch": 2
  },
  {
    "name": "Roheena Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271546,
    "batch": 2
  },
  {
    "name": "Ruhab Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210329,
    "batch": 2
  },
  {
    "name": "Rukhsar Hassan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210235,
    "batch": 2
  },
  {
    "name": "Ruqiya Mumtaz Bhatti",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210330,
    "batch": 2
  },
  {
    "name": "Saad Hafeez",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210331,
    "batch": 2
  },
  {
    "name": "Sadaf",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271547,
    "batch": 2
  },
  {
    "name": "Sadia",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210332,
    "batch": 2
  },
  {
    "name": "Sadia Malik",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271548,
    "batch": 2
  },
  {
    "name": "Saira Jumani",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210237,
    "batch": 2
  },
  {
    "name": "Sajid Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210333,
    "batch": 2
  },
  {
    "name": "Sajida Chachar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210145,
    "batch": 2
  },
  {
    "name": "Sameer",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210334,
    "batch": 2
  },
  {
    "name": "Samreen Hussain Bux",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210238,
    "batch": 2
  },
  {
    "name": "Sana Ayaz",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210239,
    "batch": 2
  },
  {
    "name": "Sanam Bhatti",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210335,
    "batch": 2
  },
  {
    "name": "Saqib Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210240,
    "batch": 2
  },
  {
    "name": "Saqib Ali Mahar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271551,
    "batch": 2
  },
  {
    "name": "Shafi Muhammad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210336,
    "batch": 2
  },
  {
    "name": "Shagufta Channa",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210146,
    "batch": 2
  },
  {
    "name": "Shahbaz Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210242,
    "batch": 2
  },
  {
    "name": "Shahzeb Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271554,
    "batch": 2
  },
  {
    "name": "Sher Ali Chohan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271555,
    "batch": 2
  },
  {
    "name": "Shifa",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210243,
    "batch": 2
  },
  {
    "name": "Shifa Tahzeeb",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210337,
    "batch": 2
  },
  {
    "name": "Shoaib Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210338,
    "batch": 2
  },
  {
    "name": "Sidhant Shive",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210148,
    "batch": 2
  },
  {
    "name": "Sidra Mahar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210339,
    "batch": 2
  },
  {
    "name": "Sineha Dhomeja",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271556,
    "batch": 2
  },
  {
    "name": "Siraj Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210244,
    "batch": 2
  },
  {
    "name": "Sobiya Shah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210149,
    "batch": 2
  },
  {
    "name": "Sohail Ahmed Khuharo",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210245,
    "batch": 2
  },
  {
    "name": "Suhana Fatima Memon",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210340,
    "batch": 2
  },
  {
    "name": "Sumair Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210246,
    "batch": 2
  },
  {
    "name": "Sumair Shaikh",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210341,
    "batch": 2
  },
  {
    "name": "Sumaiya Sanober",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210247,
    "batch": 2
  },
  {
    "name": "Sumia",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271557,
    "batch": 2
  },
  {
    "name": "Syed Hasnain Hyder",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210342,
    "batch": 2
  },
  {
    "name": "Syed Tania Noor",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271558,
    "batch": 2
  },
  {
    "name": "Syeda Aqsa",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271559,
    "batch": 2
  },
  {
    "name": "Syeda Iqra Noor",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271560,
    "batch": 2
  },
  {
    "name": "Ubaidullah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210248,
    "batch": 2
  },
  {
    "name": "Umair Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210249,
    "batch": 2
  },
  {
    "name": "Ume Ruman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210343,
    "batch": 2
  },
  {
    "name": "Urooj Channa",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210152,
    "batch": 2
  },
  {
    "name": "Urooj Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210344,
    "batch": 2
  },
  {
    "name": "Urooj Naeem",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210345,
    "batch": 2
  },
  {
    "name": "Uzair Ali Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271562,
    "batch": 2
  },
  {
    "name": "Uzma Parveen",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210250,
    "batch": 2
  },
  {
    "name": "Wahida Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210251,
    "batch": 2
  },
  {
    "name": "Wajeeha Zainab",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210252,
    "batch": 2
  },
  {
    "name": "Zain Ul Abdin",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210346,
    "batch": 2
  },
  {
    "name": "Zamzam Soomro",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210253,
    "batch": 2
  },
  {
    "name": "Zubair  Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210254,
    "batch": 2
  },
  {
    "name": "Abdul Basit",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210601,
    "batch": 2
  },
  {
    "name": "Abdul Haseeb",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271601,
    "batch": 2
  },
  {
    "name": "Abdul Maalik Bhutto",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271602,
    "batch": 2
  },
  {
    "name": "Abdul Mueed",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210602,
    "batch": 2
  },
  {
    "name": "Abdul Qayoom Bhutto",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271604,
    "batch": 2
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210603,
    "batch": 2
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210604,
    "batch": 2
  },
  {
    "name": "Abdul Sami",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210606,
    "batch": 2
  },
  {
    "name": "Adeel Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210607,
    "batch": 2
  },
  {
    "name": "Ahmed Abro",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271607,
    "batch": 2
  },
  {
    "name": "Ali Bux",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271609,
    "batch": 2
  },
  {
    "name": "Ali Jan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271610,
    "batch": 2
  },
  {
    "name": "Ali Raza Solangi",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210608,
    "batch": 2
  },
  {
    "name": "Alishba",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210609,
    "batch": 2
  },
  {
    "name": "Aliza Riaz",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210610,
    "batch": 2
  },
  {
    "name": "Aqsa Khalid",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210611,
    "batch": 2
  },
  {
    "name": "Areesha Irfan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210612,
    "batch": 2
  },
  {
    "name": "Ayesha",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210613,
    "batch": 2
  },
  {
    "name": "Azhar Abbas Mughal",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271615,
    "batch": 2
  },
  {
    "name": "Bahawal Khan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210671,
    "batch": 2
  },
  {
    "name": "Farhan  Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271616,
    "batch": 2
  },
  {
    "name": "Fariha Hassan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210615,
    "batch": 2
  },
  {
    "name": "Ghulam Nabi",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210616,
    "batch": 2
  },
  {
    "name": "Hasnain Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271618,
    "batch": 2
  },
  {
    "name": "Hassan Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271619,
    "batch": 2
  },
  {
    "name": "Hassan Raza dharejo",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271621,
    "batch": 2
  },
  {
    "name": "Insha Shaikh",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210618,
    "batch": 2
  },
  {
    "name": "Kaneez Fatima Balouch",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271623,
    "batch": 2
  },
  {
    "name": "Lareb Hassan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210622,
    "batch": 2
  },
  {
    "name": "M.Uffaif",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210623,
    "batch": 2
  },
  {
    "name": "Masham Fatima",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210624,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210625,
    "batch": 2
  },
  {
    "name": "Mudasir Hussain",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271626,
    "batch": 2
  },
  {
    "name": "Muhammad Ahmed Saleem",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271628,
    "batch": 2
  },
  {
    "name": "Muhammad Ahsan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210626,
    "batch": 2
  },
  {
    "name": "Muhammad Akram",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271629,
    "batch": 2
  },
  {
    "name": "Muhammad Areeb",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271630,
    "batch": 2
  },
  {
    "name": "Muhammad Ashraf",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271632,
    "batch": 2
  },
  {
    "name": "Muhammad Bilal Meo",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271633,
    "batch": 2
  },
  {
    "name": "Muhammad Hafeez Jalbani",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271634,
    "batch": 2
  },
  {
    "name": "Muhammad Hamza",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210627,
    "batch": 2
  },
  {
    "name": "Muhammad Najam Us Saqib",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271636,
    "batch": 2
  },
  {
    "name": "Muhammad Rehan Tasneem",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210629,
    "batch": 2
  },
  {
    "name": "Muhammad Roohallah",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210630,
    "batch": 2
  },
  {
    "name": "Muhammad Saqib",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210631,
    "batch": 2
  },
  {
    "name": "Muhammad Saqib Qureshi",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210632,
    "batch": 2
  },
  {
    "name": "Muhammad Umar Ansari",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271638,
    "batch": 2
  },
  {
    "name": "Muhammad Yousif Siddiqui",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210672,
    "batch": 2
  },
  {
    "name": "Muskan Mariyam",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210634,
    "batch": 2
  },
  {
    "name": "Muskan Memon",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271639,
    "batch": 2
  },
  {
    "name": "Qurat Ul Ain",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210635,
    "batch": 2
  },
  {
    "name": "Rehan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210636,
    "batch": 2
  },
  {
    "name": "Rehan Khan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271640,
    "batch": 2
  },
  {
    "name": "Sajjad Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271642,
    "batch": 2
  },
  {
    "name": "Sakshi Talreja",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210639,
    "batch": 2
  },
  {
    "name": "Samia Afzal Mughal",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271644,
    "batch": 2
  },
  {
    "name": "Saqib Javed Shahzad",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210641,
    "batch": 2
  },
  {
    "name": "Sarkar Hussain Shah",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271645,
    "batch": 2
  },
  {
    "name": "Satiwan Larai",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271646,
    "batch": 2
  },
  {
    "name": "Sehrish Riazuddin",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210642,
    "batch": 2
  },
  {
    "name": "Shah Ali Zaib",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210643,
    "batch": 2
  },
  {
    "name": "Shah Muhammad Shah",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271647,
    "batch": 2
  },
  {
    "name": "Shaharyar Qadir Khokhar",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210644,
    "batch": 2
  },
  {
    "name": "Shaheryar Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271648,
    "batch": 2
  },
  {
    "name": "Shaiza Abbasi",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271649,
    "batch": 2
  },
  {
    "name": "Sharih Hassan",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271650,
    "batch": 2
  },
  {
    "name": "Shehryar Dahar",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271652,
    "batch": 2
  },
  {
    "name": "Sofia Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210647,
    "batch": 2
  },
  {
    "name": "Suhail Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271653,
    "batch": 2
  },
  {
    "name": "Summaiya Shaikh",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210649,
    "batch": 2
  },
  {
    "name": "Sundas Tariq",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271655,
    "batch": 2
  },
  {
    "name": "Syed Aftab Hyder",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210651,
    "batch": 2
  },
  {
    "name": "Syed Mehdi Raza",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271656,
    "batch": 2
  },
  {
    "name": "Tahmena",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210652,
    "batch": 2
  },
  {
    "name": "Umaima",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271658,
    "batch": 2
  },
  {
    "name": "Vinesh Kumar Alies Shankar Lal",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271660,
    "batch": 2
  },
  {
    "name": "Waqar Ali Memon",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271663,
    "batch": 2
  },
  {
    "name": "Yasir Nawaz",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210653,
    "batch": 2
  },
  {
    "name": "Zahra Fatima",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 210654,
    "batch": 2
  },
  {
    "name": "Zeeshan Ali",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271664,
    "batch": 2
  },
  {
    "name": "Zeeshan Ali Channa",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271665,
    "batch": 2
  },
  {
    "name": "Zenab Shaikh",
    "course": "Certified E-Commerce Professional",
    "center": "Sukkur IBA University",
    "certificate_id": 271666,
    "batch": 2
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210401,
    "batch": 2
  },
  {
    "name": "Abdul Hayee",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210501,
    "batch": 2
  },
  {
    "name": "Abdul Qayoom",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210402,
    "batch": 2
  },
  {
    "name": "Abdul Rafio",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210502,
    "batch": 2
  },
  {
    "name": "Abdul Wasio Junejo",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271403,
    "batch": 2
  },
  {
    "name": "Abdullah Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210404,
    "batch": 2
  },
  {
    "name": "Afia Nasir",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210503,
    "batch": 2
  },
  {
    "name": "Aisha Anees Sheikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210405,
    "batch": 2
  },
  {
    "name": "Ali Hyder",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210504,
    "batch": 2
  },
  {
    "name": "Ali Nawaz Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271406,
    "batch": 2
  },
  {
    "name": "Ali Waris",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271407,
    "batch": 2
  },
  {
    "name": "Alina Raza Khan Lodhi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210505,
    "batch": 2
  },
  {
    "name": "Alishba Khoso",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210506,
    "batch": 2
  },
  {
    "name": "Aliza Memon",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271408,
    "batch": 2
  },
  {
    "name": "Amisha",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271409,
    "batch": 2
  },
  {
    "name": "Amjad Suhaib",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271410,
    "batch": 2
  },
  {
    "name": "Aniqa Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271411,
    "batch": 2
  },
  {
    "name": "Anisba",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210507,
    "batch": 2
  },
  {
    "name": "Aqsa Abdul Majeed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210508,
    "batch": 2
  },
  {
    "name": "Aqsa Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210509,
    "batch": 2
  },
  {
    "name": "Aqsa Naz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210510,
    "batch": 2
  },
  {
    "name": "Aqsa Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210511,
    "batch": 2
  },
  {
    "name": "Areeba Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210406,
    "batch": 2
  },
  {
    "name": "Arifa Soomro",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210407,
    "batch": 2
  },
  {
    "name": "Aseem Raheem",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210408,
    "batch": 2
  },
  {
    "name": "Ashique Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210512,
    "batch": 2
  },
  {
    "name": "Asif Hussain Jatoi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271414,
    "batch": 2
  },
  {
    "name": "Ayesha Imdad Jumani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210513,
    "batch": 2
  },
  {
    "name": "Ayesha Syed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271415,
    "batch": 2
  },
  {
    "name": "Azam",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210409,
    "batch": 2
  },
  {
    "name": "Babar Ali Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271416,
    "batch": 2
  },
  {
    "name": "Bisma Zaheer",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210514,
    "batch": 2
  },
  {
    "name": "Diya Kalra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271417,
    "batch": 2
  },
  {
    "name": "Dua Akhtar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210515,
    "batch": 2
  },
  {
    "name": "Dua Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271418,
    "batch": 2
  },
  {
    "name": "Dua Noor",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271419,
    "batch": 2
  },
  {
    "name": "Duaa Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210516,
    "batch": 2
  },
  {
    "name": "Falak Naz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210517,
    "batch": 2
  },
  {
    "name": "Fiza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271420,
    "batch": 2
  },
  {
    "name": "Gul Bahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210518,
    "batch": 2
  },
  {
    "name": "Hadia Channa",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210519,
    "batch": 2
  },
  {
    "name": "Hafiz Zaid Siddiqui",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271421,
    "batch": 2
  },
  {
    "name": "Hammadullah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210520,
    "batch": 2
  },
  {
    "name": "Hamza",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210521,
    "batch": 2
  },
  {
    "name": "Hamza Hamayoon",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210410,
    "batch": 2
  },
  {
    "name": "Hanzallah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210411,
    "batch": 2
  },
  {
    "name": "Hasnain Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210412,
    "batch": 2
  },
  {
    "name": "Hassam Muhammad",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210414,
    "batch": 2
  },
  {
    "name": "Heer Dadlani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271422,
    "batch": 2
  },
  {
    "name": "Hira Shah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271423,
    "batch": 2
  },
  {
    "name": "Ifat",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210415,
    "batch": 2
  },
  {
    "name": "Imran Ali Sahito",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271425,
    "batch": 2
  },
  {
    "name": "Iqra Gul Jatoi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271427,
    "batch": 2
  },
  {
    "name": "Iqra Momin",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210522,
    "batch": 2
  },
  {
    "name": "Iqra Siddiqui",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271428,
    "batch": 2
  },
  {
    "name": "Isra Maryam",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210416,
    "batch": 2
  },
  {
    "name": "Javeria",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210417,
    "batch": 2
  },
  {
    "name": "Javeria Khoso",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210523,
    "batch": 2
  },
  {
    "name": "Jaweria Fayyaz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210418,
    "batch": 2
  },
  {
    "name": "Kainat Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271429,
    "batch": 2
  },
  {
    "name": "Kamran Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271430,
    "batch": 2
  },
  {
    "name": "Kaneez Zainab Bhutto",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271431,
    "batch": 2
  },
  {
    "name": "Labaik Hawa",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210525,
    "batch": 2
  },
  {
    "name": "Lareb",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210420,
    "batch": 2
  },
  {
    "name": "Mahnoor Rizvi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210526,
    "batch": 2
  },
  {
    "name": "Maira Zulfiqar Mirani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271432,
    "batch": 2
  },
  {
    "name": "Maria Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210421,
    "batch": 2
  },
  {
    "name": "Maryam Shah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210422,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210528,
    "batch": 2
  },
  {
    "name": "Mehak",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210527,
    "batch": 2
  },
  {
    "name": "Mehak Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210424,
    "batch": 2
  },
  {
    "name": "Mehak Ali Rajput",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271433,
    "batch": 2
  },
  {
    "name": "Mehak Zehra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271434,
    "batch": 2
  },
  {
    "name": "Mehwish Gul",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210529,
    "batch": 2
  },
  {
    "name": "Misbah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210530,
    "batch": 2
  },
  {
    "name": "Mohammad Qasim",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271436,
    "batch": 2
  },
  {
    "name": "Muhammad Abubakar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271437,
    "batch": 2
  },
  {
    "name": "Muhammad Furqan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271439,
    "batch": 2
  },
  {
    "name": "Muhammad Irtaza Shah",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271440,
    "batch": 2
  },
  {
    "name": "Muhammad Mudasir",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210425,
    "batch": 2
  },
  {
    "name": "Muhammad Murad",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210531,
    "batch": 2
  },
  {
    "name": "Muhammad Saad",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210427,
    "batch": 2
  },
  {
    "name": "Muhammad Saqib Sawand",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271441,
    "batch": 2
  },
  {
    "name": "Muhammad Sufyan Arain",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271442,
    "batch": 2
  },
  {
    "name": "Muhammad Taaha",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210429,
    "batch": 2
  },
  {
    "name": "Muhammad Usman",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271443,
    "batch": 2
  },
  {
    "name": "Muntazir Mehdi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271444,
    "batch": 2
  },
  {
    "name": "Muqadas Taufeeque",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210533,
    "batch": 2
  },
  {
    "name": "Murk",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271445,
    "batch": 2
  },
  {
    "name": "Muskan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210534,
    "batch": 2
  },
  {
    "name": "Muskan Kalra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271447,
    "batch": 2
  },
  {
    "name": "Muskan Khokhar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210430,
    "batch": 2
  },
  {
    "name": "Nosheen Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271450,
    "batch": 2
  },
  {
    "name": "Prena Kumari",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210536,
    "batch": 2
  },
  {
    "name": "Qurat Ul Ain",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210432,
    "batch": 2
  },
  {
    "name": "Qurba Zehra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210433,
    "batch": 2
  },
  {
    "name": "Rabia Qureshi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210537,
    "batch": 2
  },
  {
    "name": "Rida Khursheed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210538,
    "batch": 2
  },
  {
    "name": "Rizwan Ahmed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210435,
    "batch": 2
  },
  {
    "name": "Rubab",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210539,
    "batch": 2
  },
  {
    "name": "Ruqiya",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210436,
    "batch": 2
  },
  {
    "name": "Saad Ali Abbasi",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210437,
    "batch": 2
  },
  {
    "name": "Sadia Memon",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271451,
    "batch": 2
  },
  {
    "name": "Saeeda Awan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210438,
    "batch": 2
  },
  {
    "name": "Saima Mughal",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271452,
    "batch": 2
  },
  {
    "name": "Saman Naz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210440,
    "batch": 2
  },
  {
    "name": "Sania Lashari Baloch",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210441,
    "batch": 2
  },
  {
    "name": "Sanjeeda Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271454,
    "batch": 2
  },
  {
    "name": "Saqlain Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271455,
    "batch": 2
  },
  {
    "name": "Shagufta Habib",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210540,
    "batch": 2
  },
  {
    "name": "Shah Fahad",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210541,
    "batch": 2
  },
  {
    "name": "Shah Zain Memon",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210444,
    "batch": 2
  },
  {
    "name": "Shahnaz Narejo",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210542,
    "batch": 2
  },
  {
    "name": "Sidra Tulmuntaha Malik Awan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271456,
    "batch": 2
  },
  {
    "name": "Simriti",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210543,
    "batch": 2
  },
  {
    "name": "Sineha Kumari Keswani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271457,
    "batch": 2
  },
  {
    "name": "Siya Bajaj",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210445,
    "batch": 2
  },
  {
    "name": "Soha Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210447,
    "batch": 2
  },
  {
    "name": "Soohan Mariyam",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271459,
    "batch": 2
  },
  {
    "name": "Sumaiya",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210544,
    "batch": 2
  },
  {
    "name": "Sumaiya Gull",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210448,
    "batch": 2
  },
  {
    "name": "Tamjeed Noor",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210545,
    "batch": 2
  },
  {
    "name": "Tanya Jagirani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271461,
    "batch": 2
  },
  {
    "name": "Tazeen Fatima",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210449,
    "batch": 2
  },
  {
    "name": "Tehmina Abdul Jabbar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210450,
    "batch": 2
  },
  {
    "name": "Tuba Mubeen",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210451,
    "batch": 2
  },
  {
    "name": "Umema Balouch",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271463,
    "batch": 2
  },
  {
    "name": "Umm E Habiba",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271464,
    "batch": 2
  },
  {
    "name": "Unsa",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210546,
    "batch": 2
  },
  {
    "name": "Urooj  Zubair",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210547,
    "batch": 2
  },
  {
    "name": "Uzma Rehman",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210549,
    "batch": 2
  },
  {
    "name": "Vaniza Riaz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210452,
    "batch": 2
  },
  {
    "name": "Waheed Ali Mahar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271465,
    "batch": 2
  },
  {
    "name": "Waqar Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210550,
    "batch": 2
  },
  {
    "name": "Washdev Kumar",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210453,
    "batch": 2
  },
  {
    "name": "Yasir Ubaid Makhdoom",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210454,
    "batch": 2
  },
  {
    "name": "Yasrab Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 271466,
    "batch": 2
  },
  {
    "name": "Yusra",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210455,
    "batch": 2
  },
  {
    "name": "Zainab Raees Shaikh",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210456,
    "batch": 2
  },
  {
    "name": "Zamin Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210457,
    "batch": 2
  },
  {
    "name": "Zunaira Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "certificate_id": 210552,
    "batch": 2
  },
  {
    "name": "Abdul Basit Soomro",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210701,
    "batch": 2
  },
  {
    "name": "Abdul Ghani",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210702,
    "batch": 2
  },
  {
    "name": "Abdul Waris Abro",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210704,
    "batch": 2
  },
  {
    "name": "Affan Ahmed",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210706,
    "batch": 2
  },
  {
    "name": "Ali Raza",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210708,
    "batch": 2
  },
  {
    "name": "Alishba Abdul Shakoor",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210709,
    "batch": 2
  },
  {
    "name": "Alishba Bashir",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210710,
    "batch": 2
  },
  {
    "name": "Aliza Chachar",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210711,
    "batch": 2
  },
  {
    "name": "Amar Shiva",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210713,
    "batch": 2
  },
  {
    "name": "Ameer Muawiya",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210714,
    "batch": 2
  },
  {
    "name": "Amir Khan",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210715,
    "batch": 2
  },
  {
    "name": "Bisma",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210719,
    "batch": 2
  },
  {
    "name": "Eisha",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210720,
    "batch": 2
  },
  {
    "name": "Faisal",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210721,
    "batch": 2
  },
  {
    "name": "Fatima Zamir",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210722,
    "batch": 2
  },
  {
    "name": "Ghulam Muhammad",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210723,
    "batch": 2
  },
  {
    "name": "Hirdesh Lalwani",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210724,
    "batch": 2
  },
  {
    "name": "Humza Ali",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210725,
    "batch": 2
  },
  {
    "name": "Khalid Hussain",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210727,
    "batch": 2
  },
  {
    "name": "Mahnoor Kehar",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210729,
    "batch": 2
  },
  {
    "name": "Mashood Qureshi",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210730,
    "batch": 2
  },
  {
    "name": "Meharunissa Solangi",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210731,
    "batch": 2
  },
  {
    "name": "Mohsin Ali Channa",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210732,
    "batch": 2
  },
  {
    "name": "Mudassir Hussain Solangi",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210733,
    "batch": 2
  },
  {
    "name": "Muhammad Abubakar Mahar",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210734,
    "batch": 2
  },
  {
    "name": "Muhammad Ans",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210735,
    "batch": 2
  },
  {
    "name": "Muhammad Furqan Jatoi",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210737,
    "batch": 2
  },
  {
    "name": "Muhammad Huzaifa",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210738,
    "batch": 2
  },
  {
    "name": "Muhammad Muaz Shaikh",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210739,
    "batch": 2
  },
  {
    "name": "Muhammad Salman",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210740,
    "batch": 2
  },
  {
    "name": "Muhammad Usman Khan",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210741,
    "batch": 2
  },
  {
    "name": "Naeem Ahmed",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210743,
    "batch": 2
  },
  {
    "name": "Naveed  Hussain",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210744,
    "batch": 2
  },
  {
    "name": "Nazia Khatoon",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210745,
    "batch": 2
  },
  {
    "name": "Neeta Kumari",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210746,
    "batch": 2
  },
  {
    "name": "Raees Aurangzaib",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210747,
    "batch": 2
  },
  {
    "name": "Roshni Kumari",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210748,
    "batch": 2
  },
  {
    "name": "saba",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210718,
    "batch": 2
  },
  {
    "name": "Sanjana Kumari",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210749,
    "batch": 2
  },
  {
    "name": "Shafaque Zehra Urf Maham",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210750,
    "batch": 2
  },
  {
    "name": "Shazia",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210751,
    "batch": 2
  },
  {
    "name": "Sidra Parveen",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210752,
    "batch": 2
  },
  {
    "name": "Waqas Ahmed",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210754,
    "batch": 2
  },
  {
    "name": "Waqas Hussain Dahar",
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210755,
    "batch": 2
  },
  {
    "name": "Abdul Muqeet Shaikh",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210801,
    "batch": 2
  },
  {
    "name": "Ahmed Ali",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210803,
    "batch": 2
  },
  {
    "name": "Amna Batool",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210804,
    "batch": 2
  },
  {
    "name": "Aneeq-Ur-Rehman",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210805,
    "batch": 2
  },
  {
    "name": "Arsheen Zehra",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210806,
    "batch": 2
  },
  {
    "name": "Ayaan Hussain",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210807,
    "batch": 2
  },
  {
    "name": "Ayaz Ahmed",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210808,
    "batch": 2
  },
  {
    "name": "Ayesha Khokhar",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210809,
    "batch": 2
  },
  {
    "name": "Azaf Hussain",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210810,
    "batch": 2
  },
  {
    "name": "Azhar Ali",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210811,
    "batch": 2
  },
  {
    "name": "Eashwar Lal",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210813,
    "batch": 2
  },
  {
    "name": "Fida Hussain",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210814,
    "batch": 2
  },
  {
    "name": "Ghulam Qadir",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210815,
    "batch": 2
  },
  {
    "name": "Hamza Asif",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210816,
    "batch": 2
  },
  {
    "name": "Hooriya Ansari",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210817,
    "batch": 2
  },
  {
    "name": "Husnain",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210818,
    "batch": 2
  },
  {
    "name": "Iqbal Imtiaz Memon",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210819,
    "batch": 2
  },
  {
    "name": "Khadija Fayyaz",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210820,
    "batch": 2
  },
  {
    "name": "Mehtab Hussain",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210825,
    "batch": 2
  },
  {
    "name": "Mir Hassan Khoso",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210826,
    "batch": 2
  },
  {
    "name": "Mudassar Imtiaz Memon",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210827,
    "batch": 2
  },
  {
    "name": "Muhammad Asad",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210828,
    "batch": 2
  },
  {
    "name": "Muhammad Shayan Mirani",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210830,
    "batch": 2
  },
  {
    "name": "Muhammad Zubair",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210831,
    "batch": 2
  },
  {
    "name": "Muqadas Akhound",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210832,
    "batch": 2
  },
  {
    "name": "Noor Fatima",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210833,
    "batch": 2
  },
  {
    "name": "Sadia",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210835,
    "batch": 2
  },
  {
    "name": "Sadia Solangi",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210836,
    "batch": 2
  },
  {
    "name": "Saira",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210837,
    "batch": 2
  },
  {
    "name": "Samiullah",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210838,
    "batch": 2
  },
  {
    "name": "Samreen Bibi",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210839,
    "batch": 2
  },
  {
    "name": "Sehar Shah",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210841,
    "batch": 2
  },
  {
    "name": "Shahrukh Khan",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210842,
    "batch": 2
  },
  {
    "name": "Shahzadi Marium",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210844,
    "batch": 2
  },
  {
    "name": "Sheeraz",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210845,
    "batch": 2
  },
  {
    "name": "Syed Ahmed Ali",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210846,
    "batch": 2
  },
  {
    "name": "Toqeer Ahmed",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210847,
    "batch": 2
  },
  {
    "name": "Usama Pathan",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210849,
    "batch": 2
  },
  {
    "name": "Waheed Ahmed",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210850,
    "batch": 2
  },
  {
    "name": "Zeenat Khan",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210851,
    "batch": 2
  },
  {
    "name": "Zeeshan Ahmed",
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 210852,
    "batch": 2
  },
  {
    "name": "Abdul Musawir Bhumbroo",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271301,
    "batch": 2
  },
  {
    "name": "Adil Ahmed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271302,
    "batch": 2
  },
  {
    "name": "Ali Jan Kamboh",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271303,
    "batch": 2
  },
  {
    "name": "Alisha Memon",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271305,
    "batch": 2
  },
  {
    "name": "Asadullah Mahesar",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271306,
    "batch": 2
  },
  {
    "name": "Humadullah Abro",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271310,
    "batch": 2
  },
  {
    "name": "Iqra Soomro",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271311,
    "batch": 2
  },
  {
    "name": "Kelash Kumar",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271312,
    "batch": 2
  },
  {
    "name": "Khushboo",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271313,
    "batch": 2
  },
  {
    "name": "Laiba Noor Kamboh",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271314,
    "batch": 2
  },
  {
    "name": "Majid Ali",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271315,
    "batch": 2
  },
  {
    "name": "Mehak Dhulani",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271316,
    "batch": 2
  },
  {
    "name": "Mehik Rohro",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271317,
    "batch": 2
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271319,
    "batch": 2
  },
  {
    "name": "Muhammad Anas Memon",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271320,
    "batch": 2
  },
  {
    "name": "Muhammad Arham Qureshi",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271321,
    "batch": 2
  },
  {
    "name": "Muhammad Hamza Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271322,
    "batch": 2
  },
  {
    "name": "Muhammad Umar",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271324,
    "batch": 2
  },
  {
    "name": "Muhammad Usama",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271325,
    "batch": 2
  },
  {
    "name": "Muhtashim Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271327,
    "batch": 2
  },
  {
    "name": "Mushtaque Ali",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271328,
    "batch": 2
  },
  {
    "name": "Nargis Fatima Abbasi",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271329,
    "batch": 2
  },
  {
    "name": "Noman Ali Bhumbro",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271330,
    "batch": 2
  },
  {
    "name": "Riteeka Rohra",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271332,
    "batch": 2
  },
  {
    "name": "Rizwan Ali Channa",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271333,
    "batch": 2
  },
  {
    "name": "Sada Gul Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271334,
    "batch": 2
  },
  {
    "name": "Sajjad",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271335,
    "batch": 2
  },
  {
    "name": "Sakshi Dhulani",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271336,
    "batch": 2
  },
  {
    "name": "Salar Ahmed Balouch",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271337,
    "batch": 2
  },
  {
    "name": "Saleemullah",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271338,
    "batch": 2
  },
  {
    "name": "Sughand Bai",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271341,
    "batch": 2
  },
  {
    "name": "Sumaira Balouch",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271342,
    "batch": 2
  },
  {
    "name": "Suraksha Rohra",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271343,
    "batch": 2
  },
  {
    "name": "Syeda Zunaira Kanwal",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271344,
    "batch": 2
  },
  {
    "name": "Taiba Khan",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271345,
    "batch": 2
  },
  {
    "name": "Umair",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271346,
    "batch": 2
  },
  {
    "name": "Umair Ahmed",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271347,
    "batch": 2
  },
  {
    "name": "Uzair Hussain Arain",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271348,
    "batch": 2
  },
  {
    "name": "Vishaka Dhulani",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271349,
    "batch": 2
  },
  {
    "name": "Zainab Fatima Bhutto",
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271351,
    "batch": 2
  },
  {
    "name": "Abdul Moiz Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271201,
    "batch": 2
  },
  {
    "name": "Abdul Rafay Tarkhan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271103,
    "batch": 2
  },
  {
    "name": "Abdul Sami Dayo",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271202,
    "batch": 2
  },
  {
    "name": "Afraz Khan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271105,
    "batch": 2
  },
  {
    "name": "Ahmed Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271203,
    "batch": 2
  },
  {
    "name": "Ahsan Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271106,
    "batch": 2
  },
  {
    "name": "Ahsan Hassan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271204,
    "batch": 2
  },
  {
    "name": "Ali Akbar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271205,
    "batch": 2
  },
  {
    "name": "Ameenullah Samejo",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271107,
    "batch": 2
  },
  {
    "name": "Ammar Aftab Abro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271109,
    "batch": 2
  },
  {
    "name": "Aqib Ali Mastoi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271206,
    "batch": 2
  },
  {
    "name": "Arif Ali Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271110,
    "batch": 2
  },
  {
    "name": "Arsalan Ahmed Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271208,
    "batch": 2
  },
  {
    "name": "Asad Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271111,
    "batch": 2
  },
  {
    "name": "Asadullah Memon",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271209,
    "batch": 2
  },
  {
    "name": "Azhar Ali Malik",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271112,
    "batch": 2
  },
  {
    "name": "Barkat Ali Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271113,
    "batch": 2
  },
  {
    "name": "Bhoomika Kukreja",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271114,
    "batch": 2
  },
  {
    "name": "Diya Kumari",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271210,
    "batch": 2
  },
  {
    "name": "Dua Rashid",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271115,
    "batch": 2
  },
  {
    "name": "Dureshawar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271116,
    "batch": 2
  },
  {
    "name": "Fahad Ali Sangi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271211,
    "batch": 2
  },
  {
    "name": "Faiza Memon",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271212,
    "batch": 2
  },
  {
    "name": "Faizan Ali Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271117,
    "batch": 2
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271213,
    "batch": 2
  },
  {
    "name": "Fatima Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271118,
    "batch": 2
  },
  {
    "name": "Habib Ullah Mahar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271119,
    "batch": 2
  },
  {
    "name": "Hafiz Mohammad Taha",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271120,
    "batch": 2
  },
  {
    "name": "Hasnain Ali Joyo",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271214,
    "batch": 2
  },
  {
    "name": "Hina Parveen",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271215,
    "batch": 2
  },
  {
    "name": "Hizbullah Khaldi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271121,
    "batch": 2
  },
  {
    "name": "Hussain Tahir",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271216,
    "batch": 2
  },
  {
    "name": "Huzaifa Uddin",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271123,
    "batch": 2
  },
  {
    "name": "Ibrar Ali Chohan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271217,
    "batch": 2
  },
  {
    "name": "Iqra Manan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271218,
    "batch": 2
  },
  {
    "name": "Jawad Ali Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271219,
    "batch": 2
  },
  {
    "name": "Jinsar Ahmed Jatoi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271220,
    "batch": 2
  },
  {
    "name": "Laksh Amarlal",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271127,
    "batch": 2
  },
  {
    "name": "Lareb Zahra",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271221,
    "batch": 2
  },
  {
    "name": "Maaham Naveed Abbasi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271128,
    "batch": 2
  },
  {
    "name": "Maqsood Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271222,
    "batch": 2
  },
  {
    "name": "Mohsin Ali Mangi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271129,
    "batch": 2
  },
  {
    "name": "Mohsin Ali Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271223,
    "batch": 2
  },
  {
    "name": "Mudasir Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271224,
    "batch": 2
  },
  {
    "name": "Muhamamd Junaid",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271130,
    "batch": 2
  },
  {
    "name": "Muhammad Aamir Mangrio",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271131,
    "batch": 2
  },
  {
    "name": "Muhammad Faheem",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271226,
    "batch": 2
  },
  {
    "name": "Muhammad Hammad Arain",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271133,
    "batch": 2
  },
  {
    "name": "Muhammad Hasnain Shaikh",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271134,
    "batch": 2
  },
  {
    "name": "Muhammad Hassan Kalwar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271228,
    "batch": 2
  },
  {
    "name": "Muhammad Ibrahim Mahar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271229,
    "batch": 2
  },
  {
    "name": "Muhammad Rooman",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271136,
    "batch": 2
  },
  {
    "name": "Muhammad Safdar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271230,
    "batch": 2
  },
  {
    "name": "Muhammad Shoaib Memon",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271231,
    "batch": 2
  },
  {
    "name": "Muhammad Taha",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271232,
    "batch": 2
  },
  {
    "name": "Muhammad Taha Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271233,
    "batch": 2
  },
  {
    "name": "Muhammad Talha Soomro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271137,
    "batch": 2
  },
  {
    "name": "Muhammad Waqas",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271234,
    "batch": 2
  },
  {
    "name": "Muhammad Wasiq Siddique",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271138,
    "batch": 2
  },
  {
    "name": "Muhammad Younis Qureshi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271139,
    "batch": 2
  },
  {
    "name": "Muskan Agarwal",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271140,
    "batch": 2
  },
  {
    "name": "Muskan Kukreja",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271235,
    "batch": 2
  },
  {
    "name": "Noor Ghulam Fareed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271141,
    "batch": 2
  },
  {
    "name": "Paras Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271237,
    "batch": 2
  },
  {
    "name": "Raheem Bux",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271142,
    "batch": 2
  },
  {
    "name": "Rehan Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271238,
    "batch": 2
  },
  {
    "name": "Saba Parveen",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271143,
    "batch": 2
  },
  {
    "name": "Sabeen Ul Karim Shaikh",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271239,
    "batch": 2
  },
  {
    "name": "Saira",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271145,
    "batch": 2
  },
  {
    "name": "Salman Alias Adnan Dhalet",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271240,
    "batch": 2
  },
  {
    "name": "Sanam Chandio",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271241,
    "batch": 2
  },
  {
    "name": "Saqlain Abbas",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271242,
    "batch": 2
  },
  {
    "name": "Sejal Kumari",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271148,
    "batch": 2
  },
  {
    "name": "Shafique Ahmed Jatoi",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271243,
    "batch": 2
  },
  {
    "name": "Shahbaz Khan Channa",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271244,
    "batch": 2
  },
  {
    "name": "Shahzada Ayaz Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271150,
    "batch": 2
  },
  {
    "name": "Shahzaib Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271245,
    "batch": 2
  },
  {
    "name": "Shahzeen Bisma",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271246,
    "batch": 2
  },
  {
    "name": "Shakeel Jalal",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271247,
    "batch": 2
  },
  {
    "name": "Shewani Rani",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271152,
    "batch": 2
  },
  {
    "name": "Sughandh",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271248,
    "batch": 2
  },
  {
    "name": "Syed Muhammad Faisal Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271153,
    "batch": 2
  },
  {
    "name": "Syeda Esha",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271250,
    "batch": 2
  },
  {
    "name": "Tasleem Bibi Gurgaje",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271155,
    "batch": 2
  },
  {
    "name": "Urva Khalil Kalhoro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271253,
    "batch": 2
  },
  {
    "name": "Zoha",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271160,
    "batch": 2
  },
  {
    "name": "Zubair Ahmed Channa",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "certificate_id": 271254,
    "batch": 2
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240201,
    "batch": 2
  },
  {
    "name": "Abid Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240202,
    "batch": 2
  },
  {
    "name": "Aftab Nawaz",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240203,
    "batch": 2
  },
  {
    "name": "Azad Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240204,
    "batch": 2
  },
  {
    "name": "Azhar Ali Shah",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240205,
    "batch": 2
  },
  {
    "name": "Habeeb ur Rehman",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240206,
    "batch": 2
  },
  {
    "name": "Iltaf Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240207,
    "batch": 2
  },
  {
    "name": "Israr Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240208,
    "batch": 2
  },
  {
    "name": "Jan Mohammad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240209,
    "batch": 2
  },
  {
    "name": "Kabeer Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240210,
    "batch": 2
  },
  {
    "name": "Maqsood Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240211,
    "batch": 2
  },
  {
    "name": "Maria Bibi",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240212,
    "batch": 2
  },
  {
    "name": "Mariam Gul",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240213,
    "batch": 2
  },
  {
    "name": "Muhammad Aqib",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240214,
    "batch": 2
  },
  {
    "name": "Muhammad Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240215,
    "batch": 2
  },
  {
    "name": "Muhammad Salah U Din",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240216,
    "batch": 2
  },
  {
    "name": "Muhammad Tahir",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240217,
    "batch": 2
  },
  {
    "name": "Muhammad Umar",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240218,
    "batch": 2
  },
  {
    "name": "Muhammad Zaibullah Malik",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240219,
    "batch": 2
  },
  {
    "name": "Naseebullah Channa",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240220,
    "batch": 2
  },
  {
    "name": "Rabia",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240221,
    "batch": 2
  },
  {
    "name": "Rafique Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240222,
    "batch": 2
  },
  {
    "name": "Sain Dino",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240223,
    "batch": 2
  },
  {
    "name": "Shafi Muhammad",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240224,
    "batch": 2
  },
  {
    "name": "Shahab U Din",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240225,
    "batch": 2
  },
  {
    "name": "Shahzad Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240226,
    "batch": 2
  },
  {
    "name": "Shweta",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240227,
    "batch": 2
  },
  {
    "name": "Sineha",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240228,
    "batch": 2
  },
  {
    "name": "Sohail Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240229,
    "batch": 2
  },
  {
    "name": "Zafar Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240230,
    "batch": 2
  },
  {
    "name": "Abdul Manan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240101,
    "batch": 2
  },
  {
    "name": "Abdul Muqsit",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240102,
    "batch": 2
  },
  {
    "name": "Ahssan Aziz",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240103,
    "batch": 2
  },
  {
    "name": "Ali Malik",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240104,
    "batch": 2
  },
  {
    "name": "Barkha",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240105,
    "batch": 2
  },
  {
    "name": "Faryal",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240106,
    "batch": 2
  },
  {
    "name": "Hashir Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240107,
    "batch": 2
  },
  {
    "name": "Lal Abbas",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240108,
    "batch": 2
  },
  {
    "name": "Masood Ahmed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240109,
    "batch": 2
  },
  {
    "name": "Mehvish",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240110,
    "batch": 2
  },
  {
    "name": "Meraj Ahmed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240111,
    "batch": 2
  },
  {
    "name": "Mohammad Saifullah Tabassum",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240112,
    "batch": 2
  },
  {
    "name": "Mohammad Younis",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240113,
    "batch": 2
  },
  {
    "name": "Muhammad Khan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240114,
    "batch": 2
  },
  {
    "name": "Muhammad Ramzan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240115,
    "batch": 2
  },
  {
    "name": "Muhammad Shoaib",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240116,
    "batch": 2
  },
  {
    "name": "Mushtaque Ahmed",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240117,
    "batch": 2
  },
  {
    "name": "Nirmala Thorani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240118,
    "batch": 2
  },
  {
    "name": "Prena Kumari",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240119,
    "batch": 2
  },
  {
    "name": "Prena Parpiani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240120,
    "batch": 2
  },
  {
    "name": "Raja Zafar Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240121,
    "batch": 2
  },
  {
    "name": "Rani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240122,
    "batch": 2
  },
  {
    "name": "Sajid Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240123,
    "batch": 2
  },
  {
    "name": "Sajjad Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240124,
    "batch": 2
  },
  {
    "name": "Salma",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240125,
    "batch": 2
  },
  {
    "name": "Shahid",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240127,
    "batch": 2
  },
  {
    "name": "Shahjehan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240126,
    "batch": 2
  },
  {
    "name": "Shahjehan",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240128,
    "batch": 2
  },
  {
    "name": "Shankar Valecha",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240129,
    "batch": 2
  },
  {
    "name": "Shivani Rani",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240130,
    "batch": 2
  },
  {
    "name": "Shivani Thakur",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240131,
    "batch": 2
  },
  {
    "name": "Sudarshan Lal",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240132,
    "batch": 2
  },
  {
    "name": "Toufeeque Ali",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240133,
    "batch": 2
  },
  {
    "name": "Waseem",
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240134,
    "batch": 2
  },
  {
    "name": "Abdul Basit Buriro",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240301,
    "batch": 2
  },
  {
    "name": "Abdul Samad",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240302,
    "batch": 2
  },
  {
    "name": "Adil Khan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240303,
    "batch": 2
  },
  {
    "name": "Ahmed Raza",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240304,
    "batch": 2
  },
  {
    "name": "Ali Akbar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240305,
    "batch": 2
  },
  {
    "name": "Ali Raza",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240306,
    "batch": 2
  },
  {
    "name": "Ameer Hamza",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240307,
    "batch": 2
  },
  {
    "name": "Anish Dembla",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240308,
    "batch": 2
  },
  {
    "name": "Asad Zeb",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240309,
    "batch": 2
  },
  {
    "name": "Asadullah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240310,
    "batch": 2
  },
  {
    "name": "Athar Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240311,
    "batch": 2
  },
  {
    "name": "Danish Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240312,
    "batch": 2
  },
  {
    "name": "Gulzeb",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240313,
    "batch": 2
  },
  {
    "name": "Hashir Ali Shah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240314,
    "batch": 2
  },
  {
    "name": "Hyder Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240315,
    "batch": 2
  },
  {
    "name": "Iltaf Ali Malik",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240316,
    "batch": 2
  },
  {
    "name": "Imtiaz Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240317,
    "batch": 2
  },
  {
    "name": "Izhar Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240318,
    "batch": 2
  },
  {
    "name": "Kaleemullah",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240319,
    "batch": 2
  },
  {
    "name": "Kashan Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240320,
    "batch": 2
  },
  {
    "name": "Mahtab Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240321,
    "batch": 2
  },
  {
    "name": "Mohammad Asim",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240322,
    "batch": 2
  },
  {
    "name": "Mohsin Ali Awan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240323,
    "batch": 2
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240324,
    "batch": 2
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240325,
    "batch": 2
  },
  {
    "name": "Muhammad Saleem",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240340,
    "batch": 2
  },
  {
    "name": "Naveen Kumar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240326,
    "batch": 2
  },
  {
    "name": "Radhika",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240327,
    "batch": 2
  },
  {
    "name": "Rasheed Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240328,
    "batch": 2
  },
  {
    "name": "Sameer Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240329,
    "batch": 2
  },
  {
    "name": "Shiva",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240330,
    "batch": 2
  },
  {
    "name": "Shoaib Akbar",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240331,
    "batch": 2
  },
  {
    "name": "Shoaib Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240332,
    "batch": 2
  },
  {
    "name": "Shoukat Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240333,
    "batch": 2
  },
  {
    "name": "Sineha Sachdev",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240334,
    "batch": 2
  },
  {
    "name": "Sudha Mandhan",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240335,
    "batch": 2
  },
  {
    "name": "Suhail Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240336,
    "batch": 2
  },
  {
    "name": "Wajid Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240337,
    "batch": 2
  },
  {
    "name": "Yasir Ali",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240338,
    "batch": 2
  },
  {
    "name": "Zubair Ahmed",
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University - Kandhkot Campus",
    "certificate_id": 240339,
    "batch": 2
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250101,
    "batch": 2
  },
  {
    "name": "Abdul Rauf",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250102,
    "batch": 2
  },
  {
    "name": "Adnan",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250103,
    "batch": 2
  },
  {
    "name": "Ali Dost",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250104,
    "batch": 2
  },
  {
    "name": "Ali Hyder",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250105,
    "batch": 2
  },
  {
    "name": "Aqsa",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250106,
    "batch": 2
  },
  {
    "name": "Arshad Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250107,
    "batch": 2
  },
  {
    "name": "Ateeqa",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250108,
    "batch": 2
  },
  {
    "name": "Faheem Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250109,
    "batch": 2
  },
  {
    "name": "Faizan Ansari",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250110,
    "batch": 2
  },
  {
    "name": "Hasnain Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250111,
    "batch": 2
  },
  {
    "name": "Israr Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250112,
    "batch": 2
  },
  {
    "name": "Kashaf Khalil",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250113,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250114,
    "batch": 2
  },
  {
    "name": "Laraib Fatima",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250115,
    "batch": 2
  },
  {
    "name": "Mohammad Mubeen",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250116,
    "batch": 2
  },
  {
    "name": "Mohammd Arsalan",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250117,
    "batch": 2
  },
  {
    "name": "Mohammd Hasnain Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250118,
    "batch": 2
  },
  {
    "name": "Mueez Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250119,
    "batch": 2
  },
  {
    "name": "Muheet",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250120,
    "batch": 2
  },
  {
    "name": "Nadia Noshad",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250121,
    "batch": 2
  },
  {
    "name": "Naveed Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250122,
    "batch": 2
  },
  {
    "name": "Qaisar Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250123,
    "batch": 2
  },
  {
    "name": "Sadam Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250124,
    "batch": 2
  },
  {
    "name": "Sahar",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250125,
    "batch": 2
  },
  {
    "name": "Saniya Khatoon",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250126,
    "batch": 2
  },
  {
    "name": "Sayed Sehla Batool",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250127,
    "batch": 2
  },
  {
    "name": "Shahzaib Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250128,
    "batch": 2
  },
  {
    "name": "Shoib Ahmed wagan",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250129,
    "batch": 2
  },
  {
    "name": "Sumeer Hussain",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250130,
    "batch": 2
  },
  {
    "name": "Tahir Bhutto",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250131,
    "batch": 2
  },
  {
    "name": "Waqar",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250132,
    "batch": 2
  },
  {
    "name": "Waqas u Rehman",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250133,
    "batch": 2
  },
  {
    "name": "Waroon Kumar",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250134,
    "batch": 2
  },
  {
    "name": "Zaheer Ali",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250135,
    "batch": 2
  },
  {
    "name": "Zaib un nissa",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250136,
    "batch": 2
  },
  {
    "name": "Zain ul Abideen",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250137,
    "batch": 2
  },
  {
    "name": "Zuhaib Ahmed",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250138,
    "batch": 2
  },
  {
    "name": "Zuhaib Khan",
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250139,
    "batch": 2
  },
  {
    "name": "Abdul sami",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250501,
    "batch": 2
  },
  {
    "name": "Abdullah",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250502,
    "batch": 2
  },
  {
    "name": "Ahmed Raza Abbasi",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250503,
    "batch": 2
  },
  {
    "name": "Ali Hyder",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250504,
    "batch": 2
  },
  {
    "name": "Bashir Ali",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250505,
    "batch": 2
  },
  {
    "name": "Ghulam hyder",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250506,
    "batch": 2
  },
  {
    "name": "Haseebullah",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250507,
    "batch": 2
  },
  {
    "name": "Jawad Ahmed Shaikh",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250508,
    "batch": 2
  },
  {
    "name": "Moiz-u-Rehman",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250509,
    "batch": 2
  },
  {
    "name": "Mubashir",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250510,
    "batch": 2
  },
  {
    "name": "Muhammad Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250511,
    "batch": 2
  },
  {
    "name": "Muhammad Daniyal",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250512,
    "batch": 2
  },
  {
    "name": "Muhammad hasnain",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250513,
    "batch": 2
  },
  {
    "name": "Muhammad Mohsin",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250514,
    "batch": 2
  },
  {
    "name": "Muhammad Nawaz",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250515,
    "batch": 2
  },
  {
    "name": "Muhammad Rafay Shaikh",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250516,
    "batch": 2
  },
  {
    "name": "Muhammad Yousif",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250517,
    "batch": 2
  },
  {
    "name": "Muzamil",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250518,
    "batch": 2
  },
  {
    "name": "Sadaqat Ali",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250519,
    "batch": 2
  },
  {
    "name": "Sail Abbas Mangrio",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250520,
    "batch": 2
  },
  {
    "name": "Sarfraz Ahmed",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250521,
    "batch": 2
  },
  {
    "name": "Sher Ali",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250522,
    "batch": 2
  },
  {
    "name": "Shoaib Raza",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250523,
    "batch": 2
  },
  {
    "name": "Umaid Ali",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250524,
    "batch": 2
  },
  {
    "name": "Waqas Ali Bhutto",
    "course": "Certified E-Commerce Professional",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250525,
    "batch": 2
  },
  {
    "name": "Aatika Abbasi",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250201,
    "batch": 2
  },
  {
    "name": "Abdul Bari",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250202,
    "batch": 2
  },
  {
    "name": "Abdul Rafay",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250203,
    "batch": 2
  },
  {
    "name": "Abdul Rauf",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250301,
    "batch": 2
  },
  {
    "name": "Abdul Samad Ghaffar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250302,
    "batch": 2
  },
  {
    "name": "Adina Saeed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250204,
    "batch": 2
  },
  {
    "name": "Ahmed Raza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250303,
    "batch": 2
  },
  {
    "name": "Aizaz Habib",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250205,
    "batch": 2
  },
  {
    "name": "Ali Raza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250304,
    "batch": 2
  },
  {
    "name": "Ameer Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250206,
    "batch": 2
  },
  {
    "name": "Ansar Haider",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250305,
    "batch": 2
  },
  {
    "name": "Aun Abbas",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250207,
    "batch": 2
  },
  {
    "name": "Batool",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250306,
    "batch": 2
  },
  {
    "name": "Dua Khokhar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250307,
    "batch": 2
  },
  {
    "name": "Erum shaikh",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250308,
    "batch": 2
  },
  {
    "name": "Faiza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250208,
    "batch": 2
  },
  {
    "name": "Falak Saeed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250209,
    "batch": 2
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250210,
    "batch": 2
  },
  {
    "name": "Farman Ali Larik",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250211,
    "batch": 2
  },
  {
    "name": "Farman Ali Mirani",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250212,
    "batch": 2
  },
  {
    "name": "Farwa Pathan",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250309,
    "batch": 2
  },
  {
    "name": "Ghulam Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250310,
    "batch": 2
  },
  {
    "name": "Ghulam Batool",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250213,
    "batch": 2
  },
  {
    "name": "Ghulam Rasool",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250214,
    "batch": 2
  },
  {
    "name": "Hasnain Abro",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250311,
    "batch": 2
  },
  {
    "name": "Hasnain Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250312,
    "batch": 2
  },
  {
    "name": "Hina Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250215,
    "batch": 2
  },
  {
    "name": "Iqra Kainat",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250216,
    "batch": 2
  },
  {
    "name": "Iqra Mustafa",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250217,
    "batch": 2
  },
  {
    "name": "Irfan Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250313,
    "batch": 2
  },
  {
    "name": "Irfan Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250218,
    "batch": 2
  },
  {
    "name": "Javed Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250314,
    "batch": 2
  },
  {
    "name": "Jawad Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250315,
    "batch": 2
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250219,
    "batch": 2
  },
  {
    "name": "Mairaj Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250316,
    "batch": 2
  },
  {
    "name": "Mariyam Abbasi",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250220,
    "batch": 2
  },
  {
    "name": "Meera Chandio",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250317,
    "batch": 2
  },
  {
    "name": "Mehdi Raza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250221,
    "batch": 2
  },
  {
    "name": "Mudasir",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250318,
    "batch": 2
  },
  {
    "name": "Muhammad Hanif",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250319,
    "batch": 2
  },
  {
    "name": "Muhammad Saleem",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250222,
    "batch": 2
  },
  {
    "name": "Muhammad Yameen",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250320,
    "batch": 2
  },
  {
    "name": "Munaza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250223,
    "batch": 2
  },
  {
    "name": "Muskan Fiza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250224,
    "batch": 2
  },
  {
    "name": "Najaf Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250321,
    "batch": 2
  },
  {
    "name": "Nazeer ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250322,
    "batch": 2
  },
  {
    "name": "Pawan Kumar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250225,
    "batch": 2
  },
  {
    "name": "Pooja",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250323,
    "batch": 2
  },
  {
    "name": "Rehan Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250324,
    "batch": 2
  },
  {
    "name": "Rehman Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250226,
    "batch": 2
  },
  {
    "name": "Sadam Hussain",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250227,
    "batch": 2
  },
  {
    "name": "Sadiya Habib",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250228,
    "batch": 2
  },
  {
    "name": "Safeer",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250325,
    "batch": 2
  },
  {
    "name": "Sajjan Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250326,
    "batch": 2
  },
  {
    "name": "Sameer Hussain",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250327,
    "batch": 2
  },
  {
    "name": "Sandesh",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250229,
    "batch": 2
  },
  {
    "name": "Sandhiya Kumari",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250230,
    "batch": 2
  },
  {
    "name": "Sania Javed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250328,
    "batch": 2
  },
  {
    "name": "Saqlain",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250231,
    "batch": 2
  },
  {
    "name": "Sarang Latif",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250329,
    "batch": 2
  },
  {
    "name": "Shoaib Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250330,
    "batch": 2
  },
  {
    "name": "Sony Tatheer Zahra",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250232,
    "batch": 2
  },
  {
    "name": "Soonh Rani",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250331,
    "batch": 2
  },
  {
    "name": "Sujal Bajaj",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250233,
    "batch": 2
  },
  {
    "name": "Sumaiya Gul",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250234,
    "batch": 2
  },
  {
    "name": "Sumaiya Khokhar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250332,
    "batch": 2
  },
  {
    "name": "Syed Ali Naqi",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250235,
    "batch": 2
  },
  {
    "name": "Toufique Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250236,
    "batch": 2
  },
  {
    "name": "Urooj Fatima",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250333,
    "batch": 2
  },
  {
    "name": "Waheed u Din",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250237,
    "batch": 2
  },
  {
    "name": "Waqar Ali Shah",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250334,
    "batch": 2
  },
  {
    "name": "Zeeshan Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250238,
    "batch": 2
  },
  {
    "name": "Zia Rehman",
    "course": "Certified Graphic Designer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250335,
    "batch": 2
  },
  {
    "name": "Abdul Rauf",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250401,
    "batch": 2
  },
  {
    "name": "Ahmed Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250402,
    "batch": 2
  },
  {
    "name": "Ali Akbar",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250403,
    "batch": 2
  },
  {
    "name": "ALIZA",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250404,
    "batch": 2
  },
  {
    "name": "AllahBux Soomro",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250405,
    "batch": 2
  },
  {
    "name": "Aqsa larik",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250406,
    "batch": 2
  },
  {
    "name": "Ashfaq hussain",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250407,
    "batch": 2
  },
  {
    "name": "Asma Abro",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250408,
    "batch": 2
  },
  {
    "name": "Attaullah",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250409,
    "batch": 2
  },
  {
    "name": "Basit Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250410,
    "batch": 2
  },
  {
    "name": "Disha",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250411,
    "batch": 2
  },
  {
    "name": "Duaa",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250412,
    "batch": 2
  },
  {
    "name": "Faraz Ahmed",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250413,
    "batch": 2
  },
  {
    "name": "Ghazanfar Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250414,
    "batch": 2
  },
  {
    "name": "Hasnain Hyder",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250415,
    "batch": 2
  },
  {
    "name": "Hasnsin",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250416,
    "batch": 2
  },
  {
    "name": "IQRA SHAIKH",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250417,
    "batch": 2
  },
  {
    "name": "Javed Hussain",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250418,
    "batch": 2
  },
  {
    "name": "Jawad Ahmed",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250419,
    "batch": 2
  },
  {
    "name": "Mohammad Asim Safeer",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250420,
    "batch": 2
  },
  {
    "name": "Muhammad Asfandyar",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250421,
    "batch": 2
  },
  {
    "name": "Muhammad Rashid",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250422,
    "batch": 2
  },
  {
    "name": "Mushtaque Ahmed",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250423,
    "batch": 2
  },
  {
    "name": "Naina Dodani",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250424,
    "batch": 2
  },
  {
    "name": "Nayab",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250425,
    "batch": 2
  },
  {
    "name": "Parveen Hyder",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250426,
    "batch": 2
  },
  {
    "name": "Pirah",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250427,
    "batch": 2
  },
  {
    "name": "Prathna Valija",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250428,
    "batch": 2
  },
  {
    "name": "Sheeraz Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250429,
    "batch": 2
  },
  {
    "name": "Sugra wahab",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250430,
    "batch": 2
  },
  {
    "name": "Yasir Ali Hulio",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250431,
    "batch": 2
  },
  {
    "name": "Yasir Muhammad",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250432,
    "batch": 2
  },
  {
    "name": "Zoya Maheen",
    "course": "Certified Web Developer",
    "center": "SZABIST Larkana Campus",
    "certificate_id": 250433,
    "batch": 2
  },
  {
    "name": "Abdul Hameed",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140261,
    "batch": 1
  },
  {
    "name": "Abdul Jabbar",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140201,
    "batch": 1
  },
  {
    "name": "Abdul Razzaque",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140332,
    "batch": 1
  },
  {
    "name": "Abdullah",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140203,
    "batch": 1
  },
  {
    "name": "Ahmed khan Dehraj",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140204,
    "batch": 1
  },
  {
    "name": "Aijaz Gul",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140205,
    "batch": 1
  },
  {
    "name": "AISHA",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140206,
    "batch": 1
  },
  {
    "name": "Aisha",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140207,
    "batch": 1
  },
  {
    "name": "Aliza Naz",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140253,
    "batch": 1
  },
  {
    "name": "Dua Channar",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140252,
    "batch": 1
  },
  {
    "name": "Farhan Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140246,
    "batch": 1
  },
  {
    "name": "Fayaz Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140209,
    "batch": 1
  },
  {
    "name": "Hadiya",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140416,
    "batch": 1
  },
  {
    "name": "Hijab Zehra",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140262,
    "batch": 1
  },
  {
    "name": "Hizbullah",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140213,
    "batch": 1
  },
  {
    "name": "Imran Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140214,
    "batch": 1
  },
  {
    "name": "Iqra rahim",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140215,
    "batch": 1
  },
  {
    "name": "Madiha Batool",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140249,
    "batch": 1
  },
  {
    "name": "Muhammad Asim Khanzada",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140221,
    "batch": 1
  },
  {
    "name": "Muhammad Bux",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140251,
    "batch": 1
  },
  {
    "name": "Muhammad Hassan",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140222,
    "batch": 1
  },
  {
    "name": "Muhammad Mureed",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140248,
    "batch": 1
  },
  {
    "name": "Muhammad Umer",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140224,
    "batch": 1
  },
  {
    "name": "Mujahid",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140225,
    "batch": 1
  },
  {
    "name": "Mustafa Hussain",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140247,
    "batch": 1
  },
  {
    "name": "Nabi Bux",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140263,
    "batch": 1
  },
  {
    "name": "Nimra",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140328,
    "batch": 1
  },
  {
    "name": "Noor Fatima",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140227,
    "batch": 1
  },
  {
    "name": "Rafay Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140228,
    "batch": 1
  },
  {
    "name": "Rafia",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140229,
    "batch": 1
  },
  {
    "name": "Rajub Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140271,
    "batch": 1
  },
  {
    "name": "Raza Abbas",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140231,
    "batch": 1
  },
  {
    "name": "Rizwan Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140265,
    "batch": 1
  },
  {
    "name": "Ruqiyyah Mujahid",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140254,
    "batch": 1
  },
  {
    "name": "Saba",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140245,
    "batch": 1
  },
  {
    "name": "Sameer Ali",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140242,
    "batch": 1
  },
  {
    "name": "Shaharyar Qadir",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140234,
    "batch": 1
  },
  {
    "name": "Shahzadi",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140235,
    "batch": 1
  },
  {
    "name": "Shams ul din",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140236,
    "batch": 1
  },
  {
    "name": "Shazia",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140237,
    "batch": 1
  },
  {
    "name": "Sindhu",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140244,
    "batch": 1
  },
  {
    "name": "Syeda Tehniyat Batool",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140243,
    "batch": 1
  },
  {
    "name": "Zain ul Abdin",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140266,
    "batch": 1
  },
  {
    "name": "zain-ul-Abdeen",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140239,
    "batch": 1
  },
  {
    "name": "Zobia",
    "course": "Certified Digital Marketing",
    "center": "QUEST Nawabshah",
    "certificate_id": 140240,
    "batch": 1
  },
  {
    "name": "Aaisha hameed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140374,
    "batch": 1
  },
  {
    "name": "Aasia",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140301,
    "batch": 1
  },
  {
    "name": "Abdul Hameed Sahito",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140341,
    "batch": 1
  },
  {
    "name": "Abdul Malik Soomro",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140367,
    "batch": 1
  },
  {
    "name": "Abrar hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140303,
    "batch": 1
  },
  {
    "name": "Aftab ahmad",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140304,
    "batch": 1
  },
  {
    "name": "AHMED NAWAZ",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140306,
    "batch": 1
  },
  {
    "name": "Aleesha",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140381,
    "batch": 1
  },
  {
    "name": "Ali Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140382,
    "batch": 1
  },
  {
    "name": "Ali Murtaza",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140345,
    "batch": 1
  },
  {
    "name": "Alina",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140346,
    "batch": 1
  },
  {
    "name": "Alina",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140342,
    "batch": 1
  },
  {
    "name": "Ambreen",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140308,
    "batch": 1
  },
  {
    "name": "Amjad Ali Bhatti",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140309,
    "batch": 1
  },
  {
    "name": "Asia",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140310,
    "batch": 1
  },
  {
    "name": "asia urf kazbano memon",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140347,
    "batch": 1
  },
  {
    "name": "Atif Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140343,
    "batch": 1
  },
  {
    "name": "Ayesha",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140344,
    "batch": 1
  },
  {
    "name": "Ayesha",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140348,
    "batch": 1
  },
  {
    "name": "Ayesha",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140350,
    "batch": 1
  },
  {
    "name": "Badal Khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140383,
    "batch": 1
  },
  {
    "name": "Bibi Haleema",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140384,
    "batch": 1
  },
  {
    "name": "Duaa Memon",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140312,
    "batch": 1
  },
  {
    "name": "Durreh Shehwar",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140354,
    "batch": 1
  },
  {
    "name": "Farhana",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140356,
    "batch": 1
  },
  {
    "name": "Faris Ansar",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140313,
    "batch": 1
  },
  {
    "name": "Ghayor Abbas",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140391,
    "batch": 1
  },
  {
    "name": "Ghulam Mustafa",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140355,
    "batch": 1
  },
  {
    "name": "haffeezullah",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140316,
    "batch": 1
  },
  {
    "name": "Haseeba",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140385,
    "batch": 1
  },
  {
    "name": "Heer",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140358,
    "batch": 1
  },
  {
    "name": "Humaira Bano",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140386,
    "batch": 1
  },
  {
    "name": "Humazaib",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140387,
    "batch": 1
  },
  {
    "name": "Junaid Ahmed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140359,
    "batch": 1
  },
  {
    "name": "Kashif Husssain Soomro",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140360,
    "batch": 1
  },
  {
    "name": "Kiran",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140319,
    "batch": 1
  },
  {
    "name": "M hasnat",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140302,
    "batch": 1
  },
  {
    "name": "Mahnoor",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140361,
    "batch": 1
  },
  {
    "name": "Maira Khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140321,
    "batch": 1
  },
  {
    "name": "Majid ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140322,
    "batch": 1
  },
  {
    "name": "Maqdas Parveen",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140362,
    "batch": 1
  },
  {
    "name": "Masroor",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140364,
    "batch": 1
  },
  {
    "name": "Mehak Bano",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140363,
    "batch": 1
  },
  {
    "name": "Muhammad Aqib",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140388,
    "batch": 1
  },
  {
    "name": "Muhammad Ashfaque",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140323,
    "batch": 1
  },
  {
    "name": "Muhammad Ibrahim",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140389,
    "batch": 1
  },
  {
    "name": "Muhammad Shakeel",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140366,
    "batch": 1
  },
  {
    "name": "Muneeba khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140390,
    "batch": 1
  },
  {
    "name": "Muneer Ahmed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140368,
    "batch": 1
  },
  {
    "name": "Nabeel Ahmed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140392,
    "batch": 1
  },
  {
    "name": "Nabi Bux",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140393,
    "batch": 1
  },
  {
    "name": "NEHA",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140327,
    "batch": 1
  },
  {
    "name": "Nosheen",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140329,
    "batch": 1
  },
  {
    "name": "Paras Nasir",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140370,
    "batch": 1
  },
  {
    "name": "Perwez Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140330,
    "batch": 1
  },
  {
    "name": "Piyaro Ali Tunio",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140394,
    "batch": 1
  },
  {
    "name": "Qumail Abbas",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140371,
    "batch": 1
  },
  {
    "name": "Rab Nawaz",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140372,
    "batch": 1
  },
  {
    "name": "Rabia hameed Ghouri",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140331,
    "batch": 1
  },
  {
    "name": "saba gull",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140333,
    "batch": 1
  },
  {
    "name": "Saba hassan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140334,
    "batch": 1
  },
  {
    "name": "Sahiba",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140365,
    "batch": 1
  },
  {
    "name": "Sapna",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140369,
    "batch": 1
  },
  {
    "name": "Sawera",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140335,
    "batch": 1
  },
  {
    "name": "Sawera Abbasi",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140373,
    "batch": 1
  },
  {
    "name": "Shahid Khan",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140336,
    "batch": 1
  },
  {
    "name": "Sikander Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140395,
    "batch": 1
  },
  {
    "name": "Tayyab Awais",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140351,
    "batch": 1
  },
  {
    "name": "Tooba",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140337,
    "batch": 1
  },
  {
    "name": "Umair Ahmed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140396,
    "batch": 1
  },
  {
    "name": "Umar Mawia",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140352,
    "batch": 1
  },
  {
    "name": "ushna muneer",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140339,
    "batch": 1
  },
  {
    "name": "USMAN SANI",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140353,
    "batch": 1
  },
  {
    "name": "Zafar Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140375,
    "batch": 1
  },
  {
    "name": "Zain Bin Wahab",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140397,
    "batch": 1
  },
  {
    "name": "Zain Mustafa",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140398,
    "batch": 1
  },
  {
    "name": "Zamir Hussain",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140379,
    "batch": 1
  },
  {
    "name": "Zohaib Ali",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140377,
    "batch": 1
  },
  {
    "name": "Zunair Ahmed",
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140378,
    "batch": 1
  },
  {
    "name": "Abdul Saboor",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140404,
    "batch": 1
  },
  {
    "name": "Adnan Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140407,
    "batch": 1
  },
  {
    "name": "Ahmed Hussain Memon",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140409,
    "batch": 1
  },
  {
    "name": "Ahmed Raza",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140410,
    "batch": 1
  },
  {
    "name": "aleeza",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140411,
    "batch": 1
  },
  {
    "name": "Ali Asghar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140441,
    "batch": 1
  },
  {
    "name": "Alishah Khan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140442,
    "batch": 1
  },
  {
    "name": "Alishba Imran",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140443,
    "batch": 1
  },
  {
    "name": "Aliyan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140444,
    "batch": 1
  },
  {
    "name": "Amna Fatima Shaikh",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140445,
    "batch": 1
  },
  {
    "name": "Atif Rehman",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140413,
    "batch": 1
  },
  {
    "name": "Azam",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140446,
    "batch": 1
  },
  {
    "name": "Fakhar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140447,
    "batch": 1
  },
  {
    "name": "Gulshan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140448,
    "batch": 1
  },
  {
    "name": "Hashir Raza",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140449,
    "batch": 1
  },
  {
    "name": "Hasnain",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140417,
    "batch": 1
  },
  {
    "name": "Hassan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140418,
    "batch": 1
  },
  {
    "name": "Kiran Fatima Shaikh",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140422,
    "batch": 1
  },
  {
    "name": "M Qazi Sheheryar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140450,
    "batch": 1
  },
  {
    "name": "Muhammad Anss",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140425,
    "batch": 1
  },
  {
    "name": "Muhammad Baseer Khan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140451,
    "batch": 1
  },
  {
    "name": "Muhammad Sameer",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140452,
    "batch": 1
  },
  {
    "name": "Muhammad Shariq",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140428,
    "batch": 1
  },
  {
    "name": "Muhammad Umar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140429,
    "batch": 1
  },
  {
    "name": "Muhammad Umar Abbas",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140453,
    "batch": 1
  },
  {
    "name": "Rabail Sindhu",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140432,
    "batch": 1
  },
  {
    "name": "Rohail Jan",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140433,
    "batch": 1
  },
  {
    "name": "Sagar Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140455,
    "batch": 1
  },
  {
    "name": "Sitara Khaskheli",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140456,
    "batch": 1
  },
  {
    "name": "SUFYAN ALI",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140437,
    "batch": 1
  },
  {
    "name": "Sumia",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140457,
    "batch": 1
  },
  {
    "name": "ubaidullah",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140438,
    "batch": 1
  },
  {
    "name": "Usman Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140458,
    "batch": 1
  },
  {
    "name": "Zainab Ali",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140439,
    "batch": 1
  },
  {
    "name": "Zamir Hussain",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140440,
    "batch": 1
  },
  {
    "name": "Zara",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140480,
    "batch": 1
  },
  {
    "name": "Zulfiqar",
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140459,
    "batch": 1
  },
  {
    "name": "Abdul Majid",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140141,
    "batch": 1
  },
  {
    "name": "Abdullah Khan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140143,
    "batch": 1
  },
  {
    "name": "Aqsa Malik",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140145,
    "batch": 1
  },
  {
    "name": "Aqsa Samo",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140103,
    "batch": 1
  },
  {
    "name": "Babar ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140105,
    "batch": 1
  },
  {
    "name": "Ghulam Asghar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140161,
    "batch": 1
  },
  {
    "name": "Ghulam Shabir",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140110,
    "batch": 1
  },
  {
    "name": "Hira jamali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140146,
    "batch": 1
  },
  {
    "name": "Iqra Jamali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140147,
    "batch": 1
  },
  {
    "name": "Iqrar Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140148,
    "batch": 1
  },
  {
    "name": "Junaid Ahmed",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140113,
    "batch": 1
  },
  {
    "name": "Kumail Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140114,
    "batch": 1
  },
  {
    "name": "Malaika",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140149,
    "batch": 1
  },
  {
    "name": "Mansoor Ali Mahar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140115,
    "batch": 1
  },
  {
    "name": "Moazzam Hussain",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140116,
    "batch": 1
  },
  {
    "name": "Mohsin",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140117,
    "batch": 1
  },
  {
    "name": "Muhammad Faisal",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140118,
    "batch": 1
  },
  {
    "name": "Muhammad Izzat",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140119,
    "batch": 1
  },
  {
    "name": "Muhammad Khan",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140121,
    "batch": 1
  },
  {
    "name": "Muhammad Mudasir Malik",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140122,
    "batch": 1
  },
  {
    "name": "Muhammad Umar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140162,
    "batch": 1
  },
  {
    "name": "Muhammad Younis",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140124,
    "batch": 1
  },
  {
    "name": "Mukhtiar ali magsi",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140125,
    "batch": 1
  },
  {
    "name": "Munazza javed",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140150,
    "batch": 1
  },
  {
    "name": "Murk",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140126,
    "batch": 1
  },
  {
    "name": "Najaf Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140127,
    "batch": 1
  },
  {
    "name": "Neha Malik",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140151,
    "batch": 1
  },
  {
    "name": "Nimra",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140128,
    "batch": 1
  },
  {
    "name": "Rimsha Qamar",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140163,
    "batch": 1
  },
  {
    "name": "Saveeta Bai",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140133,
    "batch": 1
  },
  {
    "name": "Shahbaz Ali",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140134,
    "batch": 1
  },
  {
    "name": "Shujaat Hussain",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140135,
    "batch": 1
  },
  {
    "name": "Ubaidullah",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140152,
    "batch": 1
  },
  {
    "name": "Zaid Ahmed",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140138,
    "batch": 1
  },
  {
    "name": "Zubair",
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "certificate_id": 140153,
    "batch": 1
  },
  {
    "name": "Abdul Rafiu",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150201,
    "batch": 1
  },
  {
    "name": "Abdul Raouf Chana",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150202,
    "batch": 1
  },
  {
    "name": "Abdullah Chandio",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150204,
    "batch": 1
  },
  {
    "name": "Ali Akbar",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150205,
    "batch": 1
  },
  {
    "name": "Ali Hyder",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150206,
    "batch": 1
  },
  {
    "name": "Ali Hyder",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150207,
    "batch": 1
  },
  {
    "name": "Arshad Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150208,
    "batch": 1
  },
  {
    "name": "Asif Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150209,
    "batch": 1
  },
  {
    "name": "Basit Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150210,
    "batch": 1
  },
  {
    "name": "Faraz Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150212,
    "batch": 1
  },
  {
    "name": "Fatima Parveen",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150252,
    "batch": 1
  },
  {
    "name": "Ghazanfar Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150213,
    "batch": 1
  },
  {
    "name": "Hasnain",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150215,
    "batch": 1
  },
  {
    "name": "Husban Ahmed Qureshi",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150217,
    "batch": 1
  },
  {
    "name": "Ilham Chouhan",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150219,
    "batch": 1
  },
  {
    "name": "Kashif Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150223,
    "batch": 1
  },
  {
    "name": "Khan Muhammad",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150224,
    "batch": 1
  },
  {
    "name": "Lutuf Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150225,
    "batch": 1
  },
  {
    "name": "M.Azam Bhutto",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150226,
    "batch": 1
  },
  {
    "name": "Mairaj Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150227,
    "batch": 1
  },
  {
    "name": "Muhammad Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150228,
    "batch": 1
  },
  {
    "name": "Muhammad Asfandyar",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150229,
    "batch": 1
  },
  {
    "name": "Muhammad Zakir",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150230,
    "batch": 1
  },
  {
    "name": "MUZAMIL",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150231,
    "batch": 1
  },
  {
    "name": "Sameer Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150233,
    "batch": 1
  },
  {
    "name": "Samiullah",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150234,
    "batch": 1
  },
  {
    "name": "Sarang",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150235,
    "batch": 1
  },
  {
    "name": "Shoaib Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150236,
    "batch": 1
  },
  {
    "name": "Wajid Alu",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150238,
    "batch": 1
  },
  {
    "name": "Zameer Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150239,
    "batch": 1
  },
  {
    "name": "Zeeshan",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150240,
    "batch": 1
  },
  {
    "name": "ABDUL HANAN",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150241,
    "batch": 1
  },
  {
    "name": "Abdul Rafiu",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150242,
    "batch": 1
  },
  {
    "name": "Abdul Samad Ghaffar",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150243,
    "batch": 1
  },
  {
    "name": "Akash Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150245,
    "batch": 1
  },
  {
    "name": "Anesh",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150246,
    "batch": 1
  },
  {
    "name": "Arslan Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150247,
    "batch": 1
  },
  {
    "name": "Azhar Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150281,
    "batch": 1
  },
  {
    "name": "Basit Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150249,
    "batch": 1
  },
  {
    "name": "Bilawal Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150282,
    "batch": 1
  },
  {
    "name": "Dur E Shahwar",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150251,
    "batch": 1
  },
  {
    "name": "Haji Khan",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150253,
    "batch": 1
  },
  {
    "name": "Irfan Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150254,
    "batch": 1
  },
  {
    "name": "Komal Syed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150283,
    "batch": 1
  },
  {
    "name": "Kounj Syed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150255,
    "batch": 1
  },
  {
    "name": "Mohammad zubair",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150257,
    "batch": 1
  },
  {
    "name": "Muazam Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150260,
    "batch": 1
  },
  {
    "name": "Muhamamd Yaseen",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150256,
    "batch": 1
  },
  {
    "name": "Muhammad Azmatullah",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150261,
    "batch": 1
  },
  {
    "name": "Muhammad Eidan",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150285,
    "batch": 1
  },
  {
    "name": "Muhammad Urs",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150263,
    "batch": 1
  },
  {
    "name": "Muzamil Hussain",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150286,
    "batch": 1
  },
  {
    "name": "Naheed Noshad",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150267,
    "batch": 1
  },
  {
    "name": "Sahil Khan Jakhro",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150272,
    "batch": 1
  },
  {
    "name": "Sharjeel",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150273,
    "batch": 1
  },
  {
    "name": "Siraj Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150287,
    "batch": 1
  },
  {
    "name": "Tanveer Ahmed",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150288,
    "batch": 1
  },
  {
    "name": "Ubaid Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150275,
    "batch": 1
  },
  {
    "name": "Umesh Kumar",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150276,
    "batch": 1
  },
  {
    "name": "Yaseen Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150278,
    "batch": 1
  },
  {
    "name": "Zeehsan Ali",
    "course": "Certified Digital Marketing",
    "center": "SZABIST University Larkana",
    "certificate_id": 150279,
    "batch": 1
  },
  {
    "name": "Abbas hyder",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150309,
    "batch": 1
  },
  {
    "name": "Abdul Qadeer Mugheri",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150303,
    "batch": 1
  },
  {
    "name": "Ahmed Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150301,
    "batch": 1
  },
  {
    "name": "Ameer Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150324,
    "batch": 1
  },
  {
    "name": "Amjad Ali Mangi",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150326,
    "batch": 1
  },
  {
    "name": "Amna",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150307,
    "batch": 1
  },
  {
    "name": "Arshad Ali Mangi",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150327,
    "batch": 1
  },
  {
    "name": "Asif Ali Junejo",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150329,
    "batch": 1
  },
  {
    "name": "Bisarat Fatima",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150306,
    "batch": 1
  },
  {
    "name": "Bisma",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150304,
    "batch": 1
  },
  {
    "name": "Bisma",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150325,
    "batch": 1
  },
  {
    "name": "Gouri Kukreja",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150330,
    "batch": 1
  },
  {
    "name": "Haya Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150360,
    "batch": 1
  },
  {
    "name": "Ishaque ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150323,
    "batch": 1
  },
  {
    "name": "Khalilullah",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150317,
    "batch": 1
  },
  {
    "name": "Khushbakhat",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150320,
    "batch": 1
  },
  {
    "name": "Memona",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150313,
    "batch": 1
  },
  {
    "name": "Muneeza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150366,
    "batch": 1
  },
  {
    "name": "Musawir Sheikh",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150322,
    "batch": 1
  },
  {
    "name": "Mushtaque Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150308,
    "batch": 1
  },
  {
    "name": "Rafique Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150302,
    "batch": 1
  },
  {
    "name": "Safeena batool",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150321,
    "batch": 1
  },
  {
    "name": "Shahnaz",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150310,
    "batch": 1
  },
  {
    "name": "Sumaiya",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150318,
    "batch": 1
  },
  {
    "name": "Aamir Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150382,
    "batch": 1
  },
  {
    "name": "Abdul Mateen",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150384,
    "batch": 1
  },
  {
    "name": "Abdul Qadeer",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150345,
    "batch": 1
  },
  {
    "name": "Abdul Raheem",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150346,
    "batch": 1
  },
  {
    "name": "Adnan",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150333,
    "batch": 1
  },
  {
    "name": "Ali Hyder",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150351,
    "batch": 1
  },
  {
    "name": "Ali Mustafa",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150385,
    "batch": 1
  },
  {
    "name": "Aliza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150352,
    "batch": 1
  },
  {
    "name": "Awais Aziz",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150355,
    "batch": 1
  },
  {
    "name": "Daud",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150356,
    "batch": 1
  },
  {
    "name": "Eman Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150357,
    "batch": 1
  },
  {
    "name": "Faraz Hussain",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150336,
    "batch": 1
  },
  {
    "name": "Ghulam Masooma",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150386,
    "batch": 1
  },
  {
    "name": "Ghulam Sugra tagar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150315,
    "batch": 1
  },
  {
    "name": "Hameedullah",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150359,
    "batch": 1
  },
  {
    "name": "Hamza Ali Narejo",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150331,
    "batch": 1
  },
  {
    "name": "Hassan Mujtaba",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150387,
    "batch": 1
  },
  {
    "name": "Hunain Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150388,
    "batch": 1
  },
  {
    "name": "Hussain Raza",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150361,
    "batch": 1
  },
  {
    "name": "Inam Ul Haq",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150389,
    "batch": 1
  },
  {
    "name": "Iqra Soomro",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150305,
    "batch": 1
  },
  {
    "name": "Javeria",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150362,
    "batch": 1
  },
  {
    "name": "Khadeeja",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150363,
    "batch": 1
  },
  {
    "name": "Mehak",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150364,
    "batch": 1
  },
  {
    "name": "Muhammad Baqar Mahar",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150365,
    "batch": 1
  },
  {
    "name": "Munsif Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150367,
    "batch": 1
  },
  {
    "name": "Naina",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150316,
    "batch": 1
  },
  {
    "name": "Qazi Irfan Haider",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150390,
    "batch": 1
  },
  {
    "name": "Rose",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150391,
    "batch": 1
  },
  {
    "name": "Saira",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150371,
    "batch": 1
  },
  {
    "name": "Samia",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150392,
    "batch": 1
  },
  {
    "name": "Shumaila soomro",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150374,
    "batch": 1
  },
  {
    "name": "Ummul Hina",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150377,
    "batch": 1
  },
  {
    "name": "Waqar Ali Shah",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150378,
    "batch": 1
  },
  {
    "name": "Zameer Ali",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150314,
    "batch": 1
  },
  {
    "name": "Zubair Ahmed",
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150380,
    "batch": 1
  },
  {
    "name": "Aamir Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150101,
    "batch": 1
  },
  {
    "name": "Abdul Ahad",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150102,
    "batch": 1
  },
  {
    "name": "Abdul Ghaffar",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150103,
    "batch": 1
  },
  {
    "name": "Abdul Qayoom",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150109,
    "batch": 1
  },
  {
    "name": "Ahmed Raza",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150106,
    "batch": 1
  },
  {
    "name": "Ahyan Hassan",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150107,
    "batch": 1
  },
  {
    "name": "Ajay Kumar",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150108,
    "batch": 1
  },
  {
    "name": "Anees",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150111,
    "batch": 1
  },
  {
    "name": "Arif Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150112,
    "batch": 1
  },
  {
    "name": "Arshad Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150113,
    "batch": 1
  },
  {
    "name": "Arsla",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150114,
    "batch": 1
  },
  {
    "name": "AZHARULDDIN",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150116,
    "batch": 1
  },
  {
    "name": "Duaa Batool Buledi",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150117,
    "batch": 1
  },
  {
    "name": "Iqra leghari",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150141,
    "batch": 1
  },
  {
    "name": "Iqrar Hussain",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150121,
    "batch": 1
  },
  {
    "name": "Jan Muhammad",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150122,
    "batch": 1
  },
  {
    "name": "Javed Hussain",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150142,
    "batch": 1
  },
  {
    "name": "Kamran",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150124,
    "batch": 1
  },
  {
    "name": "Khalid Mehmood",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150143,
    "batch": 1
  },
  {
    "name": "Mohammad Yousif",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150125,
    "batch": 1
  },
  {
    "name": "Muhammad Nawaz",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150127,
    "batch": 1
  },
  {
    "name": "Muhsin Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150128,
    "batch": 1
  },
  {
    "name": "NAZAKAT",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150129,
    "batch": 1
  },
  {
    "name": "Noor",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150130,
    "batch": 1
  },
  {
    "name": "Parveen",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150131,
    "batch": 1
  },
  {
    "name": "SADRULDDIN",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150132,
    "batch": 1
  },
  {
    "name": "Saeed Ahmed",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150133,
    "batch": 1
  },
  {
    "name": "Sher Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150135,
    "batch": 1
  },
  {
    "name": "Siraj Ali",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150137,
    "batch": 1
  },
  {
    "name": "Tarique",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150138,
    "batch": 1
  },
  {
    "name": "Uzma Batool",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150144,
    "batch": 1
  },
  {
    "name": "Waqas u Rahman",
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana",
    "certificate_id": 150139,
    "batch": 1
  },

    {
      "name": "Abdul Ghaffar",
      "certificate_id": 330201,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abdul Mateen Shah",
      "certificate_id": 330202,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ahmed Ali",
      "certificate_id": 330203,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ahsan Laique",
      "certificate_id": 330204,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aisha",
      "certificate_id": 330245,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aleesha",
      "certificate_id": 330205,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 330206,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Arsalan",
      "certificate_id": 330207,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ayesha Rasheed",
      "certificate_id": 330244,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Daniyal Khan",
      "certificate_id": 330208,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Fayaz Ahmed",
      "certificate_id": 330210,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Imran Phulpoto",
      "certificate_id": 330211,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Jawahir Hussain",
      "certificate_id": 330242,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Lareb Batool",
      "certificate_id": 330213,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mehwish",
      "certificate_id": 330214,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mudasir Rehman",
      "certificate_id": 330215,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Bilawal",
      "certificate_id": 330216,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Mudasir",
      "certificate_id": 330218,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muqeem Ahmed Shaikh",
      "certificate_id": 330219,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nadia Sami",
      "certificate_id": 330220,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nasir Hussain",
      "certificate_id": 330243,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nazim Ali",
      "certificate_id": 330221,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Pranjal",
      "certificate_id": 330222,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rabel",
      "certificate_id": 330223,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rehana",
      "certificate_id": 330246,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sadam Hussain",
      "certificate_id": 330225,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Saqib Anwar",
      "certificate_id": 330227,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sarmad Hyder",
      "certificate_id": 330228,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Seengar Ali Tunio",
      "certificate_id": 330229,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shafqat Hussain",
      "certificate_id": 330230,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shahid  Hussain",
      "certificate_id": 330231,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shahzaib",
      "certificate_id": 330232,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shakeel Ahmed",
      "certificate_id": 330233,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Syed Muhammad Sajjad Ali",
      "certificate_id": 330241,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Syeda Aleesha Zaidi",
      "certificate_id": 330234,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Syeda Fizza Shah",
      "certificate_id": 330235,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tahir Hussain",
      "certificate_id": 330236,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Usama Hameed",
      "certificate_id": 330237,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Wajid Ali",
      "certificate_id": 330238,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zahid  Hussain",
      "certificate_id": 330239,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ahsan Ali",
      "certificate_id": 330601,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ahsan Hussain",
      "certificate_id": 330602,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aisha",
      "certificate_id": 330603,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ali Murtaza",
      "certificate_id": 330604,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Amal Shaikh",
      "certificate_id": 330643,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Anesh Kumar",
      "certificate_id": 330605,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Azeem Ali",
      "certificate_id": 330641,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Bilal Ali",
      "certificate_id": 330607,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Faheem Ali",
      "certificate_id": 330650,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Faisal Hussain",
      "certificate_id": 330608,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Faraz Ali",
      "certificate_id": 330609,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Farman Ali",
      "certificate_id": 330610,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Fatima",
      "certificate_id": 330612,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ghulam Mustafa",
      "certificate_id": 330652,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Hari Parsad",
      "certificate_id": 330614,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Iqra Gul",
      "certificate_id": 330615,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kamran Ali",
      "certificate_id": 330616,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mahnoor",
      "certificate_id": 330651,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mateen Mustafa",
      "certificate_id": 330648,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mehr ul Nisa",
      "certificate_id": 330645,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mubeen Gul",
      "certificate_id": 330617,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Abdul Moiz",
      "certificate_id": 330647,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Hamza",
      "certificate_id": 330618,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Musharib",
      "certificate_id": 330649,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Talha",
      "certificate_id": 330619,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Yaseen",
      "certificate_id": 330620,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Zain Soomro",
      "certificate_id": 330621,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nabeel Gul Sahito",
      "certificate_id": 330624,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Najaf Ali",
      "certificate_id": 330625,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Najafuddin",
      "certificate_id": 330626,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nasreen Gul",
      "certificate_id": 330627,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Natasha Mangi",
      "certificate_id": 330628,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Noorulain",
      "certificate_id": 330629,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Qadir Bux",
      "certificate_id": 330642,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rabia",
      "certificate_id": 330630,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rajab Ali",
      "certificate_id": 330631,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rizwan Ali",
      "certificate_id": 330633,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sineha",
      "certificate_id": 330637,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Syed Muhammad Najaf Raza Naqvi",
      "certificate_id": 330638,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tufail Ahmed",
      "certificate_id": 330639,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Usama Khan",
      "certificate_id": 330640,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zeeshan",
      "certificate_id": 330644,
      "course": "Certified E-commerce Professional",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Agha Haider Ali",
      "certificate_id": 330702,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ali Moiz",
      "certificate_id": 330703,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 330704,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aman Ali",
      "certificate_id": 330705,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 330706,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Arslan Khan",
      "certificate_id": 330707,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Asif Ali Soomro",
      "certificate_id": 330708,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Attaullah",
      "certificate_id": 330709,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ayaz Ali",
      "certificate_id": 330710,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Bhawna",
      "certificate_id": 330711,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Bisma Shaikh",
      "certificate_id": 330712,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Daniyal Ali",
      "certificate_id": 330713,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ghulam Mustafa",
      "certificate_id": 330714,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Hafeezullah",
      "certificate_id": 330715,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Huzaifa Rashid",
      "certificate_id": 330716,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Irum",
      "certificate_id": 330717,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Jaindo Khan",
      "certificate_id": 330718,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kabeer Avesi",
      "certificate_id": 330719,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kashif Ali",
      "certificate_id": 330720,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Khalil U Rehman",
      "certificate_id": 330721,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Khizra Batool",
      "certificate_id": 330722,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kousar Ali",
      "certificate_id": 330723,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Misbah Naveed",
      "certificate_id": 330724,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mohsan Ali",
      "certificate_id": 330725,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mubshair Ali",
      "certificate_id": 330726,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Ali",
      "certificate_id": 330727,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Ibrahim",
      "certificate_id": 330728,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Ishaque",
      "certificate_id": 330729,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Uzair",
      "certificate_id": 330730,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mujahid Ali Khaskheli",
      "certificate_id": 330731,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nisha Kumari",
      "certificate_id": 330732,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Saeeda Batool",
      "certificate_id": 330733,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sarfraz Alam",
      "certificate_id": 330734,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sidra Rani",
      "certificate_id": 330735,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Syed Aadil Ali Shah",
      "certificate_id": 330736,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ussama Imtiaz",
      "certificate_id": 330737,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Vijai",
      "certificate_id": 330738,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zakir Ali",
      "certificate_id": 330739,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zoya Zaffar",
      "certificate_id": 330740,
      "course": "Certified Graphic Designer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aamir Ali",
      "certificate_id": 331101,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abdul Rehman",
      "certificate_id": 331102,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abid Ali",
      "certificate_id": 331103,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aijaz Ali",
      "certificate_id": 331144,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Allah Bux",
      "certificate_id": 331104,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Arshad Ali",
      "certificate_id": 331106,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Azmat Hussain",
      "certificate_id": 331108,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Dua Rajper",
      "certificate_id": 331109,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Ekta",
      "certificate_id": 331110,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Farman Ali",
      "certificate_id": 331111,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Farwa Batool",
      "certificate_id": 331112,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "irfan Ahmed",
      "certificate_id": 331146,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Irfan Ali",
      "certificate_id": 331145,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kamlesh Kumar",
      "certificate_id": 331143,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Kashif Khan",
      "certificate_id": 331115,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Masoom Ali",
      "certificate_id": 331116,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Meesam Raza",
      "certificate_id": 331117,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Meezan",
      "certificate_id": 331118,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mohammed Ahmed",
      "certificate_id": 331119,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mubashar Hussain",
      "certificate_id": 331120,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Arif",
      "certificate_id": 331121,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Usman",
      "certificate_id": 331122,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Younis",
      "certificate_id": 331123,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muneer Hussain",
      "certificate_id": 331124,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muzamil Ahmed",
      "certificate_id": 331125,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muzamil Hassan",
      "certificate_id": 331126,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nabia Dua",
      "certificate_id": 331127,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Qurban Ali",
      "certificate_id": 331141,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Raheel Hussain",
      "certificate_id": 331128,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Raheel Noor",
      "certificate_id": 331129,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sagar Kumar",
      "certificate_id": 331130,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sarmad Ali Ansari",
      "certificate_id": 331131,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sneha",
      "certificate_id": 331132,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Taha Ali",
      "certificate_id": 331142,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tanseer Ahmed",
      "certificate_id": 331133,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tanzeel Hassan",
      "certificate_id": 331134,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tooba Shafique",
      "certificate_id": 331135,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Yousif Ali Shah",
      "certificate_id": 331138,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zainab Khan",
      "certificate_id": 331139,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zuhaib Ali",
      "certificate_id": 331140,
      "course": "Certified Python Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aamir Ali",
      "certificate_id": 331301,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abdul Saboor",
      "certificate_id": 331302,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abid Ali",
      "certificate_id": 331303,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Afsheen Fatima",
      "certificate_id": 331304,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Aiman",
      "certificate_id": 331305,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Amber Fatima",
      "certificate_id": 331306,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Amrat Mirani",
      "certificate_id": 331307,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Asoud Ahmed",
      "certificate_id": 331308,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Esha",
      "certificate_id": 331309,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Farah Naz",
      "certificate_id": 331310,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Hamza Rehman",
      "certificate_id": 331311,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Haseeba",
      "certificate_id": 331312,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Mahnoor",
      "certificate_id": 331313,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Azeem Khan",
      "certificate_id": 331314,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Huzaifa",
      "certificate_id": 331315,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muzamil Hussain",
      "certificate_id": 331317,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Muzamil Hussain",
      "certificate_id": 331316,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Naimatullah",
      "certificate_id": 331318,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Nazeer Ahmed",
      "certificate_id": 331319,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Parvez Ahmed",
      "certificate_id": 331320,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Quratulain_Irshad",
      "certificate_id": 331321,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Rehan Ali",
      "certificate_id": 331322,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sabia Kanwal",
      "certificate_id": 331323,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sagar Kumar",
      "certificate_id": 331324,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Saira",
      "certificate_id": 331325,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sajjad Ali",
      "certificate_id": 331326,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sanaullah",
      "certificate_id": 331327,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sarfaraz Ahmed",
      "certificate_id": 331341,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shabab Uddin",
      "certificate_id": 331328,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shahzaib",
      "certificate_id": 331329,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shan",
      "certificate_id": 331342,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Shoaib Ali",
      "certificate_id": 331331,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Sohana",
      "certificate_id": 331343,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Tabassum Memon",
      "certificate_id": 331332,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Toheed Ahemd",
      "certificate_id": 331333,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Uswa-E-Noor",
      "certificate_id": 331336,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Vaniza batool",
      "certificate_id": 331337,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zaheer Ahmed",
      "certificate_id": 331338,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zeeshan Hyder",
      "certificate_id": 331339,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Zohaib Babar",
      "certificate_id": 331340,
      "course": "Certified Web Developer",
      "center": "IBA IET Khairpur Campus",
      "batch": 3
    },
    {
      "name": "Abbas Ali",
      "certificate_id": 370201,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Abdul Ghaffar",
      "certificate_id": 370202,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Agya sawlani",
      "certificate_id": 370204,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Ahssan Aziz",
      "certificate_id": 370205,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 370208,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Barkha",
      "certificate_id": 370211,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Farooq Ahmed",
      "certificate_id": 370214,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Faryal",
      "certificate_id": 370215,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Gulzeb",
      "certificate_id": 370216,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Habib ur Rehman",
      "certificate_id": 370217,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Hashir Hussain",
      "certificate_id": 370219,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Iqra Naz",
      "certificate_id": 370221,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Kashan Ali",
      "certificate_id": 370223,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Masood Ahmed",
      "certificate_id": 370224,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mehvish",
      "certificate_id": 370225,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Ali",
      "certificate_id": 370226,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Mubashir",
      "certificate_id": 370227,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Ramzan",
      "certificate_id": 370228,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Shoaib Malik",
      "certificate_id": 370229,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Prena Hablani",
      "certificate_id": 370230,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Prena parpiani",
      "certificate_id": 370231,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Raja Zafar Ali",
      "certificate_id": 370232,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Salma",
      "certificate_id": 370234,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Saqib Ali Malik",
      "certificate_id": 370235,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shahid",
      "certificate_id": 370236,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shankar Lal",
      "certificate_id": 370238,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sineha Mandhan",
      "certificate_id": 370240,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Siraj Ahmed",
      "certificate_id": 370241,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Siraj Ali",
      "certificate_id": 370242,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sudarshan lal",
      "certificate_id": 370243,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Waseem Ahmed",
      "certificate_id": 370245,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Zakir Hussain",
      "certificate_id": 370246,
      "course": "Certified Digital Marketing Professional",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Abdul Manan",
      "certificate_id": 370701,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Abdul Rahman",
      "certificate_id": 370702,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Abdul Samad",
      "certificate_id": 370703,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Ali Hasnain",
      "certificate_id": 370705,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Asim Ali",
      "certificate_id": 370706,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Dur Muhammad",
      "certificate_id": 370707,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Gul Muhammad Mahar",
      "certificate_id": 370708,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Hyder Ali",
      "certificate_id": 370709,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Israr Ahmed",
      "certificate_id": 370711,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Kabeer Ahmed",
      "certificate_id": 370712,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Karam Kumar",
      "certificate_id": 370713,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Kashif Ali",
      "certificate_id": 370714,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Bilal",
      "certificate_id": 370716,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Naseebullah",
      "certificate_id": 370722,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Radhika",
      "certificate_id": 370724,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Saif Ur Rahman",
      "certificate_id": 370725,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Saifullah",
      "certificate_id": 370726,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sain Dino",
      "certificate_id": 370727,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sakhawat",
      "certificate_id": 370728,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shafique Rahman",
      "certificate_id": 370729,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shahab U Din",
      "certificate_id": 370730,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shahzado",
      "certificate_id": 370731,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shiva",
      "certificate_id": 370732,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Shoaib Ali",
      "certificate_id": 370733,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sineha sachdev",
      "certificate_id": 370734,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sudha Mandhan",
      "certificate_id": 370735,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Suhail Ahmed",
      "certificate_id": 370737,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sumair Malik",
      "certificate_id": 370736,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Zahoor Ahmed",
      "certificate_id": 370739,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Zeeshan Ali Malik",
      "certificate_id": 370740,
      "course": "Certified Graphic Designer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Aftab Nawaz",
      "certificate_id": 371304,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Arifullah",
      "certificate_id": 371302,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Azhar Ali shah",
      "certificate_id": 371305,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Ghulam Mustafa",
      "certificate_id": 371306,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mahek",
      "certificate_id": 371307,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mahnoor Akbar",
      "certificate_id": 371308,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Maria Akbar",
      "certificate_id": 371310,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mariam gull",
      "certificate_id": 371312,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mohit kumar",
      "certificate_id": 371313,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Amin",
      "certificate_id": 371314,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Salahudin",
      "certificate_id": 371317,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Zaibullah Malik",
      "certificate_id": 371318,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Mushtaque Ali",
      "certificate_id": 371319,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Sadia",
      "certificate_id": 371322,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Samreen",
      "certificate_id": 371323,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Suhail Ahmed",
      "certificate_id": 371324,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Tufail Ahmed",
      "certificate_id": 371325,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Umair Ali",
      "certificate_id": 371326,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Varoon Kumar",
      "certificate_id": 371327,
      "course": "Certified Web Developer",
      "center": "IBA Kandhkot Campus",
      "batch": 3
    },
    {
      "name": "Ali Gulab",
      "certificate_id": 340716,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Ali Jan",
      "certificate_id": 340721,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Ali Nazar",
      "certificate_id": 340720,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Azizullah Ujjan",
      "certificate_id": 340726,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Fida Hussain",
      "certificate_id": 340723,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Gul Hassan",
      "certificate_id": 340702,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Gul Muhammad",
      "certificate_id": 340730,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Hafeezullah",
      "certificate_id": 340712,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Hakim Ali",
      "certificate_id": 340728,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Imtiaz Ali",
      "certificate_id": 340707,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Imtiaz Ali Ujjan",
      "certificate_id": 340727,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Karan Kumar",
      "certificate_id": 340725,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Kashif Ali",
      "certificate_id": 340724,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Kazim Raza",
      "certificate_id": 340703,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Mir Dawood Hassan Talpur",
      "certificate_id": 340710,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Muhammad Qurrat Ul Ain",
      "certificate_id": 340708,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Muhummad Jan Raza",
      "certificate_id": 340717,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Muqadas Ali",
      "certificate_id": 340718,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Musawir Abbas",
      "certificate_id": 340729,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Naeem Ahmed",
      "certificate_id": 340713,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Nasir Ali",
      "certificate_id": 340715,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Rahmatullah",
      "certificate_id": 340722,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Sajjad Hussain",
      "certificate_id": 340719,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Sayed Hassan Raza",
      "certificate_id": 340714,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Shahzeb",
      "certificate_id": 340706,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Sheheriar Ali Solangi",
      "certificate_id": 340705,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Tofique Abbas",
      "certificate_id": 340711,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Waheed Ali Burdi",
      "certificate_id": 340701,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "wajid ali",
      "certificate_id": 340704,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Zaheer Shaikh",
      "certificate_id": 340709,
      "course": "Certified Graphic Designer",
      "center": "Kotdiji Campus",
      "batch": 3
    },
    {
      "name": "Abdul Ghaffar",
      "certificate_id": 350301,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Muqeet",
      "certificate_id": 350201,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Rehman",
      "certificate_id": 350303,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Rehman",
      "certificate_id": 350302,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdullah",
      "certificate_id": 350304,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abeer Khan",
      "certificate_id": 350204,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Absax ali",
      "certificate_id": 350305,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aliza Batol",
      "certificate_id": 350207,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "allah warayo",
      "certificate_id": 350208,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aman Ali",
      "certificate_id": 350209,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Anam Tabassum",
      "certificate_id": 350210,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aneela",
      "certificate_id": 350306,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 350211,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Areeba Kanwal",
      "certificate_id": 350212,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arooba",
      "certificate_id": 350215,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arsal Abbas",
      "certificate_id": 350307,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aslan abbad",
      "certificate_id": 350308,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Atif Ahmed",
      "certificate_id": 350217,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "ayan ali unar",
      "certificate_id": 350218,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Basma Fatima",
      "certificate_id": 350309,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fahad Hassan",
      "certificate_id": 350221,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faizullah",
      "certificate_id": 350223,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fatima  Zohra",
      "certificate_id": 350225,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fatima Jabbar",
      "certificate_id": 350226,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "fayaz",
      "certificate_id": 350310,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fida Hussain",
      "certificate_id": 350227,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fiza",
      "certificate_id": 350311,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Gulam Sughra",
      "certificate_id": 350312,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hunza",
      "certificate_id": 350313,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Inqualb",
      "certificate_id": 350314,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jahanzaib",
      "certificate_id": 350315,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jawad Ali",
      "certificate_id": 350316,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jawad hussain",
      "certificate_id": 350317,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Junaid",
      "certificate_id": 350318,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kainat",
      "certificate_id": 350319,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kashaf",
      "certificate_id": 350232,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Khadim Hussain",
      "certificate_id": 350320,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M  . Aslam",
      "certificate_id": 350321,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M imran",
      "certificate_id": 350322,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M junaid",
      "certificate_id": 350234,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Maham khan",
      "certificate_id": 350237,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Majid Hussain",
      "certificate_id": 350323,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Maryam",
      "certificate_id": 350324,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "mashooq",
      "certificate_id": 350325,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mehak",
      "certificate_id": 350238,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mohsin Ali",
      "certificate_id": 350239,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mohsin Ali",
      "certificate_id": 350326,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Momin Ali",
      "certificate_id": 350327,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mudasir Hussain",
      "certificate_id": 350328,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad hasnain",
      "certificate_id": 350241,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Ibrahim",
      "certificate_id": 350242,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Muzammil",
      "certificate_id": 350244,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Umair Raza",
      "certificate_id": 350235,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mujtaba",
      "certificate_id": 350329,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muneeba",
      "certificate_id": 350247,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Musaib Ali",
      "certificate_id": 350248,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "muzmail",
      "certificate_id": 350331,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Naila",
      "certificate_id": 350332,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Najaf Ali",
      "certificate_id": 350276,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "namitullahBrohi",
      "certificate_id": 350333,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noor imran",
      "certificate_id": 350251,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rabnawaz",
      "certificate_id": 350334,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Raja Naimatullah",
      "certificate_id": 350335,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Safina",
      "certificate_id": 350254,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sagar Ali",
      "certificate_id": 350336,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "saifullah",
      "certificate_id": 350255,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "sajjad ali",
      "certificate_id": 350256,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sami Ullah",
      "certificate_id": 350257,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sanobar",
      "certificate_id": 350337,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saqib hussain",
      "certificate_id": 350258,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sarwar Ali",
      "certificate_id": 350259,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "shahbaz ali",
      "certificate_id": 350338,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sidra",
      "certificate_id": 350262,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "subhan ali",
      "certificate_id": 350263,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Syeda Amima Hussain",
      "certificate_id": 350339,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Umar Gul",
      "certificate_id": 350265,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Umar hayat",
      "certificate_id": 350266,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Urooj",
      "certificate_id": 350267,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Uzma",
      "certificate_id": 350340,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wajiha Zafar",
      "certificate_id": 350341,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Waqar ali",
      "certificate_id": 350342,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Waqas Ali",
      "certificate_id": 350270,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Waqas Ali",
      "certificate_id": 350343,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zakir ali",
      "certificate_id": 350272,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ziaullah khan abbasi",
      "certificate_id": 350344,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zubair Ali",
      "certificate_id": 350345,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zulfiqar Ali",
      "certificate_id": 350274,
      "course": "Certified Digital Marketing Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Manan",
      "certificate_id": 350601,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul razaque",
      "certificate_id": 350602,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdullah",
      "certificate_id": 350603,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aeiraf Fatima",
      "certificate_id": 350604,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Afaque  Ahmed",
      "certificate_id": 350605,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Amna Urooj",
      "certificate_id": 350606,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 350607,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 350608,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arslan Abid",
      "certificate_id": 350609,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ayesha Sajid",
      "certificate_id": 350610,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Basit Ali",
      "certificate_id": 350611,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Feroz ali",
      "certificate_id": 350612,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "ghulam mohammad",
      "certificate_id": 350613,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ghullam Muhammad",
      "certificate_id": 350614,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kashmala memon",
      "certificate_id": 350615,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Meeshan Khan",
      "certificate_id": 350616,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Nawaz",
      "certificate_id": 350617,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Shakeel",
      "certificate_id": 350618,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Umair",
      "certificate_id": 350619,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Uzair",
      "certificate_id": 350620,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Zarar",
      "certificate_id": 350621,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mujahid Ali",
      "certificate_id": 350622,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mukhtiar Ali",
      "certificate_id": 350623,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muzamil",
      "certificate_id": 350624,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muzammil Ali",
      "certificate_id": 350625,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nafees Rind",
      "certificate_id": 350626,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noor Muhammad",
      "certificate_id": 350627,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saba",
      "certificate_id": 350628,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sahil  Murad",
      "certificate_id": 350629,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Samiullah Lakhmir",
      "certificate_id": 350630,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahzaib Ali",
      "certificate_id": 350631,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sheezah  Khan Afridi",
      "certificate_id": 350632,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shoaib  Ali",
      "certificate_id": 350633,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shukurullah",
      "certificate_id": 350634,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Siraj Ahmed  Bhatti",
      "certificate_id": 350635,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Umair Ali",
      "certificate_id": 350636,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zaheer Ali Shah",
      "certificate_id": 350637,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zakir  Hussain",
      "certificate_id": 350638,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zamir Hussan",
      "certificate_id": 350639,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zeeshan",
      "certificate_id": 350640,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zohaib Ahmed",
      "certificate_id": 350641,
      "course": "Certified E-Commerce Professional",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aashir Razaque",
      "certificate_id": 350801,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Majid",
      "certificate_id": 350701,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Qadeer",
      "certificate_id": 350702,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Salam",
      "certificate_id": 350703,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdullah",
      "certificate_id": 350704,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aftab Ali",
      "certificate_id": 350705,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahmad Ali",
      "certificate_id": 350802,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahmed Jutt",
      "certificate_id": 350803,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahsan",
      "certificate_id": 350804,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aisha Asad",
      "certificate_id": 350706,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aisha Shafique",
      "certificate_id": 350707,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Mustafa",
      "certificate_id": 350805,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Siraj",
      "certificate_id": 350708,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Zain",
      "certificate_id": 350709,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aliza",
      "certificate_id": 350806,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aneela",
      "certificate_id": 350807,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Anwar Ali",
      "certificate_id": 350808,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Areeba",
      "certificate_id": 350809,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Areeba",
      "certificate_id": 350710,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arsalan khan",
      "certificate_id": 350810,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arslan",
      "certificate_id": 350711,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Asadullah",
      "certificate_id": 350712,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ayesha Malik",
      "certificate_id": 350713,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Bahadur Ali",
      "certificate_id": 350714,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Bushra Hamid",
      "certificate_id": 350715,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Dua",
      "certificate_id": 350811,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Dua Iqra",
      "certificate_id": 350812,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faisal Sattar",
      "certificate_id": 350716,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faiza",
      "certificate_id": 350717,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faiza",
      "certificate_id": 350813,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faraz Ahmed",
      "certificate_id": 350718,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Farhad Ali",
      "certificate_id": 350719,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Farkhanda",
      "certificate_id": 350720,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Farman Ali",
      "certificate_id": 350721,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fiza",
      "certificate_id": 350722,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ghulam.Murtaza",
      "certificate_id": 350723,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Gul Zaman",
      "certificate_id": 350814,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Gulab Khan",
      "certificate_id": 350815,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hamad Ali",
      "certificate_id": 350816,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hamid Ali",
      "certificate_id": 350817,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hansa Lareb",
      "certificate_id": 350724,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hasnain  Siddique",
      "certificate_id": 350725,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hassan Raza",
      "certificate_id": 350726,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Iftikhar Ahmed",
      "certificate_id": 350818,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Iqra Yaqoob",
      "certificate_id": 350727,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Irfan Ali",
      "certificate_id": 350728,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Israr Ahmed",
      "certificate_id": 350819,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jahanzaib",
      "certificate_id": 350729,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jahanzaib Mallah",
      "certificate_id": 350820,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jam Hassan",
      "certificate_id": 350821,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jaweria",
      "certificate_id": 350822,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kashif Ali",
      "certificate_id": 350730,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Khadija",
      "certificate_id": 350731,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Khalid Hussain",
      "certificate_id": 350732,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Khizar Ali",
      "certificate_id": 350733,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kifayat Hussain",
      "certificate_id": 350734,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Komal",
      "certificate_id": 350735,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M.Arsalan",
      "certificate_id": 350736,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M.Arslan",
      "certificate_id": 350737,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M.Zubbair Khan",
      "certificate_id": 350823,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Malika",
      "certificate_id": 350824,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Manahil",
      "certificate_id": 350825,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Maryam Javed",
      "certificate_id": 350738,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Maryam Nawaz",
      "certificate_id": 350739,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Masooma",
      "certificate_id": 350826,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Moiz Ali",
      "certificate_id": 350740,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Firdous",
      "certificate_id": 350741,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Hammad",
      "certificate_id": 350742,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Hassnain",
      "certificate_id": 350827,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Tahir Hussain Qazi",
      "certificate_id": 350743,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Uzair",
      "certificate_id": 350744,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Zeeshan",
      "certificate_id": 350828,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mujahid Ali",
      "certificate_id": 350829,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mujahid Ali",
      "certificate_id": 350745,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mujeeb ur Rehman",
      "certificate_id": 350746,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muqadas",
      "certificate_id": 350747,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muzamil",
      "certificate_id": 350748,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nafeesa",
      "certificate_id": 350749,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nandni",
      "certificate_id": 350750,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Naseem Ahmed",
      "certificate_id": 350830,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nayab",
      "certificate_id": 350751,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Neelman",
      "certificate_id": 350752,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nizakat Hussain",
      "certificate_id": 350753,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Nizba Saleman",
      "certificate_id": 350754,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noman Khan",
      "certificate_id": 350755,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noman Mughal",
      "certificate_id": 350756,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noman Mughal",
      "certificate_id": 350831,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noor Muhammad Samo",
      "certificate_id": 350832,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noureen Ashraf",
      "certificate_id": 350833,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Pir Athar",
      "certificate_id": 350757,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rafia",
      "certificate_id": 350758,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ramain",
      "certificate_id": 350834,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rimsha",
      "certificate_id": 350759,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rizwan Ali",
      "certificate_id": 350835,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Roshan Ali",
      "certificate_id": 350760,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rukhsar",
      "certificate_id": 350761,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sadia",
      "certificate_id": 350762,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saifullah",
      "certificate_id": 350763,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sajjad Ali",
      "certificate_id": 350836,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sallar Shaikh",
      "certificate_id": 350837,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sanober",
      "certificate_id": 350764,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sanober Ali",
      "certificate_id": 350838,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saqib Abbas",
      "certificate_id": 350839,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saud Ahmed Rahu",
      "certificate_id": 350840,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sawera Benazir",
      "certificate_id": 350841,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahbaz Ali",
      "certificate_id": 350842,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahbaz Ali",
      "certificate_id": 350843,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shaheer Ali",
      "certificate_id": 350765,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shamim Syal",
      "certificate_id": 350844,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shanza",
      "certificate_id": 350845,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sheeraz Ahmed",
      "certificate_id": 350846,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sidra",
      "certificate_id": 350847,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sundas Fatima",
      "certificate_id": 350848,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Syed Hasnain Hyder Shah Naqri",
      "certificate_id": 350849,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Syed Irtaza Ali",
      "certificate_id": 350766,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tania",
      "certificate_id": 350767,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tayyaba",
      "certificate_id": 350768,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tayyaba Tafzeel",
      "certificate_id": 350769,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tooba",
      "certificate_id": 350770,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tooba Ayoub",
      "certificate_id": 350850,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ubaidullah",
      "certificate_id": 350851,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "umair  Ali",
      "certificate_id": 350771,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Urooj",
      "certificate_id": 350852,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Urooj Memon",
      "certificate_id": 350853,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Urooj Safdar",
      "certificate_id": 350772,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Usama",
      "certificate_id": 350773,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wajahat Ali",
      "certificate_id": 350854,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wali Muhammad",
      "certificate_id": 350855,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wamik Ali",
      "certificate_id": 350774,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wazeer",
      "certificate_id": 350475,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Yasmeen",
      "certificate_id": 350776,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zafarullah",
      "certificate_id": 350777,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zainab",
      "certificate_id": 350778,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zakir Karim",
      "certificate_id": 350779,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zameer Ali",
      "certificate_id": 350780,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zar Khan",
      "certificate_id": 350781,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zoya Fatima",
      "certificate_id": 350856,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zubair Ali",
      "certificate_id": 350857,
      "course": "Certified Graphic Designer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aakash",
      "certificate_id": 351101,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul haseeb",
      "certificate_id": 351103,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Haseeb",
      "certificate_id": 351102,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Muqeet",
      "certificate_id": 351104,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahsan Imtiaz",
      "certificate_id": 351105,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Akbar",
      "certificate_id": 351106,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 351107,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Alishba Naeem",
      "certificate_id": 351108,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Alizeh",
      "certificate_id": 351109,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Amanullah",
      "certificate_id": 351110,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Areeba",
      "certificate_id": 351111,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Areeba Arain",
      "certificate_id": 351112,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Arib",
      "certificate_id": 351113,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ashish Kumar",
      "certificate_id": 351114,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Azhar Hussain",
      "certificate_id": 351115,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Bibi Sana",
      "certificate_id": 351116,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Dameer Ahmed",
      "certificate_id": 351117,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faiza",
      "certificate_id": 351119,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faiza",
      "certificate_id": 351118,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Farhan  Ali",
      "certificate_id": 351120,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Fawad Shoieb",
      "certificate_id": 351121,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hasaan Ahmed",
      "certificate_id": 351122,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hasnain",
      "certificate_id": 351123,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hassan Ahmed",
      "certificate_id": 351124,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hina",
      "certificate_id": 351125,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hyder Raza",
      "certificate_id": 351126,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Iqra",
      "certificate_id": 351127,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Iqrar Ali",
      "certificate_id": 351128,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jabeen  Abbas",
      "certificate_id": 351129,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kinza Batool",
      "certificate_id": 351130,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Hussain",
      "certificate_id": 351131,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Usama",
      "certificate_id": 351132,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Munaza Mushtaque",
      "certificate_id": 351133,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Qadir  Bux",
      "certificate_id": 351134,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rameez Qadir",
      "certificate_id": 351135,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Raza Ali",
      "certificate_id": 351136,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "saba",
      "certificate_id": 351137,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saba",
      "certificate_id": 351138,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Salman  Aslam",
      "certificate_id": 351139,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Salman Khan",
      "certificate_id": 351140,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sehrish",
      "certificate_id": 351141,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahid Hussain",
      "certificate_id": 351142,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shuja   Maqsood",
      "certificate_id": 351143,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shumalia",
      "certificate_id": 351144,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Tabeer Hussain",
      "certificate_id": 351145,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Vasdew",
      "certificate_id": 351146,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Vivek Anand",
      "certificate_id": 351147,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Waseem Hayat",
      "certificate_id": 351148,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Yasir Arfat",
      "certificate_id": 351149,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zuhaib Ali",
      "certificate_id": 351150,
      "course": "Certified Python Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul  Sami Ujjan",
      "certificate_id": 351401,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Basit",
      "certificate_id": 351301,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Moeed",
      "certificate_id": 351302,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Razzaque",
      "certificate_id": 351303,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abdul Sami solangi",
      "certificate_id": 351304,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Abu Bakar",
      "certificate_id": 351305,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aftab Ahmed",
      "certificate_id": 351306,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahmed Raza",
      "certificate_id": 351402,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahsan Ahmed Soomro",
      "certificate_id": 351307,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ahsan Ali",
      "certificate_id": 351403,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aisha Asad",
      "certificate_id": 351308,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aisha Kanwal",
      "certificate_id": 351309,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali  Raza",
      "certificate_id": 351404,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 351405,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Alishba   parveen",
      "certificate_id": 351406,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aliza Ishaq",
      "certificate_id": 351407,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aman",
      "certificate_id": 351310,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ameer",
      "certificate_id": 351311,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aqsa Gul",
      "certificate_id": 351408,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Asad    Ali",
      "certificate_id": 351409,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Babi Amma",
      "certificate_id": 351410,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Bisma",
      "certificate_id": 351411,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Eman Fatima",
      "certificate_id": 351412,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Faraz Gul",
      "certificate_id": 351413,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Farman ali",
      "certificate_id": 351312,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hadia Khalid",
      "certificate_id": 351313,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hadiqa Jawed",
      "certificate_id": 351414,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Haris Ali",
      "certificate_id": 351314,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hashir Raza",
      "certificate_id": 351415,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hassan Ali",
      "certificate_id": 351315,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Hira",
      "certificate_id": 351316,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ifat  Bangwar",
      "certificate_id": 351416,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Irfan Ali",
      "certificate_id": 351418,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Irfan Ali",
      "certificate_id": 351417,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jatan Kumar",
      "certificate_id": 351317,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Jhanzaib",
      "certificate_id": 351419,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kazim Ali",
      "certificate_id": 351318,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Khalid Hussain",
      "certificate_id": 351319,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Kiran Kumari",
      "certificate_id": 351420,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Laiba",
      "certificate_id": 351421,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M.Saad",
      "certificate_id": 351422,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "M.Yaseen",
      "certificate_id": 351423,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Maria",
      "certificate_id": 351320,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mehwish",
      "certificate_id": 351321,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mir Alam",
      "certificate_id": 351322,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mohsin",
      "certificate_id": 351323,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mubashir Ibrahim",
      "certificate_id": 351324,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mudasir",
      "certificate_id": 351325,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Mudasir Ali",
      "certificate_id": 351326,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad  Umar",
      "certificate_id": 351424,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Abdullah",
      "certificate_id": 351425,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Akmal Jamil",
      "certificate_id": 351426,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Aslam",
      "certificate_id": 351427,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Hassan Raza Attari",
      "certificate_id": 351428,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Muzamil",
      "certificate_id": 351429,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Salman",
      "certificate_id": 351430,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muhammad Usman",
      "certificate_id": 351431,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muneer Ahmed",
      "certificate_id": 351432,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Muzamil",
      "certificate_id": 351433,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Noor-ul-Iman",
      "certificate_id": 351434,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Parvisha",
      "certificate_id": 351327,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rabia",
      "certificate_id": 351328,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rizwan Ahmed",
      "certificate_id": 351329,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Rukhsar Bhangwar",
      "certificate_id": 351435,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Saadullah Soomro",
      "certificate_id": 351330,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sabiha",
      "certificate_id": 351436,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Samiullah",
      "certificate_id": 351437,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Sana",
      "certificate_id": 351331,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahid Ali Jamali",
      "certificate_id": 351332,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahid Hussain",
      "certificate_id": 351333,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahnila Jamil",
      "certificate_id": 351334,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahzaib Ali",
      "certificate_id": 351336,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Shahzaib Ali",
      "certificate_id": 351335,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "SHOAIB AHMED",
      "certificate_id": 351438,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Siraj  Ahmed",
      "certificate_id": 351337,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Umair Ali",
      "certificate_id": 351338,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Ume farwa",
      "certificate_id": 351339,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Urooj",
      "certificate_id": 351440,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Vikram",
      "certificate_id": 351340,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Vishall",
      "certificate_id": 351346,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Wasif Ali",
      "certificate_id": 351342,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zahmeer Ali",
      "certificate_id": 351343,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zainab Eman",
      "certificate_id": 351451,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zainab Tarique",
      "certificate_id": 351442,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zoya",
      "certificate_id": 351344,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Zubair Ahmed",
      "certificate_id": 351345,
      "course": "Certified Web Developer",
      "center": "QUEST SBA Nawabshah",
      "batch": 3
    },
    {
      "name": "Aadil Waheed Kandhir",
      "certificate_id": 310401,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abbas Ali Bhanbhro",
      "certificate_id": 310402,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Ahad Memon",
      "certificate_id": 310201,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Majeed Buriro",
      "certificate_id": 310501,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Moeez khan",
      "certificate_id": 310502,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Mueed Memon",
      "certificate_id": 310202,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Qadeer Mirani",
      "certificate_id": 310203,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Rafay Shaikh",
      "certificate_id": 310503,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdullah Mughal",
      "certificate_id": 310403,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdullah Shaikh",
      "certificate_id": 310404,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdullah Sundrani",
      "certificate_id": 310205,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abu Hurairah",
      "certificate_id": 310206,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abuzar Ali",
      "certificate_id": 310405,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Agha Zulfiqar Durrani",
      "certificate_id": 310406,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aiman Iqbal Yousafzai Pathan",
      "certificate_id": 310305,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aisha Aslam",
      "certificate_id": 310207,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ajay Kumar Oad",
      "certificate_id": 310306,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aleeza Mangi",
      "certificate_id": 310506,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ali Hyder Solangi",
      "certificate_id": 310407,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Alishah Syed",
      "certificate_id": 310408,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aliza Chachar",
      "certificate_id": 310507,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aliza Khoso",
      "certificate_id": 310508,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aliza Shaikh",
      "certificate_id": 310454,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ameer Muawiya Sahito",
      "certificate_id": 310409,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amna Batool Ansari",
      "certificate_id": 310510,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ansa Memon",
      "certificate_id": 310307,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 310411,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Malik",
      "certificate_id": 310412,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Mehak Bhutto",
      "certificate_id": 310308,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Mehak Malik",
      "certificate_id": 310309,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aseem Raheem Akhund",
      "certificate_id": 310310,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Azam Awan",
      "certificate_id": 310455,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bakhtawar Shaikh",
      "certificate_id": 310311,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Basit Ali Samo",
      "certificate_id": 310413,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bhomika Kumari",
      "certificate_id": 310312,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Daniyal Ahmed Shaikh",
      "certificate_id": 310512,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Durani Khan",
      "certificate_id": 310313,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Durgeshi Talreja",
      "certificate_id": 310209,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fabeeha Malik",
      "certificate_id": 310210,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Faraz Hassan Jatt",
      "certificate_id": 310414,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Farukh Ali Mirani",
      "certificate_id": 310314,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Faryal Memon",
      "certificate_id": 310513,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fatima Buriro",
      "certificate_id": 310315,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fatima Soomro",
      "certificate_id": 310211,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghazanfar Lashari",
      "certificate_id": 310212,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghulam Abbas Shah",
      "certificate_id": 310213,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Gul Barira Malik",
      "certificate_id": 310514,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Habib Ur Rehman Qureshi",
      "certificate_id": 310515,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hadia Channa",
      "certificate_id": 310415,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hafiz Zaid Siddiqui",
      "certificate_id": 310214,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hamza Hamayoon",
      "certificate_id": 310316,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hamza Memon",
      "certificate_id": 310416,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hasnain Ali Memon",
      "certificate_id": 310417,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hassan Ali Bhatti",
      "certificate_id": 310516,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hooriya Ansari",
      "certificate_id": 310418,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hurab Mangrio",
      "certificate_id": 310319,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hussain Ali Solangi",
      "certificate_id": 310215,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hussnain Khoso",
      "certificate_id": 310419,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Momin",
      "certificate_id": 310420,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Nazeer Khoso",
      "certificate_id": 310518,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iram Ghoto",
      "certificate_id": 310422,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Isha Dilshad",
      "certificate_id": 310320,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jawad Ahmed Hakro",
      "certificate_id": 310423,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jawad Hussain Shah",
      "certificate_id": 310519,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jaweria Pathan",
      "certificate_id": 310216,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jawwad Hussain Solangi",
      "certificate_id": 310424,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Joti Kumari",
      "certificate_id": 310425,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kaneez Fatima",
      "certificate_id": 310426,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Khadeja Shaikh",
      "certificate_id": 310321,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Khizra Eeman",
      "certificate_id": 310217,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kirshna Khemani",
      "certificate_id": 310322,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Komal Irfan",
      "certificate_id": 310427,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Lareb Khan",
      "certificate_id": 310520,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Lareb Mahesar",
      "certificate_id": 310323,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahnoor Bhutto",
      "certificate_id": 310521,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahnoor Rizvi",
      "certificate_id": 310218,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Manzar Abbas",
      "certificate_id": 310219,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mariyam Fatima Bhatti",
      "certificate_id": 310324,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Masooma Batool",
      "certificate_id": 310429,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Meesam Raza Mehdi Bhunbro",
      "certificate_id": 310325,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehak Dayo",
      "certificate_id": 310430,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehak Shaikh",
      "certificate_id": 310522,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mir Azaan Sundrani",
      "certificate_id": 310220,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mir Hassan Khoso",
      "certificate_id": 310523,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Misbah Fatima Rajput",
      "certificate_id": 310431,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Momin Hameed Mahar",
      "certificate_id": 310221,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Momina Shaikh",
      "certificate_id": 310524,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mudassar Imtiaz",
      "certificate_id": 310525,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muddasir Memon",
      "certificate_id": 310328,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Asfand Hussain Gadani",
      "certificate_id": 310222,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ashal Qasmani",
      "certificate_id": 310434,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Asim Rafiq Rajput",
      "certificate_id": 310435,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ayoob Mangarhar",
      "certificate_id": 310223,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Baqir Balouch",
      "certificate_id": 310526,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Faizan Panhwar",
      "certificate_id": 310527,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Faizan Raza Rajput",
      "certificate_id": 310528,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hanzila Memon",
      "certificate_id": 310529,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hashir Mirani",
      "certificate_id": 310530,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hunain Soomro",
      "certificate_id": 310436,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Motasim Tufail Rajput",
      "certificate_id": 310437,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Mudasir",
      "certificate_id": 310224,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Murad",
      "certificate_id": 310438,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Rizwan Shaikh",
      "certificate_id": 310329,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Sahil Pirzado",
      "certificate_id": 310532,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Tahir Mughal",
      "certificate_id": 310533,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muntazir Mehdi",
      "certificate_id": 310226,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Murk Shah",
      "certificate_id": 310440,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Musawer Ali Kalwar",
      "certificate_id": 310441,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muskan Siddiqui",
      "certificate_id": 310330,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muzamil Ahmed",
      "certificate_id": 310534,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nadia Iqbal",
      "certificate_id": 310227,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nasrullah Bhutto",
      "certificate_id": 310442,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nauman Solangi",
      "certificate_id": 310535,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Niranjan Lal",
      "certificate_id": 310331,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nisar Ahmed Khan Mughal",
      "certificate_id": 310228,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Noorul Huda Qureshi",
      "certificate_id": 310536,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nuzha Shaikh",
      "certificate_id": 310537,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Paras Bhayo",
      "certificate_id": 310538,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Paras Khoso",
      "certificate_id": 310443,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Pirarthana Doultani",
      "certificate_id": 310332,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Quratulain Soomro",
      "certificate_id": 310333,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rahima Chishti",
      "certificate_id": 310230,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rimsha Qureshi",
      "certificate_id": 310540,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rizwan Ahmed Dayo",
      "certificate_id": 310231,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ruqiya Shaikh",
      "certificate_id": 310444,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sadaf Solangi",
      "certificate_id": 310445,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Safiullah Junejo",
      "certificate_id": 310541,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saira Baloch Khoso",
      "certificate_id": 310542,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Salar Ahmed Bhutto",
      "certificate_id": 310446,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Salma Narejo",
      "certificate_id": 310232,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sarkar Hussain Shah",
      "certificate_id": 310336,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sasui Qureshi",
      "certificate_id": 310543,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sehrish Solangi",
      "certificate_id": 310448,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shafia Ahmad Khan Pathan",
      "certificate_id": 310337,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shahzaib Memon",
      "certificate_id": 310233,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shiza Kolachi",
      "certificate_id": 310339,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sidra Tul Muntaha",
      "certificate_id": 310544,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Simran Hindu",
      "certificate_id": 310234,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sindhu Bapar",
      "certificate_id": 310545,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Siraj Ahmed Magsi",
      "certificate_id": 310235,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sumera Kanwal Qureshi",
      "certificate_id": 310341,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Hamza Rehan Shah",
      "certificate_id": 310237,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Muhammad Hussain",
      "certificate_id": 310546,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tahira Ghunio",
      "certificate_id": 310547,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tanzeel Awan",
      "certificate_id": 310451,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tariq Ali Mirani",
      "certificate_id": 310238,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tayyaba Mangarhar",
      "certificate_id": 310548,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tehreem Fatima Mughal",
      "certificate_id": 310452,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tooba Gul Shaikh",
      "certificate_id": 310549,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Toufique Ahmed",
      "certificate_id": 310239,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Toufique Raza",
      "certificate_id": 310342,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Vaniza Riaz Jagirani Baloch",
      "certificate_id": 310343,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Wafa-E-Zahra",
      "certificate_id": 310550,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Waqar Ali Memon",
      "certificate_id": 310551,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Waqas Hussain Dahar",
      "certificate_id": 310344,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Waseem Lashari",
      "certificate_id": 310240,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Washdev Kumar",
      "certificate_id": 310345,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Yusra Shaikh",
      "certificate_id": 310241,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zarmeen Khan",
      "certificate_id": 310347,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Hayee Channa",
      "certificate_id": 310601,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Sameer Shaikh",
      "certificate_id": 310603,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aiman Bhatti",
      "certificate_id": 310604,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amna Rehman Soomro",
      "certificate_id": 310606,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqib Javed Shahbaz Abro",
      "certificate_id": 310607,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ashique Ali Mastoi",
      "certificate_id": 310608,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Atif Ubed Soomro",
      "certificate_id": 310609,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Azalfa Shaikh",
      "certificate_id": 310610,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Benazir Phulpoto",
      "certificate_id": 310612,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Faria Sultan Shaikh",
      "certificate_id": 310615,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fayyaz Hussain Hakro",
      "certificate_id": 310616,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hamza Mehtab Memon",
      "certificate_id": 310617,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hasnain Abbasi",
      "certificate_id": 310619,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Khan",
      "certificate_id": 310621,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Nazeer Soomro",
      "certificate_id": 310622,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Siddiqui",
      "certificate_id": 310623,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Isra Kanwal",
      "certificate_id": 310624,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kashif Ali Mahar",
      "certificate_id": 310626,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Khushbo Zehra Sandeelo",
      "certificate_id": 310627,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mansaf Khatoon",
      "certificate_id": 310628,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Manzar Hussain Mirani",
      "certificate_id": 310630,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Meer Aryan Riaz",
      "certificate_id": 310631,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mudasir Ali Abro",
      "certificate_id": 310633,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Shahzaman Mahar",
      "certificate_id": 310634,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Taha Lakho",
      "certificate_id": 310635,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Usman",
      "certificate_id": 310636,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammed Sahil Soomro",
      "certificate_id": 310637,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Noor Fatima Abbasi",
      "certificate_id": 310638,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Noor Ul Ain Abro Abro",
      "certificate_id": 310639,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sadia Soomro",
      "certificate_id": 310640,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sahar Mahar",
      "certificate_id": 310642,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sahiba Jagirani Balouch",
      "certificate_id": 310643,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sarmad Hussain Phulpoto",
      "certificate_id": 310645,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sheeraz Ahmed Buriro",
      "certificate_id": 310647,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Siraj Ahmed Gadhi",
      "certificate_id": 310648,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Hasnain Hyder",
      "certificate_id": 310649,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tayyab Hussain Channa",
      "certificate_id": 310650,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tooba Khoso",
      "certificate_id": 310651,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Umm E Habiba Mughal",
      "certificate_id": 310652,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Varsha Vaid",
      "certificate_id": 310653,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Vishal Kumar Hindu",
      "certificate_id": 310654,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Vishal Urf Sudarshan",
      "certificate_id": 310655,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Ahad Khan",
      "certificate_id": 310801,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Basit Ansari",
      "certificate_id": 310701,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Qadeer Narejo",
      "certificate_id": 310802,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Qudoos Bhatti",
      "certificate_id": 310803,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Saboor Sarwari",
      "certificate_id": 310702,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Samad Mahar",
      "certificate_id": 310901,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdullah Shah",
      "certificate_id": 310804,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Afia Arain",
      "certificate_id": 310805,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Afza Atta Malik",
      "certificate_id": 310806,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ahmed Ali Pirzado",
      "certificate_id": 310703,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aisha Siddiqui",
      "certificate_id": 310705,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ali Usman Bhutto",
      "certificate_id": 310905,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Alisha Rana",
      "certificate_id": 310706,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Alisha Sarfaraz",
      "certificate_id": 310707,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Alishba Bhutto",
      "certificate_id": 310906,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amara Mahar",
      "certificate_id": 310907,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amina Bhatti",
      "certificate_id": 310908,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amjad Hussain Jogi",
      "certificate_id": 310809,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Anasa Shaikh",
      "certificate_id": 310708,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Pitafi",
      "certificate_id": 310810,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Areeba Ansari",
      "certificate_id": 310709,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Areesha Ansari",
      "certificate_id": 310710,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Areesha Mahar",
      "certificate_id": 310909,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Arsalan Kandhir",
      "certificate_id": 310811,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Asad U Rehman Bhutto",
      "certificate_id": 310812,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Asma Soomro",
      "certificate_id": 310711,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Asma Urooj Mughal",
      "certificate_id": 310813,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ayesha Arain",
      "certificate_id": 310910,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ayesha Mehmood",
      "certificate_id": 310911,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Baby Aqsa Soomro",
      "certificate_id": 310912,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bakht Jan Solangi",
      "certificate_id": 310913,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bakhtawar Memon",
      "certificate_id": 310914,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bibi Zainab Alias Sindhu",
      "certificate_id": 310712,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bushra Iqbal",
      "certificate_id": 310814,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Dua Abbasi",
      "certificate_id": 310815,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Dua Muskan Soomro",
      "certificate_id": 310816,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fatima",
      "certificate_id": 310817,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Gresh Kumar",
      "certificate_id": 310818,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hadiya Mehmood Shaikh Siddiqui",
      "certificate_id": 310915,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hira Tabasum Soomro",
      "certificate_id": 310819,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Qasmi",
      "certificate_id": 310821,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqra Wajid Kolachi",
      "certificate_id": 310916,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iram Bibi",
      "certificate_id": 310917,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jabir Ahmed Kalhoro",
      "certificate_id": 310716,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jannat Kiran Rajput",
      "certificate_id": 310717,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jaweria Malik",
      "certificate_id": 310919,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Junaid Ahmed Soomro",
      "certificate_id": 310920,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kaleemullah Shaikh",
      "certificate_id": 310921,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kashaf Irfan Rajput",
      "certificate_id": 310922,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Khadija Bibi Qureshi",
      "certificate_id": 310923,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Khalid Yousif Mahar",
      "certificate_id": 310718,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Lackshmi Kumari",
      "certificate_id": 310720,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Lareb Shaikh",
      "certificate_id": 310823,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahnoor Ansari",
      "certificate_id": 310721,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maira Ansari",
      "certificate_id": 310924,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maleeha Soomro",
      "certificate_id": 310722,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Manesha Kumari",
      "certificate_id": 310723,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maryam Mukhtiar",
      "certificate_id": 310925,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Meena Memon",
      "certificate_id": 310724,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Meeral Khalil",
      "certificate_id": 310824,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehak",
      "certificate_id": 310725,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehak Kumari",
      "certificate_id": 310825,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehak Kumari",
      "certificate_id": 310726,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehreen Fatima Mughal",
      "certificate_id": 310826,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mehza Jawaid Bhutto",
      "certificate_id": 310827,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Memoona Jawad Abbasi",
      "certificate_id": 310828,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Misbah Shafiq",
      "certificate_id": 310829,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mohit Lal Tejwani",
      "certificate_id": 310727,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ali Mahar",
      "certificate_id": 310830,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ali Soomro",
      "certificate_id": 310927,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Awais",
      "certificate_id": 310929,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Awais Mirani",
      "certificate_id": 310930,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Furqan",
      "certificate_id": 310831,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hussain Shahzad",
      "certificate_id": 310832,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Imad Siyal",
      "certificate_id": 310833,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Muzammil Arain",
      "certificate_id": 310834,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Saad Pathan",
      "certificate_id": 310835,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Shahban Kalwar",
      "certificate_id": 310932,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Shahroz Shaikh",
      "certificate_id": 310729,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Siraj Khan",
      "certificate_id": 310730,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Suhan Ali Arain",
      "certificate_id": 310836,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Umar",
      "certificate_id": 310933,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Waseem Mirani",
      "certificate_id": 310934,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mukhtiar Ali Kharos",
      "certificate_id": 310935,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muqadas Akhound",
      "certificate_id": 310837,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muqadas Qureshi",
      "certificate_id": 310936,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muskan Mughal",
      "certificate_id": 310938,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muskan Niazi",
      "certificate_id": 310731,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muzamil Ahmed Baloch",
      "certificate_id": 310732,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Naseebullah Ghunio",
      "certificate_id": 310839,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Natasha Ali Mahar",
      "certificate_id": 310939,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nihal Kanjwani",
      "certificate_id": 310940,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Noor Fatima Memon",
      "certificate_id": 310841,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Preeti Dewra",
      "certificate_id": 310733,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Preety Lalwani",
      "certificate_id": 310842,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Qadir Bux Alias Rizwan",
      "certificate_id": 310734,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rehana Parveen Jeho",
      "certificate_id": 310844,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ritika",
      "certificate_id": 310845,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rukhsar Niazi",
      "certificate_id": 310735,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ruqia Unar",
      "certificate_id": 310736,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saba Khan",
      "certificate_id": 310941,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sadia Unar",
      "certificate_id": 310737,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Safdar Ali Shiakh",
      "certificate_id": 310942,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sahar Afshan Memon",
      "certificate_id": 310846,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saira",
      "certificate_id": 310738,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saira Soomro",
      "certificate_id": 310944,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sakshi Talreja",
      "certificate_id": 310945,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Salaruddin Chachar",
      "certificate_id": 310847,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saneha Kanjwani",
      "certificate_id": 310739,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sania Guneta",
      "certificate_id": 310848,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sania Parveen Mangrio",
      "certificate_id": 310947,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sawera Shaikh",
      "certificate_id": 310849,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shafaq Zehra Shaikh",
      "certificate_id": 310850,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shahzadi Aisha Siddique Bhatti",
      "certificate_id": 310948,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sheeraz Ali Khokhar",
      "certificate_id": 310949,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shiv Kirtan",
      "certificate_id": 310740,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sidra Nazeer Soomro",
      "certificate_id": 310950,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sidra Saleem Mughal",
      "certificate_id": 310851,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sidra Tul Muntaha",
      "certificate_id": 310951,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sineha Rani",
      "certificate_id": 310741,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sodia Pirzada",
      "certificate_id": 310742,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sohail Ahmed Khuwaro",
      "certificate_id": 310852,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Soojal Kumar",
      "certificate_id": 310743,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Suhail Ahmed Shaikh",
      "certificate_id": 310952,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sumbal Soomro",
      "certificate_id": 310953,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Summan",
      "certificate_id": 310954,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tehreem Rajput",
      "certificate_id": 310853,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ubaid Ullah",
      "certificate_id": 310744,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Umair",
      "certificate_id": 310956,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ume Habiba Arain",
      "certificate_id": 310854,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ume-Areeba Kamanger",
      "certificate_id": 310745,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Uroosa Akhound",
      "certificate_id": 310856,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Uroosa Mahar",
      "certificate_id": 310746,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Uzma Khatoon Channa",
      "certificate_id": 310958,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Waqar Ahmed Arbani",
      "certificate_id": 310747,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zainab Javid Shaikh",
      "certificate_id": 310748,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zarmeena Khan Pathan",
      "certificate_id": 310857,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Rehman Malik",
      "certificate_id": 311001,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Samad Shaikh",
      "certificate_id": 311002,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Wasay Abro",
      "certificate_id": 311003,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Adil Ali Pirzado",
      "certificate_id": 311004,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Alishba Qureshi",
      "certificate_id": 311006,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ameenullah",
      "certificate_id": 311007,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Naz",
      "certificate_id": 311008,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Arsheen Zehra",
      "certificate_id": 311010,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bakhtawar Chachar",
      "certificate_id": 311012,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fasiha Parveen",
      "certificate_id": 311014,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Fiza Mashori",
      "certificate_id": 311015,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghulam Mustafa Buriro",
      "certificate_id": 311016,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hajira Pathan",
      "certificate_id": 311017,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hansa Balouch",
      "certificate_id": 311018,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Haseebullah Jonejo",
      "certificate_id": 311019,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Iqrar Ahmed Sawand",
      "certificate_id": 311021,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Junaid Ahmed Sawand",
      "certificate_id": 311022,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kamran Ali Memon",
      "certificate_id": 311024,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kinza Fatima Soomro",
      "certificate_id": 311026,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maroof Ali Memon",
      "certificate_id": 311027,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Aamir Mangrio",
      "certificate_id": 311028,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hammad Arain",
      "certificate_id": 311029,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hasnain",
      "certificate_id": 311030,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ismail Noonari",
      "certificate_id": 311031,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Shoaib Bhatti",
      "certificate_id": 311033,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ramsha Balouch",
      "certificate_id": 311036,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Raqib Siddiqui",
      "certificate_id": 311037,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rida Shaikh",
      "certificate_id": 311038,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Saeed Ahmed Khokhar",
      "certificate_id": 311040,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sahil Kumar",
      "certificate_id": 311041,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Samiullah",
      "certificate_id": 311043,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Samreen Bibi Pitafi",
      "certificate_id": 311044,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shahmir Memon",
      "certificate_id": 311046,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shahzeb Ali Pirzado",
      "certificate_id": 311047,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Ahsan Shah",
      "certificate_id": 311048,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Sumaiya Shah",
      "certificate_id": 311049,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tanveer Ali Sawand",
      "certificate_id": 311050,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Umefarwa Ansari",
      "certificate_id": 311052,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Unzah Ayaz Shaikh",
      "certificate_id": 311053,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zeenat Yousaf Zai",
      "certificate_id": 311054,
      "course": "Certified Java Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Basit Shaikh",
      "certificate_id": 311201,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Basit Soomro",
      "certificate_id": 311102,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Muqeet Shaikh",
      "certificate_id": 311202,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Qadir Bhayo",
      "certificate_id": 311104,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Rafay Siddiqui",
      "certificate_id": 311203,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdullah",
      "certificate_id": 311204,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abubakar Mahar",
      "certificate_id": 311205,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aiman Qureshi",
      "certificate_id": 311206,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ain Ul Huda Shaikh",
      "certificate_id": 311207,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ali Raza Dahar",
      "certificate_id": 311208,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ali Zain Khoso",
      "certificate_id": 311209,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Amir Khan Pathan",
      "certificate_id": 311210,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Anchal Khanwani",
      "certificate_id": 311211,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqeel Ahmed Khoso",
      "certificate_id": 311106,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Awais Ahmed Indhar",
      "certificate_id": 311212,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bhoomika Kukreja",
      "certificate_id": 311213,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Bhoomika Leenjhara",
      "certificate_id": 311108,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Diya Kalra",
      "certificate_id": 311214,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Diya Kumari",
      "certificate_id": 311109,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Diya Makhija",
      "certificate_id": 311110,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ekta Rani",
      "certificate_id": 311111,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Falak Naz Dayo",
      "certificate_id": 311216,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Farwa Fatima Memon",
      "certificate_id": 311217,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghulam Hyder Junejo",
      "certificate_id": 311218,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghulam Muhammad Mirani",
      "certificate_id": 311114,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ghulam Mujtaba Balouch",
      "certificate_id": 311115,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hammad Ali Mirani",
      "certificate_id": 311116,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hasnain Ali Jumani",
      "certificate_id": 311219,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Heer Dadlani",
      "certificate_id": 311220,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hoorain Qureshi",
      "certificate_id": 311222,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jaffar Hussain Naich",
      "certificate_id": 311117,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kaleem Ullah Ulro",
      "certificate_id": 311118,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kashish",
      "certificate_id": 311119,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maheen Shaikh",
      "certificate_id": 311120,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahnoor Qureshi",
      "certificate_id": 311223,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Majid Khan Behan",
      "certificate_id": 311121,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Manzar Ali Zangejo",
      "certificate_id": 311224,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maria Daudpota",
      "certificate_id": 311122,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Masood Azhar Malik",
      "certificate_id": 311225,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mohammad Basit Mangi",
      "certificate_id": 311123,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mohsin Ali",
      "certificate_id": 311227,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mubashir Abro",
      "certificate_id": 311124,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mubashir Phulpoto",
      "certificate_id": 311229,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mudasar Khan Abro",
      "certificate_id": 311125,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Adil Pirzada",
      "certificate_id": 311126,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Ali Memon",
      "certificate_id": 311231,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Asif Khan",
      "certificate_id": 311232,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Idrees Malik",
      "certificate_id": 311128,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Jaffar",
      "certificate_id": 311233,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Sarfaraz Solangi",
      "certificate_id": 311234,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Shahzad Khushk",
      "certificate_id": 311235,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Taha Shaikh",
      "certificate_id": 311236,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Umar Memon",
      "certificate_id": 311130,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Usman Khan Pathan",
      "certificate_id": 311131,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Murtaza Ahmed Ansari",
      "certificate_id": 311132,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muskan Agarwal",
      "certificate_id": 311237,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muzafar Ali Balouch",
      "certificate_id": 311133,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nimarta Kumari",
      "certificate_id": 311135,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nimra Memon",
      "certificate_id": 311239,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nouman Ali Chachar",
      "certificate_id": 311240,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Palak",
      "certificate_id": 311136,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rahib Ali Mirani",
      "certificate_id": 311137,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Rizwan Ali Lakho",
      "certificate_id": 311241,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sabeen Ul Karim Shaikh",
      "certificate_id": 311138,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shah Nawaz",
      "certificate_id": 311140,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shahid Ali Sethar",
      "certificate_id": 311141,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sharika Syed",
      "certificate_id": 311244,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Shewani Bajaj",
      "certificate_id": 311143,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sibghatullah Memon",
      "certificate_id": 311246,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Simran Khastoori",
      "certificate_id": 311145,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sineha Kumari",
      "certificate_id": 311146,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sobia Asad",
      "certificate_id": 311247,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sugandh Valecha",
      "certificate_id": 311148,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Summera Soomro",
      "certificate_id": 311248,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Syed Saqlain Hyder",
      "certificate_id": 311149,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tahir Ali Mirani",
      "certificate_id": 311150,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tooba Jawaid",
      "certificate_id": 311249,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Ubedulllah Lakho",
      "certificate_id": 311250,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Urooj Fatima Shaikh",
      "certificate_id": 311152,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Usman Ali Pirzada",
      "certificate_id": 311153,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Yasir Ali Shaikh",
      "certificate_id": 311155,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Yasir Ali Solangi",
      "certificate_id": 311156,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zainab Shaikh",
      "certificate_id": 311251,
      "course": "Certified Python Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Ahad Komboh",
      "certificate_id": 311301,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Shakoor Mahar",
      "certificate_id": 311302,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Adeel Gul Kalhoro",
      "certificate_id": 311303,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Aqsa Bhayo",
      "certificate_id": 311353,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Arifa Soomro",
      "certificate_id": 311305,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Azka Mahar",
      "certificate_id": 311306,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Chouhdary Muhammad Haseeb Khokhar",
      "certificate_id": 311308,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Faisal Junejo",
      "certificate_id": 311309,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Farhanullah",
      "certificate_id": 311310,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Furqan Shaikh",
      "certificate_id": 311311,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Hamza Mangi",
      "certificate_id": 311312,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Humza Ali Khoso",
      "certificate_id": 311313,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Imran Ahmed Abro",
      "certificate_id": 311314,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Jaweria Shaikh",
      "certificate_id": 311315,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Kashaf Noor Bhatti",
      "certificate_id": 311318,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Laiba Muskan Shaikh",
      "certificate_id": 311319,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Laraib Bijarani",
      "certificate_id": 311320,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahmood Ahsan",
      "certificate_id": 311322,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mahnoor Memon",
      "certificate_id": 311323,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Malaika Amber Rajput",
      "certificate_id": 311324,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Maria Ali Memon",
      "certificate_id": 311325,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Mudassir Brohi",
      "certificate_id": 311329,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Hasnain Mangi",
      "certificate_id": 311330,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muhammad Usman Niazi",
      "certificate_id": 311332,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Muzamil Brohi",
      "certificate_id": 311333,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Nigar Fatima Bijarani",
      "certificate_id": 311334,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Noor Ul Islam Ansari",
      "certificate_id": 311335,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sabreen Abro",
      "certificate_id": 311337,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sadaf Zahra Muhammadi",
      "certificate_id": 311338,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sania Zehra Shaikh",
      "certificate_id": 311340,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Sidhant Shive",
      "certificate_id": 311342,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Soha Bhutto",
      "certificate_id": 311343,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Taimoor Khan",
      "certificate_id": 311344,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tamjeed Noor Solangi",
      "certificate_id": 311345,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tazeen Fatima Khan",
      "certificate_id": 311346,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Tuba Mubeen Khan",
      "certificate_id": 311347,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Waqar Ahmed Bhutto",
      "certificate_id": 311349,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Yusra Habib Balouch",
      "certificate_id": 311350,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zainab Sajid",
      "certificate_id": 311351,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Zeeshan Alil Bhutto",
      "certificate_id": 311352,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Regular)",
      "batch": 3
    },
    {
      "name": "Abdul Ahad Bhutto",
      "certificate_id": 320102,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Manan Soomro",
      "certificate_id": 320103,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abuzar Ali Gujrani",
      "certificate_id": 320106,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ahmed Ali Balouch",
      "certificate_id": 320107,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Allah Dino",
      "certificate_id": 320108,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Anam Akram Mughal",
      "certificate_id": 320109,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ansar Mehdi Bhunbhro",
      "certificate_id": 320110,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ashweena Rajput",
      "certificate_id": 320111,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Asif Ali Malik",
      "certificate_id": 320112,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Bakhtawar Qureshi",
      "certificate_id": 320113,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fazeela",
      "certificate_id": 320117,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kabeer Ahmed Balouch",
      "certificate_id": 320120,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Majid Ali Junejo",
      "certificate_id": 320124,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Maryyam Makhdoom Qureshi",
      "certificate_id": 320125,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehak Dhulani",
      "certificate_id": 320126,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehran Khan Qureshi",
      "certificate_id": 320127,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ahmed Arain",
      "certificate_id": 320131,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Anas Arain",
      "certificate_id": 320132,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Faizan Shaikh",
      "certificate_id": 320133,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Hamza Khan",
      "certificate_id": 320134,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ibtihaj Hussain",
      "certificate_id": 320137,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Taha",
      "certificate_id": 320138,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Umar Ansari",
      "certificate_id": 320139,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Murk Mangi",
      "certificate_id": 320140,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mushtaque Ali",
      "certificate_id": 320141,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muzammil Hussain Qureshi",
      "certificate_id": 320142,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nafeesa Noor Pathan",
      "certificate_id": 320143,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nargis Fatima",
      "certificate_id": 320144,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rimsha Mumtaz Jatt",
      "certificate_id": 320148,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Salar Ahmed",
      "certificate_id": 320151,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahzeb Shaikh",
      "certificate_id": 320153,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahzeen Bisma",
      "certificate_id": 320154,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shiwani Rani",
      "certificate_id": 320157,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sineha Dhomeja",
      "certificate_id": 320158,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sumaira Gadani",
      "certificate_id": 320159,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tasleem Bibi Gurgeaje",
      "certificate_id": 320161,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Vishaka Devi",
      "certificate_id": 320163,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Wasif Ali Shaikh",
      "certificate_id": 320164,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zain Raza Samo",
      "certificate_id": 320165,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zainab Fatima Bhutto",
      "certificate_id": 320166,
      "course": "Certified Data Scientist",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aashir Shaikh",
      "certificate_id": 320301,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Baqi",
      "certificate_id": 320201,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Faheem Malik",
      "certificate_id": 320202,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Haseeb Memon",
      "certificate_id": 320203,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Haseeb Pirzado",
      "certificate_id": 320204,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Qayoom Noonari",
      "certificate_id": 320205,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Rehman Mahar",
      "certificate_id": 320206,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Salam Shaikh",
      "certificate_id": 320207,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ahsan Ali Mahar",
      "certificate_id": 320211,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Alishah Qureshi",
      "certificate_id": 320216,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aliza kiran",
      "certificate_id": 320217,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Amar Lal",
      "certificate_id": 320303,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Amisha Lalwani",
      "certificate_id": 320304,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ammar Abro",
      "certificate_id": 320305,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Amna Memon",
      "certificate_id": 320218,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Anas Noor Rajput",
      "certificate_id": 320219,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aneesa Chohan",
      "certificate_id": 320220,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Asad Ali Memon",
      "certificate_id": 320222,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Asadullah Memon",
      "certificate_id": 320269,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Awais Shaikh",
      "certificate_id": 320224,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ayesha Syed",
      "certificate_id": 320307,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Azam Mangi",
      "certificate_id": 320225,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Babar Ali Channa",
      "certificate_id": 320226,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Dua Balouch",
      "certificate_id": 320229,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Dua Saleem Malik",
      "certificate_id": 320230,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fareeda",
      "certificate_id": 320308,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hammad Khan",
      "certificate_id": 320236,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hina Jatoi",
      "certificate_id": 320238,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hurain Fatima Bhatti",
      "certificate_id": 320239,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ibadullah Mahar",
      "certificate_id": 320240,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Jahanzeb Ali Soomro",
      "certificate_id": 320243,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Jaideep",
      "certificate_id": 320244,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kalpana",
      "certificate_id": 320246,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Lareb Akhund",
      "certificate_id": 320247,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mansoor Ahmed",
      "certificate_id": 320248,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehak Fatima Solangi",
      "certificate_id": 320249,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Moiz Qureshi",
      "certificate_id": 320251,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhamad Sadique Keerio",
      "certificate_id": 320311,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Abubakar",
      "certificate_id": 320253,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ahmed Saleem",
      "certificate_id": 320255,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ahsan Shaikh",
      "certificate_id": 320256,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ali",
      "certificate_id": 320257,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Aliyan Ansari",
      "certificate_id": 320258,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ayan Iqbal",
      "certificate_id": 320260,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Din",
      "certificate_id": 320261,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Faizan Shaikh",
      "certificate_id": 320262,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Hasaan Soomro",
      "certificate_id": 320263,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Mujtaba Malik",
      "certificate_id": 320312,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Rahin",
      "certificate_id": 320313,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Sadiq Ul Amin Soomro",
      "certificate_id": 320314,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Shoaib Memon",
      "certificate_id": 320316,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muneeb Ahmed Soomro",
      "certificate_id": 320318,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muqadas",
      "certificate_id": 320319,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muskan Kukreja",
      "certificate_id": 320320,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nadia Khalique Chohan",
      "certificate_id": 320321,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Naveed Ali Tunia",
      "certificate_id": 320327,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nousheen Rani",
      "certificate_id": 320264,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rameen Khatri",
      "certificate_id": 320329,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rehan Khan Soomro",
      "certificate_id": 320332,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rutaba Suleman Khan",
      "certificate_id": 320333,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sabir Ali Memon",
      "certificate_id": 320267,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sadam Hussain Soomro",
      "certificate_id": 320334,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Salman Khan Magsi",
      "certificate_id": 320335,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sana Rajput",
      "certificate_id": 320336,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sanina Mughal",
      "certificate_id": 320337,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saqib Hussain Ghumro",
      "certificate_id": 320338,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saqib Rehman Dayo",
      "certificate_id": 320339,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saqlain Ali Soomro",
      "certificate_id": 320340,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Satiwan Larai",
      "certificate_id": 320341,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Savera Memon",
      "certificate_id": 320342,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Seeta Bai",
      "certificate_id": 320343,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahbaz Khan Mahar",
      "certificate_id": 320344,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahzada Ayaz Ali Bhatti",
      "certificate_id": 320345,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahzaman Mahar",
      "certificate_id": 320346,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shane Muhammad Ghumro",
      "certificate_id": 320347,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sharjeel Ahmed Mahar",
      "certificate_id": 320348,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sidra Memon",
      "certificate_id": 320350,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sikandar Ali Chachar",
      "certificate_id": 320351,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Simran Kumari",
      "certificate_id": 320352,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Syed Muhammad Shozib Mehdi Rizvi",
      "certificate_id": 320354,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tabasum Ali Mangi",
      "certificate_id": 320355,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Urva Kalhoro",
      "certificate_id": 320357,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Vanita Rani",
      "certificate_id": 320358,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Wajid Ali",
      "certificate_id": 320359,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Wajid Ali Awan",
      "certificate_id": 320360,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Waqas Ahmed Soomro",
      "certificate_id": 320361,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Yasir Nawaz",
      "certificate_id": 320362,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zaib-Un-Nisa",
      "certificate_id": 320365,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zeeshan Ali",
      "certificate_id": 320367,
      "course": "Certified Digital Marketing Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdullah Memon",
      "certificate_id": 320602,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abubakar",
      "certificate_id": 320603,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Afraz Khan",
      "certificate_id": 320605,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Alishba Noor",
      "certificate_id": 320606,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aqib Ali Mastoi",
      "certificate_id": 320607,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 320608,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Awais Ahmed Qazi",
      "certificate_id": 320610,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Dua Fatima",
      "certificate_id": 320613,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fahad Sangi",
      "certificate_id": 320615,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hamza Khan Chandio Sakhani",
      "certificate_id": 320617,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hizbullah Khaldi",
      "certificate_id": 320618,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hussain Ahmed",
      "certificate_id": 320619,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hussain Tahir Dar",
      "certificate_id": 320620,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Iqra Rajput",
      "certificate_id": 320623,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kalsoom Mangi",
      "certificate_id": 320624,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kalsoom Shah",
      "certificate_id": 320625,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kirshana Jambhali",
      "certificate_id": 320626,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mohammad Yaman Memon",
      "certificate_id": 320628,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Faheem Mahar",
      "certificate_id": 320635,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ibrahim Mahar",
      "certificate_id": 320637,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Rafiullah",
      "certificate_id": 320638,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Umar Malik",
      "certificate_id": 320639,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mustaghfirullah",
      "certificate_id": 320640,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Naresh Kumar",
      "certificate_id": 320642,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nasir Nawaz Pirzada",
      "certificate_id": 320643,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Noor Fatima Memon",
      "certificate_id": 320644,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Om Parkash",
      "certificate_id": 320645,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sajjad Ali Kalhoro",
      "certificate_id": 320647,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sanam Chandio",
      "certificate_id": 320648,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saqlain Abbas",
      "certificate_id": 320651,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shakeel Jalal",
      "certificate_id": 320654,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sher Muhammad Brohi",
      "certificate_id": 320655,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sonia Kalwar",
      "certificate_id": 320657,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Suneel Kumar",
      "certificate_id": 320658,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Syed Iqra Noor",
      "certificate_id": 320659,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Syed Sadaf",
      "certificate_id": 320660,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Syed Tania",
      "certificate_id": 320661,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Taha Mehmood",
      "certificate_id": 320662,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tanseer Ali Shaikh",
      "certificate_id": 320663,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tayyaba Pathan",
      "certificate_id": 320664,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Wahid Bux Memon",
      "certificate_id": 320667,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Wakeel Ahmed",
      "certificate_id": 320668,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zahoor Ahmed Chachar",
      "certificate_id": 320670,
      "course": "Certified E-commerce Professional",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Basit",
      "certificate_id": 320864,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Adil Ahmed",
      "certificate_id": 320801,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Afzaal Aslam Bandesha",
      "certificate_id": 320701,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aisha Noor Arain",
      "certificate_id": 320702,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ali Akber Mahar",
      "certificate_id": 320803,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Alisha Qureshi",
      "certificate_id": 320705,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aliza Attaullah Bhatti",
      "certificate_id": 320706,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Amrita Kumari",
      "certificate_id": 320862,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Anam Shahzad",
      "certificate_id": 320707,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aqsa Lashari",
      "certificate_id": 320709,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Areeba Altaf Memon",
      "certificate_id": 320710,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Arsh Talreja",
      "certificate_id": 320711,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Azmat Aziz Solangi",
      "certificate_id": 320713,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Baseer Channa",
      "certificate_id": 320804,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Divya Rani",
      "certificate_id": 320715,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Dua Rashid Mahar",
      "certificate_id": 320716,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Faiza Gul Bhutto",
      "certificate_id": 320718,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Faizan Hussain Somro",
      "certificate_id": 320719,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fariha Soomro",
      "certificate_id": 320721,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fariyal Gul Bhutto",
      "certificate_id": 320722,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Fatima Arain",
      "certificate_id": 320723,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ghazanfar Qazi",
      "certificate_id": 320724,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ghulam Dastageer Makhdoom",
      "certificate_id": 320725,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ghulam Rabani",
      "certificate_id": 320727,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hamadullah Jatoi",
      "certificate_id": 320729,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hammad Makhdoom",
      "certificate_id": 320730,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hassan Ahmed",
      "certificate_id": 320731,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hizbullah",
      "certificate_id": 320733,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Humaira Shaikh",
      "certificate_id": 320734,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Jinsar Ahmed Jatoi",
      "certificate_id": 320738,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kashish Bai",
      "certificate_id": 320739,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Khalid Hussain Noohani",
      "certificate_id": 320740,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Khushboo Mirani",
      "certificate_id": 320741,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Khushboo Sehar Muhammadi",
      "certificate_id": 320866,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Laiba Shaikh",
      "certificate_id": 320805,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Maaham Naveed",
      "certificate_id": 320806,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Marium Rehman",
      "certificate_id": 320808,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Meer Murtaza Chohan",
      "certificate_id": 320744,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehak Ali Abbasi",
      "certificate_id": 320809,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Misbha Bhatti",
      "certificate_id": 320810,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mohsin Channa",
      "certificate_id": 320746,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mudasir Kalwar",
      "certificate_id": 320747,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Ahtisham Noor",
      "certificate_id": 320748,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Aqib Qureshi",
      "certificate_id": 320749,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Awais Lakho",
      "certificate_id": 320750,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Bux Chohan",
      "certificate_id": 320751,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Farrukh Imam Bhatti",
      "certificate_id": 320752,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Mubasher Pirzado",
      "certificate_id": 320753,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Mubeen Siddiqui",
      "certificate_id": 320754,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Taha Chachar",
      "certificate_id": 320755,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Younus Qureahi",
      "certificate_id": 320756,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Zuhaib Qureshi",
      "certificate_id": 320757,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mukhtiar Ali Laghari",
      "certificate_id": 320811,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muniba Memon",
      "certificate_id": 320812,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muzammil Ahmed Soomro",
      "certificate_id": 320814,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nabi Bux",
      "certificate_id": 320758,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nancy Kumari",
      "certificate_id": 320815,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nirdosh Kumar",
      "certificate_id": 320818,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Noor Fatima Kamanger",
      "certificate_id": 320759,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nusrat Hussain Abbasi",
      "certificate_id": 320821,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Parwash Abbas Bhayo",
      "certificate_id": 320822,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Quratullain Burdi",
      "certificate_id": 320825,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rahib Ali Soomro",
      "certificate_id": 320827,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rani Solangi",
      "certificate_id": 320828,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Razaullah Memon",
      "certificate_id": 320829,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rida Fatima Bhutto",
      "certificate_id": 320830,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Roohullah",
      "certificate_id": 320831,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saba Parveen Sandeelo",
      "certificate_id": 320832,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sajid Hussain",
      "certificate_id": 320833,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Salman Ali",
      "certificate_id": 320834,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Salman Mehdi",
      "certificate_id": 320835,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Samiya Memon",
      "certificate_id": 320836,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sarang Ali Qureshi",
      "certificate_id": 320838,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sarfaraz Ali Shaikh",
      "certificate_id": 320839,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sawera Lolai",
      "certificate_id": 320840,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahmor",
      "certificate_id": 320841,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shahzaib Ali",
      "certificate_id": 320843,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shaista Mehik Memon",
      "certificate_id": 320844,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shireen Nasr Malik",
      "certificate_id": 320845,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sohail Ahmed Solangi",
      "certificate_id": 320846,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sualeha Arain",
      "certificate_id": 320761,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sumair Khan Panhwar",
      "certificate_id": 320847,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sundas Mumtaz",
      "certificate_id": 320848,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sundas Tariq",
      "certificate_id": 320849,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Suraksha Rohra",
      "certificate_id": 320850,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tanveer Ahmed Soomro",
      "certificate_id": 320852,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Umaima Javed Nagebi",
      "certificate_id": 320854,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Uzair Ahmed",
      "certificate_id": 320856,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Uzair Ahmed Rajput",
      "certificate_id": 320857,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Waleed Ahmed",
      "certificate_id": 320858,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Waqas Chrestian",
      "certificate_id": 320859,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zulfat Ayesha Memon",
      "certificate_id": 320762,
      "course": "Certified Graphic Designer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aarti Devi",
      "certificate_id": 321301,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aashish Kumar",
      "certificate_id": 321302,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Kabeer Khoso",
      "certificate_id": 321305,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Qadeer Mahar",
      "certificate_id": 321306,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Rafay Syed",
      "certificate_id": 321307,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Rafiu Abro",
      "certificate_id": 321308,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Abdul Wahab Wadhyo",
      "certificate_id": 321309,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ahmed Ali",
      "certificate_id": 321312,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ahsan Ali Gabol",
      "certificate_id": 321313,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ali Raza Memon",
      "certificate_id": 321314,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aliza Kalwar",
      "certificate_id": 321402,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Altaf Ahmed",
      "certificate_id": 321316,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Amjad Suhaib Memon",
      "certificate_id": 321317,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aqsa Solangi",
      "certificate_id": 321319,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Areej Soomro",
      "certificate_id": 321320,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Arsalan Memon",
      "certificate_id": 321321,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Asad Ullah Bhutto",
      "certificate_id": 321322,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ayesha Farooq",
      "certificate_id": 321403,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Barkat Ali Mangi",
      "certificate_id": 321326,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Bashir Ahmed Balouch",
      "certificate_id": 321327,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Bilal Ahmed Samejo",
      "certificate_id": 321328,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Diya Devi",
      "certificate_id": 321329,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Dua Ali Memon",
      "certificate_id": 321330,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Faizan Memon",
      "certificate_id": 321332,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Farazuddin Sawand",
      "certificate_id": 321333,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Furqan Ali Soomro",
      "certificate_id": 321334,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ghafoor Ahmed Lund",
      "certificate_id": 321335,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Haider Raza Shah",
      "certificate_id": 321336,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hassan Raza Dharejo",
      "certificate_id": 321337,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Hassnain Abbas Chachar",
      "certificate_id": 321338,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Iqra Chachar",
      "certificate_id": 321342,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Jan Muhammad Mughal",
      "certificate_id": 321344,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Junaid Shaikh",
      "certificate_id": 321345,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Kalsoom Fatima",
      "certificate_id": 321346,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Khushboo Dhulani",
      "certificate_id": 321348,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Khushboo Rind",
      "certificate_id": 321349,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Maira Zulifqar Mirani",
      "certificate_id": 321350,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mansoor Ahmed Lund",
      "certificate_id": 321353,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehak Talreja",
      "certificate_id": 321354,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Meharunisa Channa",
      "certificate_id": 321355,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mehik Rohra",
      "certificate_id": 321356,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mohammmad Sami Mahar",
      "certificate_id": 321357,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Mohsin Ali Channa",
      "certificate_id": 321405,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Achar Mahar",
      "certificate_id": 321406,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Faisal Solangi",
      "certificate_id": 321408,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Furqan Rajput",
      "certificate_id": 321358,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Haseeb Malik",
      "certificate_id": 321409,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Hassan Raza Khokhar",
      "certificate_id": 321410,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Rafique Mahar",
      "certificate_id": 321411,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Muhammad Wasiu Abro",
      "certificate_id": 321412,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Nimra Nadeem",
      "certificate_id": 321417,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Noor E Zainab",
      "certificate_id": 321419,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Rehan Ahmed Soomro",
      "certificate_id": 321421,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Riteeka Rohra",
      "certificate_id": 321422,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Ruqiya Mangi",
      "certificate_id": 321423,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Saad Ahmed Keerio",
      "certificate_id": 321424,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sara Rajput",
      "certificate_id": 321429,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Shafique Ahmed Mahar",
      "certificate_id": 321430,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sharih Hassan Ghumro",
      "certificate_id": 321433,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sobiya Shah",
      "certificate_id": 321435,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Sughand Rohra",
      "certificate_id": 321436,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Suhaib Ahmed Akhund",
      "certificate_id": 321437,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Syed Waqar Hussain Shah",
      "certificate_id": 321441,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tanya Jagirani",
      "certificate_id": 321443,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Toufeeque Adil Chachar",
      "certificate_id": 321444,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tuba Naseer Soomro",
      "certificate_id": 321445,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Tufail Ahmed Kalwar",
      "certificate_id": 321446,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Umair Ahmed Abro",
      "certificate_id": 321447,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Vinesh Kumar Alies Shankar Lal",
      "certificate_id": 321448,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Vishwas Lal",
      "certificate_id": 321360,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Waqar Bhutto",
      "certificate_id": 321449,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Waseem Ahmed Channa",
      "certificate_id": 321450,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Zeeshan Shaikh",
      "certificate_id": 321452,
      "course": "Certified Web Developer",
      "center": "Sukkur IBA University (Weekend)",
      "batch": 3
    },
    {
      "name": "Aafan Raza",
      "certificate_id": 361301,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Bari",
      "certificate_id": 361302,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Jabbar",
      "certificate_id": 361303,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Saboor",
      "certificate_id": 361304,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Samad",
      "certificate_id": 361305,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Adil Khan",
      "certificate_id": 361306,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aiman",
      "certificate_id": 361307,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqsa",
      "certificate_id": 361308,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Atique Rehman",
      "certificate_id": 361309,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Bisma",
      "certificate_id": 361310,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Bisma Nadeem Tunyo",
      "certificate_id": 361311,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Dahar Fatima",
      "certificate_id": 361312,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Fahad Sarwar",
      "certificate_id": 361313,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam Mujtaba",
      "certificate_id": 361314,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hamza Ali",
      "certificate_id": 361315,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hassan Mukhtiar",
      "certificate_id": 361316,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Israr Hussain",
      "certificate_id": 361317,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Moazam Ali",
      "certificate_id": 361318,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Moiz ur Rehman",
      "certificate_id": 361320,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Ahmed",
      "certificate_id": 361319,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Faheem",
      "certificate_id": 361321,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Kaif",
      "certificate_id": 361322,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Musawir Soomro",
      "certificate_id": 361323,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Nafeesa Bhutto",
      "certificate_id": 361324,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rani Valecha",
      "certificate_id": 361325,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Safeer Ali",
      "certificate_id": 361326,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sahil Ali",
      "certificate_id": 361327,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sameer Hussain",
      "certificate_id": 361328,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sarang Latif",
      "certificate_id": 361329,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sarfraz Ahmed",
      "certificate_id": 361330,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Savera",
      "certificate_id": 361331,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shahjahan",
      "certificate_id": 361332,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shahzaib Ahmed",
      "certificate_id": 361333,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shakeel Ahmed Jarwar",
      "certificate_id": 361334,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sheeraz Ahmed",
      "certificate_id": 361335,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sher Ali",
      "certificate_id": 361336,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shoaib Raza",
      "certificate_id": 361337,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sony Tatahir Zihran",
      "certificate_id": 361338,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Soonh Rani",
      "certificate_id": 361339,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Tawakal Abbas",
      "certificate_id": 361340,
      "course": "Certified Web Developer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Basit",
      "certificate_id": 360101,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Ghaffar",
      "certificate_id": 360102,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul jabbar",
      "certificate_id": 360103,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Musawir",
      "certificate_id": 360104,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Bux",
      "certificate_id": 360105,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Andul Haleem",
      "certificate_id": 360106,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Arshad Ali",
      "certificate_id": 360107,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ashfaque",
      "certificate_id": 360108,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Azam Bhutto",
      "certificate_id": 360109,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Basit Ali",
      "certificate_id": 360110,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Faqeer Abass Ali",
      "certificate_id": 360111,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Fiza Shaikh",
      "certificate_id": 360112,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Furqan Ali",
      "certificate_id": 360113,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam Zainab",
      "certificate_id": 360114,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Haseebullah",
      "certificate_id": 360115,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hira Khalid",
      "certificate_id": 360116,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Iqra",
      "certificate_id": 360117,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mairaj Ahmed",
      "certificate_id": 360118,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mansoor Ali",
      "certificate_id": 360119,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mohammad Hasnain Ali",
      "certificate_id": 360120,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muddasir Ali",
      "certificate_id": 360121,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Atif",
      "certificate_id": 360122,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Hassan",
      "certificate_id": 360123,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Naeem",
      "certificate_id": 360124,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Nasir",
      "certificate_id": 360125,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Naeem Ahmed",
      "certificate_id": 360126,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Naveed",
      "certificate_id": 360127,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Raheel Ahmed",
      "certificate_id": 360128,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rizwan Hussain",
      "certificate_id": 360129,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sadam Hussain",
      "certificate_id": 360130,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sahar Mirani",
      "certificate_id": 360131,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Salam Hussain",
      "certificate_id": 360132,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sanaullah",
      "certificate_id": 360133,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sanaullah Tagar",
      "certificate_id": 360134,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shawan Kumar",
      "certificate_id": 360135,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shoaib Ali",
      "certificate_id": 360136,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sindhu Oad",
      "certificate_id": 360137,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Suhail",
      "certificate_id": 360138,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zafar Ali",
      "certificate_id": 360139,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zamzam Asif",
      "certificate_id": 360140,
      "course": "Certified Data Scientist",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Basit",
      "certificate_id": 360201,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abid Husssain Jaffri",
      "certificate_id": 360202,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aftab Ali",
      "certificate_id": 360203,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aitizaz Ahmed",
      "certificate_id": 360204,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 360205,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Anosha",
      "certificate_id": 360206,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqsa Akhtar",
      "certificate_id": 360207,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Arsla",
      "certificate_id": 360208,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Azam Ali",
      "certificate_id": 360209,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Danish ali",
      "certificate_id": 360210,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Esha Zafar",
      "certificate_id": 360211,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Fazal Abbas",
      "certificate_id": 360212,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Fazeelan Khatoon",
      "certificate_id": 360213,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam Hayder",
      "certificate_id": 360214,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam masooma",
      "certificate_id": 360215,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hassnain Rafique",
      "certificate_id": 360216,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Iftikhar Ahmed",
      "certificate_id": 360217,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Imtiaz Ali",
      "certificate_id": 360218,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Iqra Qureshi",
      "certificate_id": 360219,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Jawad Hussain",
      "certificate_id": 360220,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mahnoor",
      "certificate_id": 360221,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mehar Ali",
      "certificate_id": 360222,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Bux",
      "certificate_id": 360223,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Meer",
      "certificate_id": 360224,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Yousif",
      "certificate_id": 360225,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Nader Hussain",
      "certificate_id": 360226,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Pooja",
      "certificate_id": 360227,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Riffat",
      "certificate_id": 360228,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rohit Rai",
      "certificate_id": 360229,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sahil",
      "certificate_id": 360230,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shumaila",
      "certificate_id": 360231,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Umme Farwa Abro",
      "certificate_id": 360232,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Uzma",
      "certificate_id": 360233,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Waqar",
      "certificate_id": 360234,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zaheer Abbas Shah",
      "certificate_id": 360235,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zaheer Ahmed",
      "certificate_id": 360236,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zaheer Ahmed",
      "certificate_id": 360237,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zakir Ali",
      "certificate_id": 360238,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zameer Ali",
      "certificate_id": 360239,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zeeshan Ali Tunio",
      "certificate_id": 360240,
      "course": "Certified Digital Marketing Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Ghaffar",
      "certificate_id": 360601,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Rafay Shaikh",
      "certificate_id": 360602,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Salam",
      "certificate_id": 360603,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Samad",
      "certificate_id": 360604,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Adeena Saeed",
      "certificate_id": 360605,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Adil Hussain",
      "certificate_id": 360606,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aizaz Habib",
      "certificate_id": 360607,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Akbar Ali",
      "certificate_id": 360608,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Dino",
      "certificate_id": 360609,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Amna Bhatti",
      "certificate_id": 360610,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Awais",
      "certificate_id": 360611,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Azhar Rasool Narejo",
      "certificate_id": 360612,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Danish Qadeer",
      "certificate_id": 360613,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Faiza",
      "certificate_id": 360614,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam Ali",
      "certificate_id": 360615,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Izhar Ali",
      "certificate_id": 360616,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Kashaf Rehman",
      "certificate_id": 360617,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Kashif Tunio",
      "certificate_id": 360618,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Kazim Raza",
      "certificate_id": 360619,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Momin Hussain",
      "certificate_id": 360620,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Mubashir Ali",
      "certificate_id": 360621,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Aaqib",
      "certificate_id": 360622,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Arsalan",
      "certificate_id": 360623,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muskan Fiza",
      "certificate_id": 360624,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muzafar Ali",
      "certificate_id": 360625,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Qadir Ayaz",
      "certificate_id": 360626,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rehan Raza",
      "certificate_id": 360627,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rohit Rai",
      "certificate_id": 360628,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sadia Ali",
      "certificate_id": 360629,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Samiullah",
      "certificate_id": 360630,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sandesh Makhija",
      "certificate_id": 360631,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sania",
      "certificate_id": 360632,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sheeraz Ali",
      "certificate_id": 360633,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shoaib Ahmed",
      "certificate_id": 360634,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sugra Wahab",
      "certificate_id": 360635,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Syeda Sehla",
      "certificate_id": 360636,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Tahir Bhutto",
      "certificate_id": 360637,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Waliullah",
      "certificate_id": 360638,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zeeshan Raza",
      "certificate_id": 360639,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zuhaib khan",
      "certificate_id": 360640,
      "course": "Certified E-Commerce Professional",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aadil Ali",
      "certificate_id": 360701,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Latif",
      "certificate_id": 360702,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Latif",
      "certificate_id": 360801,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Qayoom",
      "certificate_id": 360703,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Abdul Rauf",
      "certificate_id": 360704,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Adnan Imdad Ali",
      "certificate_id": 360802,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ahmed Ali",
      "certificate_id": 360803,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aijaz Ali",
      "certificate_id": 360804,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aleeba",
      "certificate_id": 360805,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aleeza",
      "certificate_id": 360806,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Dost",
      "certificate_id": 360705,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Hyder",
      "certificate_id": 360706,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ali Raza",
      "certificate_id": 360807,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Alina",
      "certificate_id": 360808,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Allah Bux",
      "certificate_id": 360707,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Almas",
      "certificate_id": 360708,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Amanat Ali",
      "certificate_id": 360709,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aneela",
      "certificate_id": 360809,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Anees Ali",
      "certificate_id": 360710,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqib Ali Meno",
      "certificate_id": 360711,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqsa Abro",
      "certificate_id": 360712,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqsa Ali",
      "certificate_id": 360810,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aqsa Larik",
      "certificate_id": 360713,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Aroosha Kumari",
      "certificate_id": 360811,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Asif Ali",
      "certificate_id": 360714,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Asma Abro",
      "certificate_id": 360715,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Basit Ali",
      "certificate_id": 360812,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Daneen Zehra",
      "certificate_id": 360813,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Diya Fatima",
      "certificate_id": 360814,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Faisal",
      "certificate_id": 360716,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Faraz Ahmed",
      "certificate_id": 360815,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Faraz Ali Kandhro",
      "certificate_id": 360717,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Fatima Noor",
      "certificate_id": 360718,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Ghulam Sakina",
      "certificate_id": 360719,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hasnain",
      "certificate_id": 360720,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hasnain Hyder",
      "certificate_id": 360721,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Hira Khalid",
      "certificate_id": 360722,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Iqra Gul Shaikh",
      "certificate_id": 360816,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Iqra Shahnawaz",
      "certificate_id": 360817,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Jameel Ahmed",
      "certificate_id": 360818,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Javed Hussain",
      "certificate_id": 360819,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Javeria Sk",
      "certificate_id": 360820,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Junaid Ali",
      "certificate_id": 360821,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Khuram Sultan",
      "certificate_id": 360822,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Kousar",
      "certificate_id": 360723,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Maqsood Ali",
      "certificate_id": 360823,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Moazam Ali",
      "certificate_id": 360724,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "More Khan",
      "certificate_id": 360725,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhamad Urs",
      "certificate_id": 360726,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Abbas",
      "certificate_id": 360824,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Asim",
      "certificate_id": 360727,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Faisal",
      "certificate_id": 360825,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Muhammad Qasim",
      "certificate_id": 360826,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Parveen Hyder",
      "certificate_id": 360728,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Pirah",
      "certificate_id": 360729,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rafia",
      "certificate_id": 360730,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rameez Ahmed",
      "certificate_id": 360731,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rehman Ali",
      "certificate_id": 360732,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Rizwan",
      "certificate_id": 360733,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sadia Shaikh",
      "certificate_id": 360827,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sajjad Ahmed",
      "certificate_id": 360828,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sajjad Ali",
      "certificate_id": 360829,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sajjad Hussain",
      "certificate_id": 360830,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sameer Hussain",
      "certificate_id": 360734,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Samia Dhamraha",
      "certificate_id": 360831,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Samiullah",
      "certificate_id": 360832,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sania Soomro",
      "certificate_id": 360833,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sawera",
      "certificate_id": 360834,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shazia Siddique",
      "certificate_id": 360735,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sheeraz Ali",
      "certificate_id": 360835,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Shoaib Ahmed",
      "certificate_id": 360736,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Sohail Ahmed",
      "certificate_id": 360737,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Tawakal Abbas",
      "certificate_id": 360836,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Waqas Ur Rehman",
      "certificate_id": 360837,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Waseem Ali",
      "certificate_id": 360738,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Yasir Ali",
      "certificate_id": 360838,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Yasir Hussain",
      "certificate_id": 360839,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zaheer Ali",
      "certificate_id": 360840,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zakir Hussain",
      "certificate_id": 360739,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },
    {
      "name": "Zuhaib khan",
      "certificate_id": 360740,
      "course": "Certified Graphic Designer",
      "center": "SZABIST University Larkana",
      "batch": 3
    },

    //BATCH 4

    {
    "name": "Abdul Rauf",
    "certificate_id": 450101,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Abida Parveen",
    "certificate_id": 450102,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ahmed Ali Sher",
    "certificate_id": 450103,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ali Nawaz",
    "certificate_id": 450104,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Allah Bux",
    "certificate_id": 450105,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aqsa",
    "certificate_id": 450106,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aqsa Memon",
    "certificate_id": 450107,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ayesha Iqbal",
    "certificate_id": 450108,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Azhar Ali",
    "certificate_id": 450109,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Bashir Ahmed Raho",
    "certificate_id": 450110,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Basma Fatima",
    "certificate_id": 450111,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Dilshad Ali",
    "certificate_id": 450112,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Dua",
    "certificate_id": 450113,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Dua",
    "certificate_id": 450114,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Fatima Jabbar",
    "certificate_id": 450115,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hussain Ali",
    "certificate_id": 450116,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Irfan Ali",
    "certificate_id": 450117,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Jahanzeb",
    "certificate_id": 450118,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Khan Muhammad",
    "certificate_id": 450119,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Komal Tufail",
    "certificate_id": 450120,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Laiba",
    "certificate_id": 450121,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "M. Raza Siddiqui Attari",
    "certificate_id": 450122,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Malaika Shahid",
    "certificate_id": 450123,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Mehak Sarwer",
    "certificate_id": 450124,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Ans",
    "certificate_id": 450125,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Hasnain",
    "certificate_id": 450126,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Hasnain",
    "certificate_id": 450127,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Hassan Raza",
    "certificate_id": 450128,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Huzaifa",
    "certificate_id": 450129,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Khubaib",
    "certificate_id": 450130,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Mubashir",
    "certificate_id": 450131,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Rauf Jamal",
    "certificate_id": 450132,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Taha",
    "certificate_id": 450133,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muneeba",
    "certificate_id": 450134,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Nayan Raza",
    "certificate_id": 450135,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Nehal Afzal",
    "certificate_id": 450136,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Piyar Ali",
    "certificate_id": 450137,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Rajesh Kumar",
    "certificate_id": 450138,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sabiha",
    "certificate_id": 450139,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sadia",
    "certificate_id": 450140,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Safina",
    "certificate_id": 450141,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Saifullah",
    "certificate_id": 450142,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Samina",
    "certificate_id": 450143,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sanaullah",
    "certificate_id": 450144,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sehar Saleem",
    "certificate_id": 450145,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shahzaib",
    "certificate_id": 450146,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shahzaib",
    "certificate_id": 450147,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shahzaib Ali",
    "certificate_id": 450148,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shehar Bano Sarwer",
    "certificate_id": 450149,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Syed Hassan Ahmed Zaidi",
    "certificate_id": 450150,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Syeda Kainat",
    "certificate_id": 450151,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Syeda Rukhsar",
    "certificate_id": 450152,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Tabasum",
    "certificate_id": 450153,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Tooba Mazhar",
    "certificate_id": 450154,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Umaima Khan",
    "certificate_id": 450155,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Umar Gul",
    "certificate_id": 450156,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zafar Ullah",
    "certificate_id": 450157,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zahir Ali",
    "certificate_id": 450158,
    "course": "Certified Graphic Designer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Abdul Saboor",
    "certificate_id": 450601,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Adil Hussain",
    "certificate_id": 450602,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ahmar Ali Memon",
    "certificate_id": 450603,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ahmed Mujtaba Alies Ghalib",
    "certificate_id": 450604,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ali Shams U Zaman",
    "certificate_id": 450605,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ali Zain",
    "certificate_id": 450606,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Amna",
    "certificate_id": 450607,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Anjali",
    "certificate_id": 450608,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Areeba",
    "certificate_id": 450609,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Bibi Sana",
    "certificate_id": 450610,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Christopher",
    "certificate_id": 450611,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Dildar Ali",
    "certificate_id": 450612,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Dost Ali",
    "certificate_id": 450613,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Fareeda Soomro",
    "certificate_id": 450614,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Fatima",
    "certificate_id": 450615,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ghulam Khalique",
    "certificate_id": 450616,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Heer",
    "certificate_id": 450617,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Huma",
    "certificate_id": 450618,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Isra Mazhar Jatoi",
    "certificate_id": 450619,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Javed Ali",
    "certificate_id": 450620,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Jaweria",
    "certificate_id": 450621,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Jennifer",
    "certificate_id": 450622,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Majid Hussain",
    "certificate_id": 450623,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Maria",
    "certificate_id": 450624,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Maryam",
    "certificate_id": 450625,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Shahbaz",
    "certificate_id": 450626,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Taha",
    "certificate_id": 450627,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Yasir",
    "certificate_id": 450628,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Murad Bux",
    "certificate_id": 450629,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Najeebullah",
    "certificate_id": 450630,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Rizwana",
    "certificate_id": 450631,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sana",
    "certificate_id": 450632,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sandhia",
    "certificate_id": 450633,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Saneha",
    "certificate_id": 450634,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Santosh Kumar",
    "certificate_id": 450635,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Saqib Dahri",
    "certificate_id": 450636,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shahzaib Jamali",
    "certificate_id": 450637,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shoaib Ahmed",
    "certificate_id": 450638,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sikandar Ali",
    "certificate_id": 450639,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Tanweer",
    "certificate_id": 450640,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Uzma",
    "certificate_id": 450641,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Veena",
    "certificate_id": 450642,
    "course": "Certified Web Developer",
    "center": "QUEST NAWABSHAH",
    "batch": 4
  },
  {
    "name": "Zahoor Mehdi",
    "certificate_id": 450643,
    "course": "Certified Web Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aamna Nasir",
    "certificate_id": 450401,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Abdullah",
    "certificate_id": 450402,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Adil Hussain",
    "certificate_id": 450403,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aisha",
    "certificate_id": 450404,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ali Asghar",
    "certificate_id": 450405,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Amjad Ali",
    "certificate_id": 450406,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aqib Hussain",
    "certificate_id": 450407,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Areeba",
    "certificate_id": 450408,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Farkhanda",
    "certificate_id": 450409,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ghulam Murtaza",
    "certificate_id": 450410,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ghulam Sarwar",
    "certificate_id": 450411,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Gul Zaman Ali",
    "certificate_id": 450412,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hira",
    "certificate_id": 450413,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hira Latif",
    "certificate_id": 450414,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ibrar Hussain",
    "certificate_id": 450415,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Iqra Ayaz",
    "certificate_id": 450416,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Irfan Ali",
    "certificate_id": 450417,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Kifayat Hussain",
    "certificate_id": 450418,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Kinza Nasir Mehmood",
    "certificate_id": 450419,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Maliha Memon",
    "certificate_id": 450420,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Mansoor Ali",
    "certificate_id": 450421,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Maryam Nawaz",
    "certificate_id": 450422,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Mehmood Khan",
    "certificate_id": 450423,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Ali Haider",
    "certificate_id": 450424,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Hunaid",
    "certificate_id": 450425,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Ilyas",
    "certificate_id": 450426,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Owais Raza",
    "certificate_id": 450427,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Rehan",
    "certificate_id": 450428,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Yasir",
    "certificate_id": 450429,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Mukhtiar Ali",
    "certificate_id": 450430,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muzamil",
    "certificate_id": 450431,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Qirat Malik",
    "certificate_id": 450432,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ramain",
    "certificate_id": 450433,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Saifullah",
    "certificate_id": 450434,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Salar Shaikh",
    "certificate_id": 450435,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Samreen",
    "certificate_id": 450436,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sardar Ali",
    "certificate_id": 450437,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sawera Shaikh",
    "certificate_id": 450438,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shahid Hussain",
    "certificate_id": 450439,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shumaila",
    "certificate_id": 450440,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Syeda Batool Fatima Taqri",
    "certificate_id": 450441,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Tanveer",
    "certificate_id": 450442,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ume Farwa",
    "certificate_id": 450443,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zafarullah Dahri",
    "certificate_id": 450444,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zahra Latif",
    "certificate_id": 450445,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zoya Fatima",
    "certificate_id": 450446,
    "course": "Certified Digital Marketing Professional",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Abdul Qadeer",
    "certificate_id": 450701,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "abdul wahid",
    "certificate_id": 450702,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Abu Usman",
    "certificate_id": 450703,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aisha Asad",
    "certificate_id": 450704,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aizaz Hyder",
    "certificate_id": 450705,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ajay Kumar",
    "certificate_id": 450706,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Alishba",
    "certificate_id": 450707,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Aqsa Gul",
    "certificate_id": 450708,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Asadullah",
    "certificate_id": 450709,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ashfaque Ali",
    "certificate_id": 450710,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Asif Ali",
    "certificate_id": 450711,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Davia Kumari",
    "certificate_id": 450712,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Faraz Gul",
    "certificate_id": 450713,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Fayaz Hussain",
    "certificate_id": 450714,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Ghamshad Ali",
    "certificate_id": 450715,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hadia Khalid",
    "certificate_id": 450716,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Haris Ali",
    "certificate_id": 450717,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hasnain Raza",
    "certificate_id": 450718,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Hira Solangi",
    "certificate_id": 450719,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Imran Ali",
    "certificate_id": 450720,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Kiran Kumari",
    "certificate_id": 450721,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Komal Fiza",
    "certificate_id": 450722,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Malaika Zulqarnain",
    "certificate_id": 450723,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Marvi Rukhsar",
    "certificate_id": 450724,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Mehtab Ali",
    "certificate_id": 450725,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Abdullah",
    "certificate_id": 450726,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Ashan Panhyar",
    "certificate_id": 450727,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muhammad Bux",
    "certificate_id": 450728,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Muntaha",
    "certificate_id": 450729,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Nadia Daud",
    "certificate_id": 450730,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Nazia",
    "certificate_id": 450731,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Neha Malik",
    "certificate_id": 450732,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Nida",
    "certificate_id": 450733,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Rashid Ali",
    "certificate_id": 450734,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Rimsha Khalid",
    "certificate_id": 450735,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sadam Hussain",
    "certificate_id": 450736,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sahil Rajput",
    "certificate_id": 450737,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sajjad Hussain",
    "certificate_id": 450738,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sana",
    "certificate_id": 450739,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shams Raza",
    "certificate_id": 450740,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Shehzadi",
    "certificate_id": 450741,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sidra Baloch",
    "certificate_id": 450742,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Sobia",
    "certificate_id": 450743,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Tooba",
    "certificate_id": 450744,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zafar Ali Panhyar",
    "certificate_id": 450745,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zubair Ali",
    "certificate_id": 450746,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Zulqarnain Haider",
    "certificate_id": 450747,
    "course": "Certified Python Developer",
    "center": "QUEST Nawabshah",
    "batch": 4
  },
  {
    "name": "Benazir Phulpoto",
    "certificate_id": 410310,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Farman Ali Bhanbhro",
    "certificate_id": 410618,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Majid Ali",
    "certificate_id": 410625,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nauman Solangi",
    "certificate_id": 410643,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Rizwan Shaikh",
    "certificate_id": 410634,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Faraz Hassan Jutt",
    "certificate_id": 410314,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Waqar Mughal",
    "certificate_id": 410637,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hareshta Wadhwani",
    "certificate_id": 410315,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Asif Bhatti",
    "certificate_id": 410629,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mohsin Raza Pathan",
    "certificate_id": 410322,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Waqar Ali Bhutto",
    "certificate_id": 410766,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Saqlain Hyder",
    "certificate_id": 410657,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muzafar Ali Balouch",
    "certificate_id": 410843,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Moueez Ahmed",
    "certificate_id": 410325,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Vishal Kumar",
    "certificate_id": 410351,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ekta Rani Keswani",
    "certificate_id": 410313,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Saleha Bukhari Syed",
    "certificate_id": 410339,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Salman Ahmed Chachar",
    "certificate_id": 410647,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Um E Samara Agha",
    "certificate_id": 410454,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Asadullah Bhutto",
    "certificate_id": 410812,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Samad Shaikh",
    "certificate_id": 410803,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Summera Soomro",
    "certificate_id": 410345,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Momina Shaikh",
    "certificate_id": 410324,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shehla Wahid Simair",
    "certificate_id": 410342,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ahad Hussain Bhatti",
    "certificate_id": 410108,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Safeer Hussain Abro",
    "certificate_id": 410337,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Saira Jumani",
    "certificate_id": 410338,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bibi Muskan Zehra",
    "certificate_id": 410311,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Viky Kumar",
    "certificate_id": 410859,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sawera Abro",
    "certificate_id": 410340,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bakhtawar Abro",
    "certificate_id": 410308,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bakhtawar Chachar",
    "certificate_id": 410309,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Muhammad Hussain",
    "certificate_id": 410346,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hasnain Ali Memon",
    "certificate_id": 410316,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sawera Rasool",
    "certificate_id": 410341,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aqsa Zameer",
    "certificate_id": 410307,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Tahira Ghunio",
    "certificate_id": 410260,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mir Ahmed Pathan",
    "certificate_id": 410827,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Eshwar Kumar",
    "certificate_id": 410817,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Asghar Bhatti",
    "certificate_id": 410305,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sofia Ali",
    "certificate_id": 410344,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Toufique Raza Burdi",
    "certificate_id": 410348,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahid Khan Pathan",
    "certificate_id": 410851,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abbas Ali Bhanbhro",
    "certificate_id": 410301,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rukhsar Rajput",
    "certificate_id": 410752,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syeda Iqra Rizvi",
    "certificate_id": 410347,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kalsoom Shah",
    "certificate_id": 410317,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Abdul Hakeem Chachar",
    "certificate_id": 410627,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aqsa Mahar",
    "certificate_id": 410610,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Kabir Hussain",
    "certificate_id": 410656,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Farhat Alias Laila",
    "certificate_id": 410617,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Furqan Qureshi",
    "certificate_id": 410631,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Taha Khan",
    "certificate_id": 410636,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Uzairullah Khan",
    "certificate_id": 410660,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Hamza Ansari",
    "certificate_id": 410835,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Arif Malik",
    "certificate_id": 410833,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Ali Soomro",
    "certificate_id": 410628,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Asra Memon",
    "certificate_id": 410613,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kashaf Noor",
    "certificate_id": 410824,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Akber Brohi",
    "certificate_id": 410806,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ubaidullah Malik",
    "certificate_id": 410857,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahzad Pathan",
    "certificate_id": 410852,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shazia Noor Malik",
    "certificate_id": 410652,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kirtan Shiv",
    "certificate_id": 410826,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Zeeshan Qureshi",
    "certificate_id": 410639,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Zain",
    "certificate_id": 410607,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Jawad Ahmed",
    "certificate_id": 410524,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sagar Hakro",
    "certificate_id": 410548,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Uzair Ahmed Noohani",
    "certificate_id": 410567,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Vishal Sudurshan",
    "certificate_id": 410568,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ayesha Khan Abbasi",
    "certificate_id": 410515,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Faizan Ali Malik",
    "certificate_id": 410521,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fatima Khoso",
    "certificate_id": 410722,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Areeba Badaruddin Memon",
    "certificate_id": 410513,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Samad Shaikh",
    "certificate_id": 410703,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Sohail Rajput",
    "certificate_id": 410537,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Zubair Rajput",
    "certificate_id": 410541,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Agha Hassan Ali Pathan",
    "certificate_id": 410506,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Amerta Kumari Kukreja",
    "certificate_id": 410509,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Siraj Khan",
    "certificate_id": 410536,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahzaib Ali Shah",
    "certificate_id": 410554,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Qudoos Channa",
    "certificate_id": 410502,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Inayatullah Sawand",
    "certificate_id": 410622,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nayab Solangi",
    "certificate_id": 410747,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Qadir Bux Alias Rizwan",
    "certificate_id": 410545,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Basit Memon",
    "certificate_id": 410701,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aashesh Kumar",
    "certificate_id": 410501,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rohit Kumar Marwari",
    "certificate_id": 410751,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dureshahwar Mirani",
    "certificate_id": 410720,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mustafa Hassan",
    "certificate_id": 410746,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shanza Aleem",
    "certificate_id": 410555,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ramsha Shaikh",
    "certificate_id": 410336,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Jawad Ahmed Shaikh",
    "certificate_id": 410526,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muqaddas Kamboh",
    "certificate_id": 410641,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muskan Kalwar",
    "certificate_id": 410745,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Faisal",
    "certificate_id": 410133,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Laiba Masood Siddique",
    "certificate_id": 410528,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rabeea Kashaf Shaikh",
    "certificate_id": 410334,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Baqir Balouch",
    "certificate_id": 410328,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muskan",
    "certificate_id": 410542,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Ali Chandio",
    "certificate_id": 410239,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sania Zehra Shaikh",
    "certificate_id": 410848,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ashique Ali Bijarani",
    "certificate_id": 410208,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ghulam Mujtaba Balouch",
    "certificate_id": 410818,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Khadeja Shaikh",
    "certificate_id": 410732,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Maria Daudpota",
    "certificate_id": 410320,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Unzeela Abbasi",
    "certificate_id": 410350,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shifa Shah",
    "certificate_id": 410653,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Rehman Mangi",
    "certificate_id": 410602,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Asif Shaikh",
    "certificate_id": 410132,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Qadeer Mirani",
    "certificate_id": 410103,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Shahzaib Soomro",
    "certificate_id": 410247,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sidra Gull Pathan",
    "certificate_id": 410654,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Baby Aqsa Soomro",
    "certificate_id": 410516,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Rashid Channa",
    "certificate_id": 410135,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mudassar Hussain Dayo",
    "certificate_id": 410130,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Khushbo Zehra Sandeelo",
    "certificate_id": 410230,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Samad",
    "certificate_id": 410160,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hizbullah Buriro",
    "certificate_id": 410727,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Samreen Baby",
    "certificate_id": 410550,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Iqra",
    "certificate_id": 410623,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Mujtaba Malik",
    "certificate_id": 410327,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bhawesh Kumar",
    "certificate_id": 410115,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Jawad Ali Solangi",
    "certificate_id": 410125,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Tahir Mughal",
    "certificate_id": 410248,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ahmed-e-Mujtaba",
    "certificate_id": 410161,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ghulam Mustafa",
    "certificate_id": 410724,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Vedika Duseja",
    "certificate_id": 410157,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hidayatullah Lashari",
    "certificate_id": 410225,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Tanveer Hussain Akhund",
    "certificate_id": 410154,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Faiza Rasheed Sanjrani",
    "certificate_id": 410116,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aisha Aslam Memon",
    "certificate_id": 410109,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Sumaiya Shah",
    "certificate_id": 410855,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Eram Naz Mangi",
    "certificate_id": 410616,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mudasir Abro",
    "certificate_id": 410129,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mohsin Ali Chachar",
    "certificate_id": 410237,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Laiba Tariq Bhatti",
    "certificate_id": 410232,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hamadullah Mangi",
    "certificate_id": 410819,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Sameer Shaikh",
    "certificate_id": 410503,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ritika Bangeja",
    "certificate_id": 410547,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Farhan Memon",
    "certificate_id": 410218,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sandhiya Kukreja",
    "certificate_id": 410144,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Hakeem Dayo",
    "certificate_id": 410101,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dua Abbasi",
    "certificate_id": 410517,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Tariq Ali Mirani",
    "certificate_id": 410155,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dua Noor Qureshi",
    "certificate_id": 410519,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Soojal Kumar",
    "certificate_id": 410854,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Basit Malik",
    "certificate_id": 410302,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Irfan Akhund",
    "certificate_id": 410134,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Shoaib Bhatti",
    "certificate_id": 410434,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mahmood Ahsan",
    "certificate_id": 410733,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kashif Ali Pitafi",
    "certificate_id": 410228,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kashif Ur Rehman",
    "certificate_id": 410229,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Atif Memon",
    "certificate_id": 410630,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mukhtiar Ali Kharos",
    "certificate_id": 410435,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hussain Mehdi Mirani",
    "certificate_id": 410121,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahbaz Akhtar Malik",
    "certificate_id": 410651,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dua Batool Samo",
    "certificate_id": 410312,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hurab Mangrio",
    "certificate_id": 410226,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sagar Kumar",
    "certificate_id": 410143,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Affan Ahmad Arain",
    "certificate_id": 410107,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Hashir Mirani",
    "certificate_id": 410242,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Aliyan",
    "certificate_id": 410131,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Maheen Shaikh",
    "certificate_id": 410319,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Raikha Bai Lakhani",
    "certificate_id": 410750,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aisha Mangi",
    "certificate_id": 410710,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Ali Chachar",
    "certificate_id": 410238,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Farman Ali Mahar",
    "certificate_id": 410219,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Misbah Fatima",
    "certificate_id": 410321,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Disha Lalwani",
    "certificate_id": 410213,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bisma Bhatti",
    "certificate_id": 410211,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mariyam Ali Khokhar",
    "certificate_id": 410234,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Mashood Qureshi",
    "certificate_id": 410243,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hamza Riaz Rajpur",
    "certificate_id": 410224,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Areesha Abbasi",
    "certificate_id": 410207,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Waqar Ahmed Bhutto",
    "certificate_id": 410765,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fayyaz Hussain Hakro",
    "certificate_id": 410418,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Zafar Ali Lakho",
    "certificate_id": 410262,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aleeza Aftab Abbasi",
    "certificate_id": 410407,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nasrullah Bhutto",
    "certificate_id": 410329,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mehak Bai",
    "certificate_id": 410530,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hijab E Zuhra Mangi",
    "certificate_id": 410621,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sarshti",
    "certificate_id": 410756,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Faisal Ahmed Abro",
    "certificate_id": 410216,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nasir Nawaz Pirzada",
    "certificate_id": 410250,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aswa Mahar",
    "certificate_id": 410209,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hasnain Rajput",
    "certificate_id": 410522,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahbaz Ali Katohar",
    "certificate_id": 410758,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Raheela Batool Samo",
    "certificate_id": 410335,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aqsa Abbasi",
    "certificate_id": 410411,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bisma Noor Arain",
    "certificate_id": 410212,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Areeba Arain",
    "certificate_id": 410512,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rizwan Ahmed Joyo",
    "certificate_id": 410255,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Abdul Rafay",
    "certificate_id": 410562,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Safiullah Indhar",
    "certificate_id": 410754,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syeda Asifa Batool Naqvi",
    "certificate_id": 410259,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Salman Baig",
    "certificate_id": 410245,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Haseeb Ghanghro",
    "certificate_id": 410241,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sania Mangi",
    "certificate_id": 410648,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Umar Mahar",
    "certificate_id": 410539,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muzammil Ahmed Soomro",
    "certificate_id": 410438,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mahnoor Memon",
    "certificate_id": 410734,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kashish Bai",
    "certificate_id": 410527,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Seerat Batool Mahar",
    "certificate_id": 410650,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hamza Awan",
    "certificate_id": 410223,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Alisha Qureshi",
    "certificate_id": 410409,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Agha Kinza Batool",
    "certificate_id": 410204,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Syed Jaffar Ali Shah",
    "certificate_id": 410153,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Laiba Muskan Shiekh",
    "certificate_id": 410231,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Hussain Pathan",
    "certificate_id": 410836,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Shahzaman",
    "certificate_id": 410535,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Asif Qazi",
    "certificate_id": 410240,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Daood Mirbahar",
    "certificate_id": 410739,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Hafeez Ghanghro",
    "certificate_id": 410201,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Gurmeet Kataria",
    "certificate_id": 410222,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rahul Badlan",
    "certificate_id": 410254,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Alishba Amir",
    "certificate_id": 410712,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Tayyab Durrani",
    "certificate_id": 410840,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Muzamil Arain",
    "certificate_id": 410244,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Lakhmeer Khan Wadhio",
    "certificate_id": 410263,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mehak Makhija",
    "certificate_id": 410735,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fatima Shaikh",
    "certificate_id": 410620,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nimerta Jagwani",
    "certificate_id": 410140,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dipeeka",
    "certificate_id": 410416,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ahmed Ali Maitlo",
    "certificate_id": 410406,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nehal Ali Mirani",
    "certificate_id": 410543,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Bilawal Ghumro",
    "certificate_id": 410431,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Rehman Bhangar",
    "certificate_id": 410402,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Suneel Kumar",
    "certificate_id": 410561,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fiza Mashori",
    "certificate_id": 410419,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahzadi Marium",
    "certificate_id": 410449,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ronaq Dayo",
    "certificate_id": 410142,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Anshrah Zainab Rajput",
    "certificate_id": 410714,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Yasir Soomro",
    "certificate_id": 410137,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Zakir Ali Ghorchani",
    "certificate_id": 410458,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Babar Ali Channa",
    "certificate_id": 410113,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Soha Fatima",
    "certificate_id": 410451,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Hamza Mirani",
    "certificate_id": 410605,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shiwani Rani",
    "certificate_id": 410760,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Kashan Junaid Shaikh",
    "certificate_id": 410534,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mohammad Arslan Naich",
    "certificate_id": 410236,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kaleemullah Shaikh",
    "certificate_id": 410731,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Adeel Gul Kalhoro",
    "certificate_id": 410504,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muqadas Abbasi",
    "certificate_id": 410138,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Meeral Khalil",
    "certificate_id": 410428,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Saleem Soomro",
    "certificate_id": 410136,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aqsa Ali Bhayo",
    "certificate_id": 410609,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Afia Arain",
    "certificate_id": 410404,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Safiullah Khoso",
    "certificate_id": 410755,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muskan Pathan",
    "certificate_id": 410842,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Faraz Ali Bhatti",
    "certificate_id": 410217,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Hasnain Kamanger",
    "certificate_id": 410606,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aiman Shaikh",
    "certificate_id": 410205,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hamza Ali Rajput",
    "certificate_id": 410420,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sana Ansari",
    "certificate_id": 410447,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Manisha Kaur",
    "certificate_id": 410529,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shahzeb Shujrah",
    "certificate_id": 410147,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muskan Mughal",
    "certificate_id": 410437,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sawera Shaikh",
    "certificate_id": 410448,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Talat Hussain Soomro",
    "certificate_id": 410564,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Salaruddin Chachar",
    "certificate_id": 410445,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Musab Shaikh",
    "certificate_id": 410841,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sadaqat Hussain Dahar",
    "certificate_id": 410443,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Lareb Soomro",
    "certificate_id": 410318,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nazia Shaikh",
    "certificate_id": 410331,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ammar Shahid Arain",
    "certificate_id": 410410,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Misbah Asad Soomro",
    "certificate_id": 410736,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fatima Qureshi",
    "certificate_id": 410220,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aliza Irhad Shaikh",
    "certificate_id": 410608,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hina Magsi",
    "certificate_id": 410422,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bilal Ahmed Samejo",
    "certificate_id": 410210,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mahnoor Jokhio",
    "certificate_id": 410624,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mehak Kumari",
    "certificate_id": 410531,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mubashir Hussain Rashidi",
    "certificate_id": 410430,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Musfera Siddiqui",
    "certificate_id": 410642,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Taiba Khan",
    "certificate_id": 410658,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Adil Pirzado",
    "certificate_id": 410831,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mehfooz Ahmed Panhyar",
    "certificate_id": 410127,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mussaver Ahmed Makhdoom",
    "certificate_id": 410249,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shifa Tahzeeb Shaikh",
    "certificate_id": 410343,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Benish Akhund",
    "certificate_id": 410114,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdullah Indhar",
    "certificate_id": 410804,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Preety Lalwani",
    "certificate_id": 410544,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Raheen Abbasi",
    "certificate_id": 410441,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Shahzad Khushk",
    "certificate_id": 410839,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Mahnoor Arain",
    "certificate_id": 410233,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dua Muskan Soomro",
    "certificate_id": 410518,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Naveed Ali Tunio",
    "certificate_id": 410330,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Yasir Nawaz",
    "certificate_id": 410353,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Shanza Jumani",
    "certificate_id": 410759,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rafique Ahmed Narejo",
    "certificate_id": 410846,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Amna Mangi",
    "certificate_id": 410510,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Simran Lala",
    "certificate_id": 410149,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Masham Fatima",
    "certificate_id": 410427,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Wafa-E-Zahra",
    "certificate_id": 410352,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Zainab Sajid",
    "certificate_id": 410860,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Alijan Ansari",
    "certificate_id": 410110,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Liaqat Ali Chachar",
    "certificate_id": 410426,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ekta Kumari Congreja",
    "certificate_id": 410214,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ayesha Arain",
    "certificate_id": 410413,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Misbha Bhatti",
    "certificate_id": 410429,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Huzaifa Ahmed Arain",
    "certificate_id": 410122,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Um E Atiya Mahar",
    "certificate_id": 410453,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Qadir Qureshi",
    "certificate_id": 410104,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Preeti Dewra",
    "certificate_id": 410440,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Anam Shahzad",
    "certificate_id": 410511,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nimarta Kumari",
    "certificate_id": 410845,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Kashish",
    "certificate_id": 410825,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Wahid Bux Memon",
    "certificate_id": 410456,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Hira Tabasum Soomro",
    "certificate_id": 410523,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Awais Memon",
    "certificate_id": 410432,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Jawad Hussain Shah",
    "certificate_id": 410126,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sahar Afshan",
    "certificate_id": 410549,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sarmad Hussain Phulpoto",
    "certificate_id": 410553,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sanjana Kumari",
    "certificate_id": 410649,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Iqra Ansari",
    "certificate_id": 410124,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rameeza Hashmi",
    "certificate_id": 410546,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Vandna Kumari",
    "certificate_id": 410261,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Afzal Wahab",
    "certificate_id": 410832,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Dur-E-Shahwar",
    "certificate_id": 410417,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Mateen Alias Rashid Rabbani",
    "certificate_id": 410202,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Momina Abdul Majid",
    "certificate_id": 410323,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Haseeb Ahmed Channa",
    "certificate_id": 410421,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Fiha Fatima Shaikh",
    "certificate_id": 410221,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Murk Kalhoro",
    "certificate_id": 410744,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Azalfa Shaikh",
    "certificate_id": 410414,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Saqib Indher",
    "certificate_id": 410246,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Preety Kumari Sachdave",
    "certificate_id": 410252,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Yousra Moriani",
    "certificate_id": 410354,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nabi Bux Umrani",
    "certificate_id": 410439,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Tehmeena",
    "certificate_id": 410452,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Unzah Ayaz Shaikh",
    "certificate_id": 410858,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Gaitry Ahuj",
    "certificate_id": 410119,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Nashra Riaz",
    "certificate_id": 410139,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sitara Naz Pathan",
    "certificate_id": 410150,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Suhail Ahmed Soomro",
    "certificate_id": 410152,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Usama Soomro",
    "certificate_id": 410156,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Uroosa Mahar",
    "certificate_id": 410455,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Subhana Sahar",
    "certificate_id": 410151,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Agha Zeeshan",
    "certificate_id": 410405,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sidra Saleem Mughal",
    "certificate_id": 410450,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Musawir Hussain Zangejo",
    "certificate_id": 410436,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Bilal Abbasi",
    "certificate_id": 410834,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Asma Soomro",
    "certificate_id": 410412,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Yousuf Khan",
    "certificate_id": 410638,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Rida Shaikh",
    "certificate_id": 410646,
    "course": "Certified Web Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Ali Usman Bhutto",
    "certificate_id": 410408,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Afza Malik",
    "certificate_id": 410505,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Zain Ul Abideen Laghari",
    "certificate_id": 410457,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bushra Shaikh",
    "certificate_id": 410816,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "AHSAN RAZA",
    "certificate_id": 420603,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALEEZA",
    "certificate_id": 420604,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI JAHANZEB",
    "certificate_id": 420605,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI JAN ABBASI",
    "certificate_id": 420606,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AMBER FATIMA",
    "certificate_id": 420607,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ANOSHA",
    "certificate_id": 420608,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ARADHNA",
    "certificate_id": 420609,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AZMAT HUSSAIN",
    "certificate_id": 420611,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "DANIYAL ALI",
    "certificate_id": 420612,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "DUA RAJPER",
    "certificate_id": 420613,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "FARAH NAZ",
    "certificate_id": 420615,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "GHULAM MUSTAFA",
    "certificate_id": 420616,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "HASNAIN FAROOQ",
    "certificate_id": 420617,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "IRFAN ALI",
    "certificate_id": 420641,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KASHIF ALI",
    "certificate_id": 420620,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KASHISH RANI",
    "certificate_id": 420621,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MISBAH FATIMA",
    "certificate_id": 420622,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUZAMIL AHMED",
    "certificate_id": 420626,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NADIR ALI",
    "certificate_id": 420627,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NOREEN GULL",
    "certificate_id": 420628,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "PRANJAL KUMARI",
    "certificate_id": 420629,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RAHEEL HUSSAIN",
    "certificate_id": 420630,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RAJAB ALI",
    "certificate_id": 420631,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RIDA FATIMA",
    "certificate_id": 420632,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SNEHA",
    "certificate_id": 420634,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SUHANA BAI",
    "certificate_id": 420637,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SYED WASI SHAH",
    "certificate_id": 420643,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUHAMMAD ASIM",
    "certificate_id": 420646,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RIZWAN ALI",
    "certificate_id": 420650,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "HUZAIFA RASHID",
    "certificate_id": 420651,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUHAMMAD YASEEN",
    "certificate_id": 420652,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "FABIHA KHAN",
    "certificate_id": 420654,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NABEEL GUL",
    "certificate_id": 420655,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SADAM HUSSAIN",
    "certificate_id": 420656,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "PRANJAL",
    "certificate_id": 420658,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MEHAK RANI",
    "certificate_id": 420659,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NASIR HUSSAIN",
    "certificate_id": 420660,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KAREENA",
    "certificate_id": 420661,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MASOOM ALI",
    "certificate_id": 420662,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AYAZ HUSSAIN",
    "certificate_id": 420663,
    "course": "Certified Web Developer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AAJIZ ALI",
    "certificate_id": 420101,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDUL QADEER",
    "certificate_id": 420102,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDUL WAHAB",
    "certificate_id": 420103,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AMJAD ALI",
    "certificate_id": 420105,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ASOUDAHMED",
    "certificate_id": 420106,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ATTA HUSSAIN",
    "certificate_id": 420107,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "BILAL NAWAZ",
    "certificate_id": 420108,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "DUAA PARVEEN",
    "certificate_id": 420109,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "GHULAM MUSTAFA",
    "certificate_id": 420113,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KHUSHI",
    "certificate_id": 420117,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "LAREB BATOOL",
    "certificate_id": 420118,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MEHAK KUMARI",
    "certificate_id": 420119,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MEHAK SAMTANI",
    "certificate_id": 420120,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MEHWISH",
    "certificate_id": 420122,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MEMONA",
    "certificate_id": 420123,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUDASIR ALI",
    "certificate_id": 420124,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUSKAN",
    "certificate_id": 420125,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RASHID ALI",
    "certificate_id": 420127,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "REHANA",
    "certificate_id": 420128,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SARFRAZ ALAM",
    "certificate_id": 420130,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SOHANA  KUMARI",
    "certificate_id": 420134,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "YASIR HUSSAIN",
    "certificate_id": 420139,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ZOHAIB BABAR",
    "certificate_id": 420140,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NAZIM ALI",
    "certificate_id": 420141,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KHALEEQUE AHMED",
    "certificate_id": 420142,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SAQIB ABBAS",
    "certificate_id": 420147,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "GHULAM RAZA",
    "certificate_id": 420149,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AHMED RAZA",
    "certificate_id": 420151,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUHAMMAD ISHAQUE",
    "certificate_id": 420153,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUSKAN ZEHRA",
    "certificate_id": 420155,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MR SAGAR",
    "certificate_id": 420157,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NADIA SAMI",
    "certificate_id": 420159,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "TOOBA",
    "certificate_id": 420163,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ZAHID HUSSAIN",
    "certificate_id": 420164,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI MOIZ",
    "certificate_id": 420165,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AHSAN HUSSAIN",
    "certificate_id": 420166,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "BHARTI",
    "certificate_id": 420167,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RABEL",
    "certificate_id": 420169,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI MURTAZA",
    "certificate_id": 420170,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SEENGAR ALI",
    "certificate_id": 420171,
    "course": "Certified Graphic Designer",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDUL FAHEEM",
    "certificate_id": 420401,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI JAN",
    "certificate_id": 420402,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALI JAAN",
    "certificate_id": 420403,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ALVEENA",
    "certificate_id": 420404,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AMAN ALI",
    "certificate_id": 420405,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AQSA",
    "certificate_id": 420406,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "EKTA",
    "certificate_id": 420410,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "FATIMA ZEHRA",
    "certificate_id": 420412,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "IMAM DINO",
    "certificate_id": 420414,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KINZA",
    "certificate_id": 420416,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "LAREB",
    "certificate_id": 420417,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MOAZZAM ALI",
    "certificate_id": 420418,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MOHSIN ALI",
    "certificate_id": 420420,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUNEEB UR REHMAN",
    "certificate_id": 420424,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUSAWAR AZEEM",
    "certificate_id": 420425,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUZAMIL HUSSAIN",
    "certificate_id": 420426,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "MUZAMIL HUSSAIN",
    "certificate_id": 420441,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "QADIR BUX",
    "certificate_id": 420427,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "RAZA AHMED",
    "certificate_id": 420429,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SADORO",
    "certificate_id": 420430,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SIRAJ AHMED",
    "certificate_id": 420442,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "YUSRA JANNAT",
    "certificate_id": 420439,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDUL AHAD",
    "certificate_id": 420443,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDUL MAJEED",
    "certificate_id": 420445,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ABDULLAH",
    "certificate_id": 420449,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AIJAZ UL HAQ",
    "certificate_id": 420450,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ARSLAN KHAN",
    "certificate_id": 420455,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "AZAD AHMED",
    "certificate_id": 420456,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "BHAWNA",
    "certificate_id": 420457,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "DUR-E-BATOOL",
    "certificate_id": 420458,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "IRFAN AHMED",
    "certificate_id": 420462,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "KASAK",
    "certificate_id": 420463,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SIDRA RANI",
    "certificate_id": 420473,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "SYED MUHAMMAD NAJAF RAZA",
    "certificate_id": 420475,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "TANSEER AHMED",
    "certificate_id": 420477,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "TOOBA SHAFIQUE",
    "certificate_id": 420478,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "ZAINAB",
    "certificate_id": 420479,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "NISBAT ZEHRA",
    "certificate_id": 420480,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "IQRA GUL",
    "certificate_id": 420481,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "Amal Shaikh",
    "certificate_id": 420482,
    "course": "Certified Digital Marketing Professional",
    "center": "IBA IET Khairpur Campus",
    "batch": 4
  },
  {
    "name": "Abbas Ali",
    "certificate_id": 430102,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Abdul basit",
    "certificate_id": 430104,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Agya",
    "certificate_id": 430106,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Arifullah",
    "certificate_id": 430109,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Asif ali",
    "certificate_id": 430110,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Dur Muhammad",
    "certificate_id": 430112,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Farheen",
    "certificate_id": 430114,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Farooq Ahmed",
    "certificate_id": 430116,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Faryal",
    "certificate_id": 430117,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Habib Rehman",
    "certificate_id": 430118,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Kashan Ali",
    "certificate_id": 430119,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Khushi rani",
    "certificate_id": 430120,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Mahek",
    "certificate_id": 430121,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Mohammad Asim",
    "certificate_id": 430123,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Rab Nawaz  Awan",
    "certificate_id": 430124,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Sharan Kumar",
    "certificate_id": 430127,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Shiwani kumari",
    "certificate_id": 430129,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Shuweta",
    "certificate_id": 430130,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Sineha Khetpal",
    "certificate_id": 430131,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Siraj Ali",
    "certificate_id": 430132,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Sughand Punjabi",
    "certificate_id": 430133,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Umair Ali",
    "certificate_id": 430135,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Varoon Kumar",
    "certificate_id": 430136,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Gul Muhammad",
    "certificate_id": 430405,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Iltaf Hussain",
    "certificate_id": 430406,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Jote Ali",
    "certificate_id": 430408,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Kamran Ali",
    "certificate_id": 430409,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Kibsha Bibi",
    "certificate_id": 430411,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Mohammad Awais",
    "certificate_id": 430412,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Mohsin Ali",
    "certificate_id": 430413,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Muhibullah",
    "certificate_id": 430416,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Pranchal Thorani",
    "certificate_id": 430418,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Saif U Rahman",
    "certificate_id": 430421,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Sakhawat hussain",
    "certificate_id": 430422,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Syed Roshan Ali shah",
    "certificate_id": 430424,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Waris Ali",
    "certificate_id": 430426,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Yashwant kumar",
    "certificate_id": 430427,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Zakir Ali",
    "certificate_id": 430428,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Zeeshan Ali",
    "certificate_id": 430429,
    "course": "Certified Digital Marketing Professional",
    "center": "Sukkur IBA Kandhkot Campus",
    "batch": 4
  },
  {
    "name": "Aafan Raza",
    "certificate_id": 440101,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Basit",
    "certificate_id": 440102,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Basit",
    "certificate_id": 440103,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul nabi",
    "certificate_id": 440104,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Salam",
    "certificate_id": 440105,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ahsan Ali",
    "certificate_id": 440106,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Aijaz Ali",
    "certificate_id": 440107,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "AllahBux Soomro",
    "certificate_id": 440108,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Asad Ali kandhro",
    "certificate_id": 440109,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hameedullah",
    "certificate_id": 440110,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hifza",
    "certificate_id": 440111,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Iqrar Ali",
    "certificate_id": 440112,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Irfan Ali",
    "certificate_id": 440113,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Kashaf Rehman",
    "certificate_id": 440114,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Kashif ali",
    "certificate_id": 440115,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Moazam Ali Soomro",
    "certificate_id": 440116,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Mohammad",
    "certificate_id": 440117,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Mohammad Asim Safeer",
    "certificate_id": 440118,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Mohammad Mudasir",
    "certificate_id": 440119,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Moiz u Rehman",
    "certificate_id": 440120,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhamma Sharif",
    "certificate_id": 440121,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Ahmed",
    "certificate_id": 440122,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Nasir",
    "certificate_id": 440123,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Raza",
    "certificate_id": 440124,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Younis",
    "certificate_id": 440125,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Musawer Raza",
    "certificate_id": 440126,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muskan Fiza",
    "certificate_id": 440127,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rehman Ali",
    "certificate_id": 440128,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Sahar mirani",
    "certificate_id": 440129,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Sajjad Ali",
    "certificate_id": 440130,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Sameer Hussain meerjat",
    "certificate_id": 440131,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Samiullah",
    "certificate_id": 440132,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Shah Muhammad",
    "certificate_id": 440133,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Shoaib Raza",
    "certificate_id": 440134,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Tahira memon",
    "certificate_id": 440135,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Tarique khan",
    "certificate_id": 440136,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Um E Laila",
    "certificate_id": 440137,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Waliya",
    "certificate_id": 440138,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Yasir Ali",
    "certificate_id": 440139,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Yusra",
    "certificate_id": 440140,
    "course": "Certified Graphic Designer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Qadeer",
    "certificate_id": 440401,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Qudoos",
    "certificate_id": 440402,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Saboor",
    "certificate_id": 440403,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Samad",
    "certificate_id": 440404,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ahmed Ali",
    "certificate_id": 440405,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Aitizaz hussain",
    "certificate_id": 440406,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Aizaz",
    "certificate_id": 440407,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Aqsa soomro",
    "certificate_id": 440408,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Arshan Ali",
    "certificate_id": 440409,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Baghali",
    "certificate_id": 440410,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Bilawal Ali",
    "certificate_id": 440411,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Faraz Ahmed",
    "certificate_id": 440412,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Farhan Ali",
    "certificate_id": 440413,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hassnain",
    "certificate_id": 440414,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ibrar ali",
    "certificate_id": 440415,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Israr Ali",
    "certificate_id": 440416,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Ali",
    "certificate_id": 440417,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Atif",
    "certificate_id": 440418,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Azeem",
    "certificate_id": 440419,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad paryal",
    "certificate_id": 440420,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad siddique",
    "certificate_id": 440421,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad zaki",
    "certificate_id": 440422,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Musawar Hussain",
    "certificate_id": 440423,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muzafar Ali",
    "certificate_id": 440424,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Narjis Pitafi",
    "certificate_id": 440425,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Quratulain",
    "certificate_id": 440426,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rani",
    "certificate_id": 440427,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rimsha Solangi",
    "certificate_id": 440428,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rizwan Ali",
    "certificate_id": 440429,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Shahjahan",
    "certificate_id": 440430,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Shoaib Ali",
    "certificate_id": 440431,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Usama",
    "certificate_id": 440432,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Uzair Ahmed",
    "certificate_id": 440433,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Uzair Ali",
    "certificate_id": 440434,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Waheed Ali",
    "certificate_id": 440435,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Waliya",
    "certificate_id": 440436,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Waqar Ali",
    "certificate_id": 440437,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Waseeullah",
    "certificate_id": 440438,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Yasir Ali",
    "certificate_id": 440439,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Yasmeen",
    "certificate_id": 440440,
    "course": "Certified Digital Marketing Professional",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Daneen Zehra",
    "certificate_id": 440601,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rukhsana",
    "certificate_id": 440602,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Iqra Shaikh",
    "certificate_id": 440603,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Pooja",
    "certificate_id": 440604,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Sheeraz Ali",
    "certificate_id": 440605,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Qadeer",
    "certificate_id": 440606,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Aitizaz Ahmed",
    "certificate_id": 440607,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Ramzan",
    "certificate_id": 440608,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Gul Sher Ali",
    "certificate_id": 440609,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Masab Ali",
    "certificate_id": 440610,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hizbullah Tunio",
    "certificate_id": 440611,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Moazam Ali",
    "certificate_id": 440612,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Sami",
    "certificate_id": 440613,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Mateen",
    "certificate_id": 440614,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Suhail",
    "certificate_id": 440615,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Haseebullah Butto",
    "certificate_id": 440616,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Adnan",
    "certificate_id": 440617,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Kashif Tunio",
    "certificate_id": 440618,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Taswar Hussain",
    "certificate_id": 440619,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Rehman Ali",
    "certificate_id": 440620,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Abdul Qadeer",
    "certificate_id": 440621,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Nader Hussain",
    "certificate_id": 440622,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Tahir Bhutto",
    "certificate_id": 440623,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Arsla jam",
    "certificate_id": 440624,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hasnain Ali",
    "certificate_id": 440625,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Adnan",
    "certificate_id": 440626,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Mubeen",
    "certificate_id": 440627,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ume farwah",
    "certificate_id": 440628,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Yasir Aijaz",
    "certificate_id": 440629,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "SHAFIQUE AHMED",
    "certificate_id": 440630,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ghulam Hyder",
    "certificate_id": 440631,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Hussain Raza",
    "certificate_id": 440632,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Mujahid Hussain",
    "certificate_id": 440633,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Ghulam Haider Samtio",
    "certificate_id": 440634,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Qasim",
    "certificate_id": 440635,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Muhammad Moiz Shaikh",
    "certificate_id": 440636,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Javeria",
    "certificate_id": 440637,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Samia",
    "certificate_id": 440638,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Neeraj",
    "certificate_id": 440639,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Sugar wahab",
    "certificate_id": 440640,
    "course": "Certified Web Developer",
    "center": "SZABIST University Larkana Campus",
    "batch": 4
  },
  {
    "name": "Soha Bhutto",
    "certificate_id": 210497,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Iqra Dayo",
    "certificate_id": 320765,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Saba Mahar",
    "certificate_id": 210718,
    "course": "Certified Java Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sanina Mughal",
    "certificate_id": 271488,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sodia Pirzada",
    "certificate_id": 210835,
    "course": "Certified Mobile App Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Muhammad Ramzan",
    "certificate_id": 271365,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Natasha Ramzan",
    "certificate_id": 271476,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Parveen Abro",
    "certificate_id": 320770,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Liaqat Chachar",
    "certificate_id": 320771,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Abdul Rehman Jumani",
    "certificate_id": 271477,
    "course": "Certified Graphic Designer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Sharjeel Ahmed",
    "certificate_id": 311252,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bibi Rahmeed Mahzeb",
    "certificate_id": 271478,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aisha Kalwar",
    "certificate_id": 271479,
    "course": "Certified Python Developer",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Bibi Rahmeed Mahzeb",
    "certificate_id": 311253,
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "batch": 4
  },
  {
    "name": "Aisha Kalwar",
    "certificate_id": 311254,
    "course": "Certified Data Scientist",
    "center": "Sukkur IBA University",
    "batch": 4
  }


]
